// @generated by protobuf-ts 2.11.1 with parameter long_type_string,generate_dependencies,output_legacy_commonjs
// @generated from protobuf file "sennotech/base/examination/examination.proto" (package "base.examination", syntax proto3)
// tslint:disable
import { Empty } from "../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp";
import { Int32Value } from "../../google/protobuf/wrappers";
import { BoolValue } from "../../google/protobuf/wrappers";
import { ListValue } from "../../google/protobuf/struct";
import { StringValue } from "../../google/protobuf/wrappers";
import { Int64Value } from "../../google/protobuf/wrappers";
/**
 * @generated from protobuf message base.examination.DeleteSymptomsRequest
 */
export interface DeleteSymptomsRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examiner_account_id = 1
     */
    examinerAccountId?: Int64Value;
    /**
     * @generated from protobuf field: repeated string symptoms = 2
     */
    symptoms: string[];
}
/**
 * @generated from protobuf message base.examination.ListSymptomsResponse
 */
export interface ListSymptomsResponse {
    /**
     * @generated from protobuf field: repeated string symptoms = 1
     */
    symptoms: string[];
    /**
     * @generated from protobuf field: int64 total_elements = 2
     */
    totalElements: string;
    /**
     * @generated from protobuf field: int32 total_pages = 3
     */
    totalPages: number;
    /**
     * @generated from protobuf field: bool is_first = 4
     */
    isFirst: boolean;
    /**
     * @generated from protobuf field: bool is_last = 5
     */
    isLast: boolean;
    /**
     * @generated from protobuf field: int32 page_elements = 6
     */
    pageElements: number;
    /**
     * @generated from protobuf field: int32 page_num = 7
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 page_size = 8
     */
    pageSize: number;
}
/**
 * @generated from protobuf message base.examination.PageListExamineeResponse
 */
export interface PageListExamineeResponse {
    /**
     * @generated from protobuf field: repeated base.examination.ExamineeResult examinees = 1
     */
    examinees: ExamineeResult[];
    /**
     * @generated from protobuf field: int64 total_elements = 2
     */
    totalElements: string;
    /**
     * @generated from protobuf field: int32 total_pages = 3
     */
    totalPages: number;
    /**
     * @generated from protobuf field: bool is_first = 4
     */
    isFirst: boolean;
    /**
     * @generated from protobuf field: bool is_last = 5
     */
    isLast: boolean;
    /**
     * @generated from protobuf field: int32 page_elements = 6
     */
    pageElements: number;
    /**
     * @generated from protobuf field: int32 page_num = 7
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 page_size = 8
     */
    pageSize: number;
}
/**
 * @generated from protobuf message base.examination.ListSymptomsRequest
 */
export interface ListSymptomsRequest {
    /**
     * @generated from protobuf field: int32 page_num = 1
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examiner_account_id = 3
     */
    examinerAccountId?: Int64Value;
}
/**
 * @generated from protobuf message base.examination.PageListExamineeRequest
 */
export interface PageListExamineeRequest {
    /**
     * @generated from protobuf field: int32 page_num = 1
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examiner_account_id = 5
     */
    examinerAccountId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue examinee_name = 6
     */
    examineeName?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 7
     */
    client?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue phone = 8
     */
    phone?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value start_timestamp = 9
     */
    startTimestamp?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value end_timestamp = 10
     */
    endTimestamp?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue examinee_name_initial = 11
     */
    examineeNameInitial?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.ListValue clients = 12
     */
    clients?: ListValue;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organization_id = 13
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue registered = 14
     */
    registered?: BoolValue;
    /**
     * field_name1 asc/desc,field_name2 asc/desc也可以省略asc，如：field_name1,field_name2 desc
     * field_name options: id, name, name_initial, create_time
     *
     * @generated from protobuf field: google.protobuf.StringValue order_by = 15
     */
    orderBy?: StringValue;
}
/**
 * @generated from protobuf message base.examination.GetExaminerByAccountIdResponse
 */
export interface GetExaminerByAccountIdResponse {
    /**
     * @generated from protobuf field: base.examination.ExaminerResult examinerResult = 1
     */
    examinerResult?: ExaminerResult;
}
/**
 * @generated from protobuf message base.examination.ListExamineeResponse
 */
export interface ListExamineeResponse {
    /**
     * @generated from protobuf field: repeated base.examination.ExamineeResult examineeResult = 1
     */
    examineeResult: ExamineeResult[];
}
/**
 * @generated from protobuf message base.examination.ListExamineeRequest
 */
export interface ListExamineeRequest {
    /**
     * @generated from protobuf field: repeated string name = 1
     */
    name: string[];
    /**
     * @generated from protobuf field: repeated string client = 2
     */
    client: string[];
    /**
     * @generated from protobuf field: repeated string phone = 3
     */
    phone: string[];
    /**
     * @generated from protobuf field: repeated int64 creatorAccountId = 4
     */
    creatorAccountId: string[];
    /**
     * @generated from protobuf field: repeated int64 ids = 5
     */
    ids: string[];
}
/**
 * @generated from protobuf message base.examination.CountExamineeByExaminersRequest
 */
export interface CountExamineeByExaminersRequest {
    /**
     * @generated from protobuf field: int64 organization_id = 1
     */
    organizationId: string;
    /**
     * @generated from protobuf field: repeated int64 examiner_ids = 2
     */
    examinerIds: string[];
}
/**
 * @generated from protobuf message base.examination.CountExamineeByExaminersResponse
 */
export interface CountExamineeByExaminersResponse {
    /**
     * @generated from protobuf field: repeated base.examination.CountExamineeByExaminersResponse.Result results = 1
     */
    results: CountExamineeByExaminersResponse_Result[];
}
/**
 * @generated from protobuf message base.examination.CountExamineeByExaminersResponse.Result
 */
export interface CountExamineeByExaminersResponse_Result {
    /**
     * @generated from protobuf field: int64 examiner_id = 1
     */
    examinerId: string;
    /**
     * @generated from protobuf field: int32 count = 2
     */
    count: number;
}
/**
 * @generated from protobuf message base.examination.ListExamineeListByExamineeAccountIdsResponse
 */
export interface ListExamineeListByExamineeAccountIdsResponse {
    /**
     * @generated from protobuf field: repeated base.examination.ExamineeResult examineeResult = 1
     */
    examineeResult: ExamineeResult[];
}
/**
 * @generated from protobuf message base.examination.ListExamineeListByExamineeAccountIdsRequest
 */
export interface ListExamineeListByExamineeAccountIdsRequest {
    /**
     * @generated from protobuf field: repeated int64 examineeAccountIds = 1
     */
    examineeAccountIds: string[];
    /**
     * @generated from protobuf field: repeated string client = 2
     */
    client: string[];
}
/**
 * @generated from protobuf message base.examination.ListExaminationReportByOrganizationIdAndTypeResponse
 */
export interface ListExaminationReportByOrganizationIdAndTypeResponse {
    /**
     * @generated from protobuf field: repeated base.examination.ExaminationReportResult examinationReportResults = 1
     */
    examinationReportResults: ExaminationReportResult[];
}
/**
 * @generated from protobuf message base.examination.ListExaminationReportByOrganizationIdAndTypeRequest
 */
export interface ListExaminationReportByOrganizationIdAndTypeRequest {
    /**
     * @generated from protobuf field: repeated int64 organizationIds = 1
     */
    organizationIds: string[];
    /**
     * @generated from protobuf field: base.examination.ExaminationReportType examinationReportType = 2
     */
    examinationReportType: ExaminationReportType;
}
/**
 * @generated from protobuf message base.examination.GetExaminationReportPageByAccessTokenAndTypeResponse
 */
export interface GetExaminationReportPageByAccessTokenAndTypeResponse {
    /**
     * @generated from protobuf field: repeated base.examination.ExaminationReportResult examinationReportResults = 1
     */
    examinationReportResults: ExaminationReportResult[];
    /**
     * @generated from protobuf field: int64 totalElements = 2
     */
    totalElements: string;
    /**
     * @generated from protobuf field: int32 totalPages = 3
     */
    totalPages: number;
    /**
     * @generated from protobuf field: bool isFirst = 4
     */
    isFirst: boolean;
    /**
     * @generated from protobuf field: bool isLast = 5
     */
    isLast: boolean;
    /**
     * @generated from protobuf field: int32 number = 6
     */
    number: number;
    /**
     * @generated from protobuf field: int32 numberOfElements = 7
     */
    numberOfElements: number;
    /**
     * @generated from protobuf field: int32 size = 8
     */
    size: number;
}
/**
 * @generated from protobuf message base.examination.GetExaminationReportPageByAccessTokenAndTypeRequest
 */
export interface GetExaminationReportPageByAccessTokenAndTypeRequest {
    /**
     * @generated from protobuf field: base.examination.ExaminationReportType examinationReportType = 2
     */
    examinationReportType: ExaminationReportType;
    /**
     * @generated from protobuf field: repeated string clientList = 3
     */
    clientList: string[];
    /**
     * @generated from protobuf field: int32 pageNum = 4
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 pageSize = 5
     */
    pageSize: number;
}
/**
 * @generated from protobuf message base.examination.GetExamineeListByIdsRequest
 */
export interface GetExamineeListByIdsRequest {
    /**
     * @generated from protobuf field: repeated int64 examineeId = 1
     */
    examineeId: string[];
}
/**
 * @generated from protobuf message base.examination.GetExamineeListByIdsResponse
 */
export interface GetExamineeListByIdsResponse {
    /**
     * @generated from protobuf field: repeated base.examination.ExamineeResult examineeResult = 1
     */
    examineeResult: ExamineeResult[];
}
/**
 * @generated from protobuf message base.examination.DeleteExaminationRelationshipByAccountIdRequest
 */
export interface DeleteExaminationRelationshipByAccountIdRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examineeId = 1
     */
    examineeId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountId = 2
     */
    accountId?: Int64Value;
}
/**
 * @generated from protobuf message base.examination.DeleteExaminationRelationshipByAccountIdResponse
 */
export interface DeleteExaminationRelationshipByAccountIdResponse {
    /**
     * @generated from protobuf field: bool isDeleted = 1
     */
    isDeleted: boolean;
}
/**
 * @generated from protobuf message base.examination.BatchDeleteExaminationRelationshipByOrganizationRequest
 */
export interface BatchDeleteExaminationRelationshipByOrganizationRequest {
    /**
     * @generated from protobuf field: int64 organization_id = 1
     */
    organizationId: string;
    /**
     * @generated from protobuf field: repeated int64 examinee_ids = 2
     */
    examineeIds: string[];
}
/**
 * @generated from protobuf message base.examination.BatchDeleteExaminationRelationshipByOrganizationResponse
 */
export interface BatchDeleteExaminationRelationshipByOrganizationResponse {
    /**
     * @generated from protobuf field: repeated int64 examinee_ids = 1
     */
    examineeIds: string[];
}
/**
 * @generated from protobuf message base.examination.BatchDeleteExaminationRelationshipByExaminerAccountIdRequest
 */
export interface BatchDeleteExaminationRelationshipByExaminerAccountIdRequest {
    /**
     * @generated from protobuf field: int64 examiner_account_id = 1
     */
    examinerAccountId: string;
    /**
     * @generated from protobuf field: repeated int64 examinee_ids = 2
     */
    examineeIds: string[];
}
/**
 * @generated from protobuf message base.examination.BatchDeleteExaminationRelationshipByExaminerAccountIdResponse
 */
export interface BatchDeleteExaminationRelationshipByExaminerAccountIdResponse {
    /**
     * @generated from protobuf field: repeated int64 examinee_ids = 1
     */
    examineeIds: string[];
}
/**
 * @generated from protobuf message base.examination.GetExaminationReportByExamineeReportDetailIdRequest
 */
export interface GetExaminationReportByExamineeReportDetailIdRequest {
    /**
     * @generated from protobuf field: string examineeReportDetailId = 1
     */
    examineeReportDetailId: string;
}
/**
 * @generated from protobuf message base.examination.GetExaminationReportByExamineeReportDetailIdResponse
 */
export interface GetExaminationReportByExamineeReportDetailIdResponse {
    /**
     * @generated from protobuf field: base.examination.ExaminationReportResult examinationReportResult = 1
     */
    examinationReportResult?: ExaminationReportResult;
}
/**
 * @generated from protobuf message base.examination.BatchGetExaminationReportsByDetailIdRequest
 */
export interface BatchGetExaminationReportsByDetailIdRequest {
    /**
     * @generated from protobuf field: repeated string detail_ids = 1
     */
    detailIds: string[];
}
/**
 * @generated from protobuf message base.examination.BatchGetExaminationReportsByDetailIdResponse
 */
export interface BatchGetExaminationReportsByDetailIdResponse {
    /**
     * @generated from protobuf field: repeated base.examination.ExaminationReportResult reports = 1
     */
    reports: ExaminationReportResult[];
}
/**
 * @generated from protobuf message base.examination.UpdateExaminationReportByExamineeReportDetailIdRequest
 */
export interface UpdateExaminationReportByExamineeReportDetailIdRequest {
    /**
     * @generated from protobuf field: base.examination.ExaminationReportInfo examinationReportInfo = 1
     */
    examinationReportInfo?: ExaminationReportInfo;
}
/**
 * @generated from protobuf message base.examination.UpdateExaminationReportByExamineeReportDetailIdResponse
 */
export interface UpdateExaminationReportByExamineeReportDetailIdResponse {
    /**
     * @generated from protobuf field: bool isUpdated = 1
     */
    isUpdated: boolean;
}
/**
 * @generated from protobuf message base.examination.GetExaminationReportPageByExamineeIdRequest
 */
export interface GetExaminationReportPageByExamineeIdRequest {
    /**
     * @generated from protobuf field: int64 examineeId = 1
     */
    examineeId: string;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue self_examine = 4
     */
    selfExamine?: BoolValue;
    /**
     * @generated from protobuf field: int32 pageNum = 2
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 pageSize = 3
     */
    pageSize: number;
}
/**
 * @generated from protobuf message base.examination.GetExaminationReportPageByExamineeIdResponse
 */
export interface GetExaminationReportPageByExamineeIdResponse {
    /**
     * @generated from protobuf field: repeated base.examination.ExaminationReportResult examinationReportResults = 1
     */
    examinationReportResults: ExaminationReportResult[];
    /**
     * @generated from protobuf field: int64 totalElements = 2
     */
    totalElements: string;
    /**
     * @generated from protobuf field: int32 totalPages = 3
     */
    totalPages: number;
    /**
     * @generated from protobuf field: bool isFirst = 4
     */
    isFirst: boolean;
    /**
     * @generated from protobuf field: bool isLast = 5
     */
    isLast: boolean;
    /**
     * @generated from protobuf field: int32 number = 6
     */
    number: number;
    /**
     * @generated from protobuf field: int32 numberOfElements = 7
     */
    numberOfElements: number;
    /**
     * @generated from protobuf field: int32 size = 8
     */
    size: number;
}
/**
 * @generated from protobuf message base.examination.GetExaminationReportPageByExamineeIdAndTypeRequest
 */
export interface GetExaminationReportPageByExamineeIdAndTypeRequest {
    /**
     * @generated from protobuf field: int64 examineeId = 1
     */
    examineeId: string;
    /**
     * @generated from protobuf field: base.examination.ExaminationReportType examinationReportType = 2
     */
    examinationReportType: ExaminationReportType;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue self_examine = 5
     */
    selfExamine?: BoolValue;
    /**
     * @generated from protobuf field: int32 pageNum = 3
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 pageSize = 4
     */
    pageSize: number;
}
/**
 * @generated from protobuf message base.examination.GetExaminationReportPageByExamineeIdAndTypeResponse
 */
export interface GetExaminationReportPageByExamineeIdAndTypeResponse {
    /**
     * @generated from protobuf field: repeated base.examination.ExaminationReportResult examinationReportResults = 1
     */
    examinationReportResults: ExaminationReportResult[];
    /**
     * @generated from protobuf field: int64 totalElements = 2
     */
    totalElements: string;
    /**
     * @generated from protobuf field: int32 totalPages = 3
     */
    totalPages: number;
    /**
     * @generated from protobuf field: bool isFirst = 4
     */
    isFirst: boolean;
    /**
     * @generated from protobuf field: bool isLast = 5
     */
    isLast: boolean;
    /**
     * @generated from protobuf field: int32 number = 6
     */
    number: number;
    /**
     * @generated from protobuf field: int32 numberOfElements = 7
     */
    numberOfElements: number;
    /**
     * @generated from protobuf field: int32 size = 8
     */
    size: number;
}
/**
 * @generated from protobuf message base.examination.GetExaminationReportPageByAccountIdRequest
 */
export interface GetExaminationReportPageByAccountIdRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountId = 1
     */
    accountId?: Int64Value;
    /**
     * @generated from protobuf field: repeated string clientList = 2
     */
    clientList: string[];
    /**
     * @generated from protobuf field: int32 pageNum = 3
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 pageSize = 4
     */
    pageSize: number;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue self_examine = 5
     */
    selfExamine?: BoolValue;
}
/**
 * @generated from protobuf message base.examination.GetExaminationReportPageByAccountIdResponse
 */
export interface GetExaminationReportPageByAccountIdResponse {
    /**
     * @generated from protobuf field: repeated base.examination.ExaminationReportResult examinationReportResults = 1
     */
    examinationReportResults: ExaminationReportResult[];
    /**
     * @generated from protobuf field: int64 totalElements = 2
     */
    totalElements: string;
    /**
     * @generated from protobuf field: int32 totalPages = 3
     */
    totalPages: number;
    /**
     * @generated from protobuf field: bool isFirst = 4
     */
    isFirst: boolean;
    /**
     * @generated from protobuf field: bool isLast = 5
     */
    isLast: boolean;
    /**
     * @generated from protobuf field: int32 number = 6
     */
    number: number;
    /**
     * @generated from protobuf field: int32 numberOfElements = 7
     */
    numberOfElements: number;
    /**
     * @generated from protobuf field: int32 size = 8
     */
    size: number;
}
/**
 * @generated from protobuf message base.examination.GetExaminationReportPageByAccountIdAndTypeRequest
 */
export interface GetExaminationReportPageByAccountIdAndTypeRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountId = 1
     */
    accountId?: Int64Value;
    /**
     * @generated from protobuf field: base.examination.ExaminationReportType examinationReportType = 2
     */
    examinationReportType: ExaminationReportType;
    /**
     * @generated from protobuf field: repeated string clientList = 3
     */
    clientList: string[];
    /**
     * @generated from protobuf field: int32 pageNum = 4
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 pageSize = 5
     */
    pageSize: number;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue self_examine = 6
     */
    selfExamine?: BoolValue;
}
/**
 * @generated from protobuf message base.examination.GetExaminationReportPageByAccountIdAndTypeResponse
 */
export interface GetExaminationReportPageByAccountIdAndTypeResponse {
    /**
     * @generated from protobuf field: repeated base.examination.ExaminationReportResult examinationReportResults = 1
     */
    examinationReportResults: ExaminationReportResult[];
    /**
     * @generated from protobuf field: int64 totalElements = 2
     */
    totalElements: string;
    /**
     * @generated from protobuf field: int32 totalPages = 3
     */
    totalPages: number;
    /**
     * @generated from protobuf field: bool isFirst = 4
     */
    isFirst: boolean;
    /**
     * @generated from protobuf field: bool isLast = 5
     */
    isLast: boolean;
    /**
     * @generated from protobuf field: int32 number = 6
     */
    number: number;
    /**
     * @generated from protobuf field: int32 numberOfElements = 7
     */
    numberOfElements: number;
    /**
     * @generated from protobuf field: int32 size = 8
     */
    size: number;
}
/**
 * @generated from protobuf message base.examination.UpdateExaminationRelationshipByIdRequest
 */
export interface UpdateExaminationRelationshipByIdRequest {
    /**
     * @generated from protobuf field: int64 examinationRelationshipId = 1
     */
    examinationRelationshipId: string;
    /**
     * @generated from protobuf field: bool examinable = 2
     */
    examinable: boolean;
}
/**
 * @generated from protobuf message base.examination.UpdateExaminationRelationshipByIdResponse
 */
export interface UpdateExaminationRelationshipByIdResponse {
    /**
     * @generated from protobuf field: bool done = 1
     */
    done: boolean;
}
/**
 * @generated from protobuf message base.examination.GetExaminationRelationshipByAccessTokenRequest
 */
export interface GetExaminationRelationshipByAccessTokenRequest {
}
/**
 * @generated from protobuf message base.examination.GetExaminationRelationshipByAccessTokenResponse
 */
export interface GetExaminationRelationshipByAccessTokenResponse {
    /**
     * @generated from protobuf field: repeated base.examination.ExaminationRelationshipResult examinationRelationship = 1
     */
    examinationRelationship: ExaminationRelationshipResult[];
}
/**
 * @generated from protobuf message base.examination.ExaminationRelationshipResult
 */
export interface ExaminationRelationshipResult {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value id = 1
     */
    id?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examinerAccountId = 2
     */
    examinerAccountId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 3
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: bool examinable = 4
     */
    examinable: boolean;
    /**
     * @generated from protobuf field: base.examination.ExamineeResult examinee = 5
     */
    examinee?: ExamineeResult;
}
/**
 * @generated from protobuf message base.examination.ListExaminersRequest
 */
export interface ListExaminersRequest {
    /**
     * @generated from protobuf oneof: examinee
     */
    examinee: {
        oneofKind: "examineeId";
        /**
         * @generated from protobuf field: int64 examinee_id = 2
         */
        examineeId: string;
    } | {
        oneofKind: "examineeAccountId";
        /**
         * @generated from protobuf field: int64 examinee_account_id = 3
         */
        examineeAccountId: string;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message base.examination.ListExaminersResponse
 */
export interface ListExaminersResponse {
    /**
     * @generated from protobuf field: repeated int64 examiner_account_ids = 1
     */
    examinerAccountIds: string[];
}
/**
 * @generated from protobuf message base.examination.ShareExamineeRequest
 */
export interface ShareExamineeRequest {
    /**
     * @generated from protobuf field: int64 examineeId = 1
     */
    examineeId: string;
    /**
     * @generated from protobuf field: bool examinable = 2
     */
    examinable: boolean;
}
/**
 * @generated from protobuf message base.examination.ShareExamineeResponse
 */
export interface ShareExamineeResponse {
    /**
     * @generated from protobuf field: bool done = 1
     */
    done: boolean;
}
/**
 * @generated from protobuf message base.examination.GetMyAllExaminersRequest
 */
export interface GetMyAllExaminersRequest {
}
/**
 * @generated from protobuf message base.examination.GetMyAllExaminersResponse
 */
export interface GetMyAllExaminersResponse {
    /**
     * @generated from protobuf field: repeated base.examination.ExaminerResult examinerResults = 1
     */
    examinerResults: ExaminerResult[];
}
/**
 * @generated from protobuf message base.examination.CreateExaminerRequest
 */
export interface CreateExaminerRequest {
    /**
     * @generated from protobuf field: base.examination.ExaminerInfo examinerInfo = 1
     */
    examinerInfo?: ExaminerInfo;
}
/**
 * @generated from protobuf message base.examination.CreateExaminerResponse
 */
export interface CreateExaminerResponse {
    /**
     * @generated from protobuf field: int64 examinerId = 1
     */
    examinerId: string;
}
/**
 * @generated from protobuf message base.examination.CreateExaminerByAccountIdRequest
 */
export interface CreateExaminerByAccountIdRequest {
    /**
     * @generated from protobuf field: base.examination.ExaminerInfo examinerInfo = 1
     */
    examinerInfo?: ExaminerInfo;
}
/**
 * @generated from protobuf message base.examination.GetExaminerByAccountIdRequest
 */
export interface GetExaminerByAccountIdRequest {
    /**
     * @generated from protobuf field: int64 examinerId = 1
     */
    examinerId: string;
}
/**
 * @generated from protobuf message base.examination.CreateExaminerByAccountIdResponse
 */
export interface CreateExaminerByAccountIdResponse {
    /**
     * @generated from protobuf field: int64 examinerId = 1
     */
    examinerId: string;
}
/**
 * @generated from protobuf message base.examination.AddExamineeToExaminationRelationshipRequest
 */
export interface AddExamineeToExaminationRelationshipRequest {
    /**
     * @generated from protobuf field: int64 examineeId = 1
     */
    examineeId: string;
}
/**
 * @generated from protobuf message base.examination.AddExamineeToExaminationRelationshipResponse
 */
export interface AddExamineeToExaminationRelationshipResponse {
    /**
     * @generated from protobuf field: bool isadded = 1
     */
    isadded: boolean;
}
/**
 * @generated from protobuf message base.examination.AddExamineeRequest
 */
export interface AddExamineeRequest {
    /**
     * @generated from protobuf field: google.protobuf.StringValue name = 1
     */
    name?: StringValue;
    /**
     * @generated from protobuf field: base.examination.Gender gender = 2
     */
    gender: Gender;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 3
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value birthTimeStamp = 5
     */
    birthTimeStamp?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value age = 6
     */
    age?: Int32Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue phone = 7
     */
    phone?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue heightScalar = 8
     */
    heightScalar?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue heightUnit = 9
     */
    heightUnit?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue weightScalar = 10
     */
    weightScalar?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue weightUnit = 11
     */
    weightUnit?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value userId = 12
     */
    userId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue userType = 13
     */
    userType?: StringValue;
    /**
     * @generated from protobuf field: bool examinable = 14
     */
    examinable: boolean;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 15
     */
    client?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue description = 16
     */
    description?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue inPerson = 17
     */
    inPerson?: BoolValue; // 是否是本人
    /**
     * @generated from protobuf field: google.protobuf.StringValue email = 18
     */
    email?: StringValue; // 邮箱
    /**
     * @generated from protobuf field: google.protobuf.StringValue idNumber = 19
     */
    idNumber?: StringValue; // 身份证号
    /**
     * @generated from protobuf field: google.protobuf.StringValue patient_id = 20
     */
    patientId?: StringValue;
    /**
     * @generated from protobuf field: repeated string symptoms = 21
     */
    symptoms: string[];
}
/**
 * @generated from protobuf message base.examination.AddExamineeByAccountIdRequest
 */
export interface AddExamineeByAccountIdRequest {
    /**
     * @generated from protobuf field: google.protobuf.StringValue name = 1
     */
    name?: StringValue;
    /**
     * @generated from protobuf field: base.examination.Gender gender = 2
     */
    gender: Gender;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 3
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value creatorAccountId = 4
     */
    creatorAccountId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value birthTimeStamp = 5
     */
    birthTimeStamp?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value age = 6
     */
    age?: Int32Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue phone = 7
     */
    phone?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue heightScalar = 8
     */
    heightScalar?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue heightUnit = 9
     */
    heightUnit?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue weightScalar = 10
     */
    weightScalar?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue weightUnit = 11
     */
    weightUnit?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountId = 12
     */
    accountId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 13
     */
    client?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue description = 14
     */
    description?: StringValue; // 描述信息/病征
    /**
     * @generated from protobuf field: google.protobuf.BoolValue inPerson = 15
     */
    inPerson?: BoolValue; // 是否是本人
    /**
     * @generated from protobuf field: google.protobuf.StringValue email = 16
     */
    email?: StringValue; // 邮箱
    /**
     * @generated from protobuf field: google.protobuf.StringValue idNumber = 17
     */
    idNumber?: StringValue; // 身份证号
    /**
     * @generated from protobuf field: google.protobuf.StringValue patient_id = 18
     */
    patientId?: StringValue;
    /**
     * @generated from protobuf field: repeated string symptoms = 21
     */
    symptoms: string[];
}
/**
 * @generated from protobuf message base.examination.AddExamineeResponse
 */
export interface AddExamineeResponse {
    /**
     * @generated from protobuf field: int64 examineeId = 1
     */
    examineeId: string;
    /**
     * @generated from protobuf field: base.examination.ExamineeResult examinee = 2
     */
    examinee?: ExamineeResult; // 保证没有更新的调用方不会出错
}
/**
 * @generated from protobuf message base.examination.AddExamineeByAccountIdResponse
 */
export interface AddExamineeByAccountIdResponse {
    /**
     * @generated from protobuf field: int64 examineeId = 1
     */
    examineeId: string;
}
/**
 * @generated from protobuf message base.examination.AddExamineeMyselfRequest
 */
export interface AddExamineeMyselfRequest {
    /**
     * @generated from protobuf field: google.protobuf.StringValue name = 1
     */
    name?: StringValue;
    /**
     * @generated from protobuf field: base.examination.Gender gender = 2
     */
    gender: Gender;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 3
     */
    organizationId?: Int64Value;
}
/**
 * @generated from protobuf message base.examination.AddExamineeMyselfResponse
 */
export interface AddExamineeMyselfResponse {
    /**
     * @generated from protobuf field: int64 examineeId = 1
     */
    examineeId: string;
}
/**
 * @generated from protobuf message base.examination.CreateExamineeRequest
 */
export interface CreateExamineeRequest {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: base.examination.Gender gender = 2
     */
    gender: Gender;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp birthdate = 3
     */
    birthdate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value height = 4
     */
    height?: Int32Value; // 单位：cm
    /**
     * @generated from protobuf field: google.protobuf.Int32Value weight = 5
     */
    weight?: Int32Value; // 单位：kg
    /**
     * @generated from protobuf field: google.protobuf.StringValue description = 6
     */
    description?: StringValue; // 描述信息/病症
    /**
     * @generated from protobuf field: repeated string symptoms = 7
     */
    symptoms: string[]; // 病症，和description差不多，后面加上的，作为更结构化的病症
    /**
     * @generated from protobuf field: google.protobuf.StringValue phone_number = 8
     */
    phoneNumber?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue email = 9
     */
    email?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue id_number = 10
     */
    idNumber?: StringValue; // 身份证号
    /**
     * @generated from protobuf field: google.protobuf.Int64Value creator_account_id = 11
     */
    creatorAccountId?: Int64Value; // 创建examinee的账号id，一般是examiner
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examinee_account_id = 12
     */
    examineeAccountId?: Int64Value; // examinee自己的账号id
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 13
     */
    client?: StringValue;
}
/**
 * @generated from protobuf message base.examination.CreateExamineeResponse
 */
export interface CreateExamineeResponse {
    /**
     * @generated from protobuf field: int64 examinee_id = 1
     */
    examineeId: string;
}
/**
 * @generated from protobuf message base.examination.BatchCreateExamineesRequest
 */
export interface BatchCreateExamineesRequest {
    /**
     * @generated from protobuf field: int64 organization_id = 1
     */
    organizationId: string;
    /**
     * @generated from protobuf field: int64 creator_account_id = 2
     */
    creatorAccountId: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 3
     */
    client?: StringValue;
    /**
     * @generated from protobuf field: repeated base.examination.BatchCreateExamineesRequest.Examinee examinees = 4
     */
    examinees: BatchCreateExamineesRequest_Examinee[];
    /**
     * @generated from protobuf field: repeated int64 relate_account_ids = 5
     */
    relateAccountIds: string[];
}
/**
 * @generated from protobuf message base.examination.BatchCreateExamineesRequest.Examinee
 */
export interface BatchCreateExamineesRequest_Examinee {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: base.examination.Gender gender = 2
     */
    gender: Gender;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp birth_date = 3
     */
    birthDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value height = 4
     */
    height?: Int32Value;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value weight = 5
     */
    weight?: Int32Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue phone_number = 6
     */
    phoneNumber?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue description = 7
     */
    description?: StringValue;
    /**
     * @generated from protobuf field: repeated string symptoms = 21
     */
    symptoms: string[];
}
/**
 * @generated from protobuf message base.examination.BatchCreateExamineesResponse
 */
export interface BatchCreateExamineesResponse {
    /**
     * @generated from protobuf field: repeated base.examination.BatchCreateExamineesResponse.Examinee examinees = 1
     */
    examinees: BatchCreateExamineesResponse_Examinee[];
}
/**
 * @generated from protobuf message base.examination.BatchCreateExamineesResponse.Examinee
 */
export interface BatchCreateExamineesResponse_Examinee {
    /**
     * @generated from protobuf field: int64 organization_id = 1
     */
    organizationId: string;
    /**
     * @generated from protobuf field: int64 creator_account_id = 2
     */
    creatorAccountId: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 3
     */
    client?: StringValue;
    /**
     * @generated from protobuf field: string name = 4
     */
    name: string;
    /**
     * @generated from protobuf field: base.examination.Gender gender = 5
     */
    gender: Gender;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp birth_date = 6
     */
    birthDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value age = 7
     */
    age?: Int32Value;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value height = 8
     */
    height?: Int32Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue height_unit = 9
     */
    heightUnit?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value weight = 10
     */
    weight?: Int32Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue weight_unit = 11
     */
    weightUnit?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue phone_number = 12
     */
    phoneNumber?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue description = 13
     */
    description?: StringValue;
}
/**
 * @generated from protobuf message base.examination.GetPresignedPutObjectUrlRequest
 */
export interface GetPresignedPutObjectUrlRequest {
    /**
     * @generated from protobuf field: string object_type = 1
     */
    objectType: string;
    /**
     * @generated from protobuf field: string key = 2
     */
    key: string;
}
/**
 * @generated from protobuf message base.examination.GetPresignedPutObjectUrlResponse
 */
export interface GetPresignedPutObjectUrlResponse {
    /**
     * @generated from protobuf field: string key = 1
     */
    key: string;
    /**
     * @generated from protobuf field: string url = 2
     */
    url: string;
}
/**
 * @generated from protobuf message base.examination.BatchCreateExamineesWithExcelRequest
 */
export interface BatchCreateExamineesWithExcelRequest {
    /**
     * @generated from protobuf field: int64 organization_id = 1
     */
    organizationId: string;
    /**
     * @generated from protobuf field: int64 creator_account_id = 2
     */
    creatorAccountId: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 3
     */
    client?: StringValue;
    /**
     * @generated from protobuf field: string filename = 4
     */
    filename: string;
    /**
     * @generated from protobuf field: repeated int64 relate_account_ids = 5
     */
    relateAccountIds: string[];
}
/**
 * @generated from protobuf message base.examination.BatchCreateExamineesWithExcelResponse
 */
export interface BatchCreateExamineesWithExcelResponse {
    /**
     * @generated from protobuf field: bool valid = 1
     */
    valid: boolean;
    /**
     * @generated from protobuf field: repeated string invalid_row_descriptions = 2
     */
    invalidRowDescriptions: string[];
}
/**
 * @generated from protobuf message base.examination.GetBatchCreateExamineesExcelTemplateResponse
 */
export interface GetBatchCreateExamineesExcelTemplateResponse {
    /**
     * @generated from protobuf field: string template_url = 1
     */
    templateUrl: string;
}
/**
 * @generated from protobuf message base.examination.BindExamineeToExaminerRequest
 */
export interface BindExamineeToExaminerRequest {
    /**
     * @generated from protobuf field: int64 examiner_account_id = 1
     */
    examinerAccountId: string;
    /**
     * @generated from protobuf oneof: examinee
     */
    examinee: {
        oneofKind: "examineeId";
        /**
         * @generated from protobuf field: int64 examinee_id = 2
         */
        examineeId: string;
    } | {
        oneofKind: "examineeAccountId";
        /**
         * @generated from protobuf field: int64 examinee_account_id = 3
         */
        examineeAccountId: string;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message base.examination.UnbindExamineeFromExaminerRequest
 */
export interface UnbindExamineeFromExaminerRequest {
    /**
     * @generated from protobuf field: int64 examiner_account_id = 1
     */
    examinerAccountId: string;
    /**
     * @generated from protobuf oneof: examinee
     */
    examinee: {
        oneofKind: "examineeId";
        /**
         * @generated from protobuf field: int64 examinee_id = 2
         */
        examineeId: string;
    } | {
        oneofKind: "examineeAccountId";
        /**
         * @generated from protobuf field: int64 examinee_account_id = 3
         */
        examineeAccountId: string;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message base.examination.ExportExamineesListRequest
 */
export interface ExportExamineesListRequest {
    /**
     * @generated from protobuf field: int32 page_num = 1
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string type = 3
     */
    type: string; // options: qrcode, barcode
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_time = 4
     */
    startTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_time = 5
     */
    endTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organization_id = 6
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examiner_account_id = 7
     */
    examinerAccountId?: Int64Value;
}
/**
 * @generated from protobuf message base.examination.ExportExamineesListResponse
 */
export interface ExportExamineesListResponse {
    /**
     * @generated from protobuf field: string file_extension = 1
     */
    fileExtension: string; // options: .doc, .docx
    /**
     * @generated from protobuf field: bytes data = 2
     */
    data: Uint8Array;
    /**
     * @generated from protobuf field: int64 total_elements = 5
     */
    totalElements: string;
    /**
     * @generated from protobuf field: int32 total_pages = 6
     */
    totalPages: number;
    /**
     * @generated from protobuf field: bool is_first = 7
     */
    isFirst: boolean;
    /**
     * @generated from protobuf field: bool is_last = 8
     */
    isLast: boolean;
    /**
     * @generated from protobuf field: int32 page_elements = 9
     */
    pageElements: number;
    /**
     * @generated from protobuf field: int32 page_num = 10
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 page_size = 11
     */
    pageSize: number;
}
/**
 * @generated from protobuf message base.examination.GetExamineeIdEncryptAlphabetResponse
 */
export interface GetExamineeIdEncryptAlphabetResponse {
    /**
     * @generated from protobuf field: string alphabet = 1
     */
    alphabet: string;
}
/**
 * @generated from protobuf message base.examination.DecodeExamineeIdCodeRequest
 */
export interface DecodeExamineeIdCodeRequest {
    /**
     * @generated from protobuf field: string code = 1
     */
    code: string;
}
/**
 * @generated from protobuf message base.examination.DecodeExamineeIdCodeResponse
 */
export interface DecodeExamineeIdCodeResponse {
    /**
     * @generated from protobuf field: int64 examinee_id = 1
     */
    examineeId: string;
}
/**
 * @generated from protobuf message base.examination.SetAccountIdForExamineeRequest
 */
export interface SetAccountIdForExamineeRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examineeId = 1
     */
    examineeId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue inPerson = 2
     */
    inPerson?: BoolValue; // 是否是本人
}
/**
 * @generated from protobuf message base.examination.SetAccountIdForExamineeResponse
 */
export interface SetAccountIdForExamineeResponse {
    /**
     * @generated from protobuf field: bool isUpdated = 1
     */
    isUpdated: boolean;
}
/**
 * @generated from protobuf message base.examination.SetExamineeAccountIdRequest
 */
export interface SetExamineeAccountIdRequest {
    /**
     * @generated from protobuf field: int64 examinee_id = 1
     */
    examineeId: string;
    /**
     * @generated from protobuf field: int64 account_id = 2
     */
    accountId: string;
}
/**
 * @generated from protobuf message base.examination.UpdateExamineeRequest
 */
export interface UpdateExamineeRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examineeId = 1
     */
    examineeId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue name = 2
     */
    name?: StringValue;
    /**
     * @generated from protobuf field: base.examination.Gender gender = 3
     */
    gender: Gender;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value birthTimeStamp = 5
     */
    birthTimeStamp?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value age = 6
     */
    age?: Int32Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue phone = 7
     */
    phone?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue heightScalar = 8
     */
    heightScalar?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue heightUnit = 9
     */
    heightUnit?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue weightScalar = 10
     */
    weightScalar?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue weightUnit = 11
     */
    weightUnit?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue description = 16
     */
    description?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue inPerson = 17
     */
    inPerson?: BoolValue; // 是否是本人
    /**
     * @generated from protobuf field: google.protobuf.StringValue email = 18
     */
    email?: StringValue; // 邮箱
    /**
     * @generated from protobuf field: google.protobuf.Int64Value creationTimestamp = 19
     */
    creationTimestamp?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue idNumber = 20
     */
    idNumber?: StringValue; // 身份证
    /**
     * @generated from protobuf field: google.protobuf.StringValue patient_id = 21
     */
    patientId?: StringValue;
    /**
     * @generated from protobuf field: repeated string symptoms = 31
     */
    symptoms: string[];
}
/**
 * @generated from protobuf message base.examination.UpdateExamineeResponse
 */
export interface UpdateExamineeResponse {
    /**
     * @generated from protobuf field: bool isUpdated = 1
     */
    isUpdated: boolean;
}
/**
 * @generated from protobuf message base.examination.DeleteExaminationRelationshipRequest
 */
export interface DeleteExaminationRelationshipRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examineeId = 1
     */
    examineeId?: Int64Value;
}
/**
 * @generated from protobuf message base.examination.DeleteExaminationRelationshipResponse
 */
export interface DeleteExaminationRelationshipResponse {
    /**
     * @generated from protobuf field: bool isDeleted = 1
     */
    isDeleted: boolean;
}
/**
 * @generated from protobuf message base.examination.GetExamineeByIdRequest
 */
export interface GetExamineeByIdRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examineeId = 1
     */
    examineeId?: Int64Value;
}
/**
 * @generated from protobuf message base.examination.GetExamineeByIdResponse
 */
export interface GetExamineeByIdResponse {
    /**
     * @generated from protobuf field: base.examination.ExamineeResult examineeResult = 1
     */
    examineeResult?: ExamineeResult;
}
/**
 * @generated from protobuf message base.examination.GetExamineeByAccountIdRequest
 */
export interface GetExamineeByAccountIdRequest {
    /**
     * @generated from protobuf field: int64 account_id = 1
     */
    accountId: string;
}
/**
 * @generated from protobuf message base.examination.GetExamineeByAccountIdResponse
 */
export interface GetExamineeByAccountIdResponse {
    /**
     * @generated from protobuf field: base.examination.ExamineeResult examinee = 1
     */
    examinee?: ExamineeResult;
}
/**
 * @generated from protobuf message base.examination.GetMyExamineeRequest
 */
export interface GetMyExamineeRequest {
    /**
     * @generated from protobuf field: int64 examinee_id = 1
     */
    examineeId: string;
}
/**
 * @generated from protobuf message base.examination.GetMyExamineeResponse
 */
export interface GetMyExamineeResponse {
    /**
     * @generated from protobuf field: base.examination.ExamineeResult examineeResult = 1
     */
    examineeResult?: ExamineeResult;
}
/**
 * @generated from protobuf message base.examination.GetMyExamineeListRequest
 */
export interface GetMyExamineeListRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 1
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: repeated string clientList = 2
     */
    clientList: string[];
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examiner_account_id = 3
     */
    examinerAccountId?: Int64Value;
}
/**
 * @generated from protobuf message base.examination.GetMyExamineeListResponse
 */
export interface GetMyExamineeListResponse {
    /**
     * @generated from protobuf field: int64 examinerAccountId = 1
     */
    examinerAccountId: string;
    /**
     * @generated from protobuf field: repeated base.examination.ExamineeResult ExamineeResults = 2
     */
    examineeResults: ExamineeResult[];
}
/**
 * @generated from protobuf message base.examination.GetExamineeListByOrganizationIdRequest
 */
export interface GetExamineeListByOrganizationIdRequest {
    /**
     * @generated from protobuf field: int32 page_num = 1
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: int64 organization_id = 3
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string client = 4
     */
    client: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue examinee_name = 5
     */
    examineeName?: StringValue;
    /**
     * @generated from protobuf field: repeated string clients = 6
     */
    clients: string[];
}
/**
 * @generated from protobuf message base.examination.GetExamineeListByOrganizationIdResponse
 */
export interface GetExamineeListByOrganizationIdResponse {
    /**
     * @generated from protobuf field: repeated base.examination.ExamineeResult examinees = 1
     */
    examinees: ExamineeResult[];
    /**
     * @generated from protobuf field: int64 total_elements = 2
     */
    totalElements: string;
    /**
     * @generated from protobuf field: int32 total_pages = 3
     */
    totalPages: number;
    /**
     * @generated from protobuf field: bool is_first = 4
     */
    isFirst: boolean;
    /**
     * @generated from protobuf field: bool is_last = 5
     */
    isLast: boolean;
    /**
     * @generated from protobuf field: int32 page_elements = 6
     */
    pageElements: number;
    /**
     * @generated from protobuf field: int32 page_num = 7
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 page_size = 8
     */
    pageSize: number;
}
/**
 * @generated from protobuf message base.examination.GetExamineesExaminationReportListRequest
 */
export interface GetExamineesExaminationReportListRequest {
    /**
     * @generated from protobuf field: repeated int64 examinees = 1
     */
    examinees: string[];
}
/**
 * @generated from protobuf message base.examination.GetExamineesExaminationReportListByReportTypeRequest
 */
export interface GetExamineesExaminationReportListByReportTypeRequest {
    /**
     * @generated from protobuf field: repeated int64 examinees = 1
     */
    examinees: string[];
    /**
     * @generated from protobuf field: base.examination.ExaminationReportType examinationReportType = 2
     */
    examinationReportType: ExaminationReportType;
}
/**
 * @generated from protobuf message base.examination.ExaminationReportMapValue
 */
export interface ExaminationReportMapValue {
    /**
     * @generated from protobuf field: repeated base.examination.ExaminationReportRelationshipDtoResult examinationReportRelationshipResults = 1
     */
    examinationReportRelationshipResults: ExaminationReportRelationshipDtoResult[];
}
/**
 * @generated from protobuf message base.examination.GetExamineesExaminationReportListResponse
 */
export interface GetExamineesExaminationReportListResponse {
    /**
     * @generated from protobuf field: map<int64, base.examination.ExaminationReportMapValue> examinationReportRelationshipMapResults = 1
     */
    examinationReportRelationshipMapResults: {
        [key: string]: ExaminationReportMapValue;
    };
}
/**
 * @generated from protobuf message base.examination.GetExamineesExaminationReportListByReportTypeResponse
 */
export interface GetExamineesExaminationReportListByReportTypeResponse {
    /**
     * @generated from protobuf field: map<int64, base.examination.ExaminationReportMapValue> examinationReportRelationshipMapResults = 1
     */
    examinationReportRelationshipMapResults: {
        [key: string]: ExaminationReportMapValue;
    };
}
/**
 * @generated from protobuf message base.examination.GetMyExaminationReportListRequest
 */
export interface GetMyExaminationReportListRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 1
     */
    organizationId?: Int64Value;
}
/**
 * @generated from protobuf message base.examination.GetMyExaminationReportListResponse
 */
export interface GetMyExaminationReportListResponse {
    /**
     * @generated from protobuf field: repeated base.examination.ExaminationReportRelationshipDtoResult examinationReportRelationshipResults = 1
     */
    examinationReportRelationshipResults: ExaminationReportRelationshipDtoResult[];
}
/**
 * @generated from protobuf message base.examination.ExaminationReportRelationshipResult
 */
export interface ExaminationReportRelationshipResult {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examinationReportRelationshipId = 4
     */
    examinationReportRelationshipId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountId = 1
     */
    accountId?: Int64Value;
    /**
     * @generated from protobuf field: base.examination.Relationship relationship = 2
     */
    relationship: Relationship;
    /**
     * @generated from protobuf field: base.examination.ExaminationReportResult examinationReportResults = 3
     */
    examinationReportResults?: ExaminationReportResult;
}
/**
 * @generated from protobuf message base.examination.ExaminationReportRelationshipDtoResult
 */
export interface ExaminationReportRelationshipDtoResult {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountId = 1
     */
    accountId?: Int64Value;
    /**
     * @generated from protobuf field: map<string, base.examination.RelationshipDetailResult> relationshipMap = 2
     */
    relationshipMap: {
        [key: string]: RelationshipDetailResult;
    };
    /**
     * @generated from protobuf field: base.examination.ExaminationReportResult examinationReportResults = 3
     */
    examinationReportResults?: ExaminationReportResult;
}
/**
 * @generated from protobuf message base.examination.RelationshipDetailResult
 */
export interface RelationshipDetailResult {
    /**
     * @generated from protobuf field: int64 examinationReportRelationshipId = 1
     */
    examinationReportRelationshipId: string;
}
/**
 * @generated from protobuf message base.examination.ExaminationReportResult
 */
export interface ExaminationReportResult {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examinationReportId = 6
     */
    examinationReportId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examinerAccountId = 1
     */
    examinerAccountId?: Int64Value;
    /**
     * @generated from protobuf field: base.examination.ExamineeResult examineeResult = 2
     */
    examineeResult?: ExamineeResult;
    /**
     * @generated from protobuf field: google.protobuf.StringValue examineeReportDetailType = 3
     */
    examineeReportDetailType?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue examineeReportDetailId = 4
     */
    examineeReportDetailId?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value creationTimestamp = 5
     */
    creationTimestamp?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue doctorAdvice = 7
     */
    doctorAdvice?: StringValue;
    /**
     * @generated from protobuf field: base.examination.ExaminerResult examinerResult = 8
     */
    examinerResult?: ExaminerResult;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 9
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value evaluator_account_id = 10
     */
    evaluatorAccountId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp evaluate_time = 11
     */
    evaluateTime?: Timestamp;
}
/**
 * @generated from protobuf message base.examination.ExamineeResult
 */
export interface ExamineeResult {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examineeId = 1
     */
    examineeId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue name = 2
     */
    name?: StringValue;
    /**
     * @generated from protobuf field: base.examination.Gender gender = 3
     */
    gender: Gender;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountId = 4
     */
    accountId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value creatorAccountId = 17
     */
    creatorAccountId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value birthTimeStamp = 5
     */
    birthTimeStamp?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value age = 6
     */
    age?: Int32Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue phone = 7
     */
    phone?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue heightScalar = 8
     */
    heightScalar?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue heightUnit = 9
     */
    heightUnit?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue weightScalar = 10
     */
    weightScalar?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue weightUnit = 11
     */
    weightUnit?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value creationTimestamp = 12
     */
    creationTimestamp?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value userId = 13
     */
    userId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue userType = 14
     */
    userType?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue description = 15
     */
    description?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue inPerson = 16
     */
    inPerson?: BoolValue; // 是否是本人
    /**
     * @generated from protobuf field: google.protobuf.StringValue email = 18
     */
    email?: StringValue; // 邮箱
    /**
     * @generated from protobuf field: google.protobuf.StringValue idNumber = 19
     */
    idNumber?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue nameInitial = 20
     */
    nameInitial?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue examinee_id_code = 21
     */
    examineeIdCode?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue patient_id = 22
     */
    patientId?: StringValue;
    /**
     * @generated from protobuf field: repeated string symptoms = 31
     */
    symptoms: string[];
}
/**
 * @generated from protobuf message base.examination.ExaminationReportInfo
 */
export interface ExaminationReportInfo {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value id = 1
     */
    id?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examineeId = 2
     */
    examineeId?: Int64Value;
    /**
     * @generated from protobuf field: base.examination.ExaminationReportType examineeReportDetailType = 3
     */
    examineeReportDetailType: ExaminationReportType;
    /**
     * @generated from protobuf field: google.protobuf.StringValue examineeReportDetailId = 4
     */
    examineeReportDetailId?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 5
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue doctorAdvice = 6
     */
    doctorAdvice?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examinerId = 7
     */
    examinerId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examinerAccountId = 8
     */
    examinerAccountId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examineeAccountId = 9
     */
    examineeAccountId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value creationTimestamp = 10
     */
    creationTimestamp?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value evaluator_account_id = 11
     */
    evaluatorAccountId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp evaluate_time = 12
     */
    evaluateTime?: Timestamp;
}
/**
 * @generated from protobuf message base.examination.ExaminerInfo
 */
export interface ExaminerInfo {
    /**
     * @generated from protobuf field: google.protobuf.StringValue name = 1
     */
    name?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue phone = 2
     */
    phone?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 3
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value id = 5
     */
    id?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value creatorAccountId = 4
     */
    creatorAccountId?: Int64Value;
}
/**
 * @generated from protobuf message base.examination.ExaminerResult
 */
export interface ExaminerResult {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value id = 5
     */
    id?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue name = 1
     */
    name?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue phone = 2
     */
    phone?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 3
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value creatorAccountId = 4
     */
    creatorAccountId?: Int64Value;
}
/**
 * @generated from protobuf message base.examination.CreateExaminationReportRequest
 */
export interface CreateExaminationReportRequest {
    /**
     * @generated from protobuf field: base.examination.ExaminationReportInfo examinationReportInfo = 1
     */
    examinationReportInfo?: ExaminationReportInfo;
}
/**
 * @generated from protobuf message base.examination.CreateExaminationReportResponse
 */
export interface CreateExaminationReportResponse {
    /**
     * @generated from protobuf field: int64 examinationReportId = 1
     */
    examinationReportId: string;
}
/**
 * @generated from protobuf message base.examination.UpdateExaminationReportRequest
 */
export interface UpdateExaminationReportRequest {
    /**
     * @generated from protobuf field: base.examination.ExaminationReportInfo examinationReportInfo = 1
     */
    examinationReportInfo?: ExaminationReportInfo;
}
/**
 * @generated from protobuf message base.examination.UpdateExaminationReportResponse
 */
export interface UpdateExaminationReportResponse {
    /**
     * @generated from protobuf field: bool isUpdated = 1
     */
    isUpdated: boolean;
}
/**
 * @generated from protobuf message base.examination.GetExaminationReportByIdRequest
 */
export interface GetExaminationReportByIdRequest {
    /**
     * @generated from protobuf field: int64 examinationReportId = 1
     */
    examinationReportId: string;
}
/**
 * @generated from protobuf message base.examination.GetExaminationReportByIdResponse
 */
export interface GetExaminationReportByIdResponse {
    /**
     * @generated from protobuf field: base.examination.ExaminationReportResult examinationReportResult = 1
     */
    examinationReportResult?: ExaminationReportResult;
}
/**
 * @generated from protobuf message base.examination.DeleteExaminationReportRelationshipRequest
 */
export interface DeleteExaminationReportRelationshipRequest {
    /**
     * @generated from protobuf field: int64 examinationReportId = 1
     */
    examinationReportId: string;
}
/**
 * @generated from protobuf message base.examination.DeleteExaminationReportRelationshipResponse
 */
export interface DeleteExaminationReportRelationshipResponse {
    /**
     * @generated from protobuf field: bool isDeleted = 1
     */
    isDeleted: boolean;
}
/**
 * @generated from protobuf message base.examination.DeleteAllExaminationReportRelationshipRequest
 */
export interface DeleteAllExaminationReportRelationshipRequest {
    /**
     * @generated from protobuf field: int64 examinationReportId = 1
     */
    examinationReportId: string;
}
/**
 * @generated from protobuf message base.examination.DeleteAllExaminationReportRelationshipResponse
 */
export interface DeleteAllExaminationReportRelationshipResponse {
    /**
     * @generated from protobuf field: bool isDeleted = 1
     */
    isDeleted: boolean;
}
/**
 * @generated from protobuf message base.examination.DeleteExaminationReportByDetailIdRequest
 */
export interface DeleteExaminationReportByDetailIdRequest {
    /**
     * @generated from protobuf field: string detail_id = 1
     */
    detailId: string;
}
/**
 * @generated from protobuf message base.examination.DeleteExaminationReportByDetailIdResponse
 */
export interface DeleteExaminationReportByDetailIdResponse {
    /**
     * @generated from protobuf field: bool success = 1
     */
    success: boolean;
}
/**
 * @generated from protobuf message base.examination.GetExamineeListByExaminerAccountIdRequest
 */
export interface GetExamineeListByExaminerAccountIdRequest {
    /**
     * @generated from protobuf field: int64 examinerAccountId = 1
     */
    examinerAccountId: string;
    /**
     * @generated from protobuf field: repeated string clientList = 2
     */
    clientList: string[];
}
/**
 * @generated from protobuf message base.examination.GetExamineeListByExaminerAccountIdResponse
 */
export interface GetExamineeListByExaminerAccountIdResponse {
    /**
     * @generated from protobuf field: repeated base.examination.ExamineeResult examineeResult = 1
     */
    examineeResult: ExamineeResult[];
}
/**
 * @generated from protobuf message base.examination.AddExaminationReportRequest
 */
export interface AddExaminationReportRequest {
    /**
     * @generated from protobuf field: int64 examinationReportId = 1
     */
    examinationReportId: string;
}
/**
 * @generated from protobuf message base.examination.AddExaminationReportResponse
 */
export interface AddExaminationReportResponse {
    /**
     * @generated from protobuf field: bool isSucceeded = 1
     */
    isSucceeded: boolean;
}
/**
 * @generated from protobuf message base.examination.ShareExaminationReportRequest
 */
export interface ShareExaminationReportRequest {
    /**
     * @generated from protobuf field: int64 examination_report_id = 1
     */
    examinationReportId: string;
    /**
     * @generated from protobuf field: int64 examiner_account_id = 2
     */
    examinerAccountId: string;
}
/**
 * @generated from protobuf message base.examination.CountExaminationReportByExaminersRequest
 */
export interface CountExaminationReportByExaminersRequest {
    /**
     * @generated from protobuf field: int64 organization_id = 1
     */
    organizationId: string;
    /**
     * @generated from protobuf field: repeated int64 examiner_ids = 2
     */
    examinerIds: string[];
    /**
     * @generated from protobuf field: repeated base.examination.ExaminationReportType types = 3
     */
    types: ExaminationReportType[]; // 为保持接口行为不变，当types为空时，查询所有类型的报告
}
/**
 * @generated from protobuf message base.examination.CountExaminationReportByExaminersResponse
 */
export interface CountExaminationReportByExaminersResponse {
    /**
     * @generated from protobuf field: repeated base.examination.CountExaminationReportByExaminersResponse.Result results = 1
     */
    results: CountExaminationReportByExaminersResponse_Result[];
}
/**
 * @generated from protobuf message base.examination.CountExaminationReportByExaminersResponse.Result
 */
export interface CountExaminationReportByExaminersResponse_Result {
    /**
     * @generated from protobuf field: int64 examiner_id = 1
     */
    examinerId: string;
    /**
     * @generated from protobuf field: int32 count = 2
     */
    count: number;
}
/**
 * @generated from protobuf message base.examination.CountExaminationReportByExamineesRequest
 */
export interface CountExaminationReportByExamineesRequest {
    /**
     * @generated from protobuf field: int64 organization_id = 1
     */
    organizationId: string;
    /**
     * @generated from protobuf field: repeated int64 examinee_ids = 2
     */
    examineeIds: string[];
    /**
     * @generated from protobuf field: repeated base.examination.ExaminationReportType types = 3
     */
    types: ExaminationReportType[]; // 为保持接口行为不变，当types为空时，查询所有类型的报告
}
/**
 * @generated from protobuf message base.examination.CountExaminationReportByExamineesResponse
 */
export interface CountExaminationReportByExamineesResponse {
    /**
     * @generated from protobuf field: repeated base.examination.CountExaminationReportByExamineesResponse.Result results = 1
     */
    results: CountExaminationReportByExamineesResponse_Result[];
}
/**
 * @generated from protobuf message base.examination.CountExaminationReportByExamineesResponse.Result
 */
export interface CountExaminationReportByExamineesResponse_Result {
    /**
     * @generated from protobuf field: int64 examinee_id = 1
     */
    examineeId: string;
    /**
     * @generated from protobuf field: int32 count = 2
     */
    count: number;
}
/**
 * @generated from protobuf message base.examination.ListExaminationReportsRequest
 */
export interface ListExaminationReportsRequest {
    /**
     * @generated from protobuf field: int32 page_num = 1
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organization_id = 4
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examinee_id = 5
     */
    examineeId?: Int64Value;
    /**
     * @generated from protobuf field: optional base.examination.ExaminationReportType report_type = 6
     */
    reportType?: ExaminationReportType;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value examiner_account_id = 7
     */
    examinerAccountId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_time = 8
     */
    startTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_time = 9
     */
    endTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue self_examine = 10
     */
    selfExamine?: BoolValue;
}
/**
 * @generated from protobuf message base.examination.ListExaminationReportsResponse
 */
export interface ListExaminationReportsResponse {
    /**
     * @generated from protobuf field: repeated base.examination.ExaminationReportResult reports = 1
     */
    reports: ExaminationReportResult[];
    /**
     * @generated from protobuf field: int64 total_elements = 2
     */
    totalElements: string;
    /**
     * @generated from protobuf field: int32 total_pages = 3
     */
    totalPages: number;
    /**
     * @generated from protobuf field: bool is_first = 4
     */
    isFirst: boolean;
    /**
     * @generated from protobuf field: bool is_last = 5
     */
    isLast: boolean;
    /**
     * @generated from protobuf field: int32 page_elements = 6
     */
    pageElements: number;
    /**
     * @generated from protobuf field: int32 page_num = 7
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 page_size = 8
     */
    pageSize: number;
}
/**
 * @generated from protobuf message base.examination.ListExaminationReportHeadersRequest
 */
export interface ListExaminationReportHeadersRequest {
    /**
     * @generated from protobuf field: int32 page_num = 1
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: google.protobuf.StringValue examine_type = 5
     */
    examineType?: StringValue;
}
/**
 * @generated from protobuf message base.examination.ListExaminationReportHeadersResponse
 */
export interface ListExaminationReportHeadersResponse {
    /**
     * @generated from protobuf field: repeated base.examination.ListExaminationReportHeadersResponse.ReportHeader report_headers = 1
     */
    reportHeaders: ListExaminationReportHeadersResponse_ReportHeader[];
    /**
     * @generated from protobuf field: int64 total_elements = 2
     */
    totalElements: string;
    /**
     * @generated from protobuf field: int32 total_pages = 3
     */
    totalPages: number;
    /**
     * @generated from protobuf field: bool is_first = 4
     */
    isFirst: boolean;
    /**
     * @generated from protobuf field: bool is_last = 5
     */
    isLast: boolean;
    /**
     * @generated from protobuf field: int32 page_elements = 6
     */
    pageElements: number;
    /**
     * @generated from protobuf field: int32 page_num = 7
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 page_size = 8
     */
    pageSize: number;
}
/**
 * @generated from protobuf message base.examination.ListExaminationReportHeadersResponse.ReportHeader
 */
export interface ListExaminationReportHeadersResponse_ReportHeader {
    /**
     * @generated from protobuf field: string uuid = 1
     */
    uuid: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp create_time = 2
     */
    createTime?: Timestamp;
    /**
     * @generated from protobuf field: string examine_type = 3
     */
    examineType: string;
    /**
     * @generated from protobuf field: base.examination.ListExaminationReportHeadersResponse.Examinee examinee = 4
     */
    examinee?: ListExaminationReportHeadersResponse_Examinee;
}
/**
 * @generated from protobuf message base.examination.ListExaminationReportHeadersResponse.Examinee
 */
export interface ListExaminationReportHeadersResponse_Examinee {
    /**
     * @generated from protobuf field: google.protobuf.StringValue name = 1
     */
    name?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue gender = 2
     */
    gender?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value age = 3
     */
    age?: Int32Value;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value height = 4
     */
    height?: Int32Value;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value weight = 5
     */
    weight?: Int32Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue description = 6
     */
    description?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue phone_number = 10
     */
    phoneNumber?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue id_number = 11
     */
    idNumber?: StringValue;
}
/**
 * @generated from protobuf enum base.examination.Gender
 */
export enum Gender {
    /**
     * @generated from protobuf enum value: GENDER_UNKNOWN = 0;
     */
    GENDER_UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: MALE = 1;
     */
    MALE = 1,
    /**
     * @generated from protobuf enum value: FEMALE = 2;
     */
    FEMALE = 2
}
/**
 * @generated from protobuf enum base.examination.Relationship
 */
export enum Relationship {
    /**
     * @generated from protobuf enum value: SHARED = 0;
     */
    SHARED = 0,
    /**
     * @generated from protobuf enum value: EXAMINER = 1;
     */
    EXAMINER = 1,
    /**
     * @generated from protobuf enum value: EXAMINEE = 2;
     */
    EXAMINEE = 2
}
/**
 * @generated from protobuf enum base.examination.ExaminationReportType
 */
export enum ExaminationReportType {
    /**
     * 步姿检测
     *
     * @generated from protobuf enum value: GAIT = 0;
     */
    GAIT = 0,
    /**
     * 静态体态检测
     *
     * @generated from protobuf enum value: POSTURE = 1;
     */
    POSTURE = 1,
    /**
     * 跑姿检测
     *
     * @generated from protobuf enum value: RUNNING = 2;
     */
    RUNNING = 2,
    /**
     * 压力检测
     *
     * @generated from protobuf enum value: PRESSURE = 3;
     */
    PRESSURE = 3,
    /**
     * 身份证测量脚长
     *
     * @generated from protobuf enum value: MEASUREMENT_IDCARD = 5;
     */
    MEASUREMENT_IDCARD = 5,
    /**
     * 足部扫描仪
     *
     * @generated from protobuf enum value: SCANNER = 6;
     */
    SCANNER = 6,
    /**
     * 问诊
     *
     * @generated from protobuf enum value: DIAGNOSIS = 7;
     */
    DIAGNOSIS = 7,
    /**
     * ATR检测
     *
     * @generated from protobuf enum value: ATR = 8;
     */
    ATR = 8,
    /**
     * 动态体态检测
     *
     * @generated from protobuf enum value: POSTURE_DYNAMIC = 9;
     */
    POSTURE_DYNAMIC = 9
}
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSymptomsRequest$Type extends MessageType<DeleteSymptomsRequest> {
    constructor() {
        super("base.examination.DeleteSymptomsRequest", [
            { no: 1, name: "examiner_account_id", kind: "message", T: () => Int64Value },
            { no: 2, name: "symptoms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteSymptomsRequest>): DeleteSymptomsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.symptoms = [];
        if (value !== undefined)
            reflectionMergePartial<DeleteSymptomsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteSymptomsRequest): DeleteSymptomsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value examiner_account_id */ 1:
                    message.examinerAccountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examinerAccountId);
                    break;
                case /* repeated string symptoms */ 2:
                    message.symptoms.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteSymptomsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value examiner_account_id = 1; */
        if (message.examinerAccountId)
            Int64Value.internalBinaryWrite(message.examinerAccountId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string symptoms = 2; */
        for (let i = 0; i < message.symptoms.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.symptoms[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.DeleteSymptomsRequest
 */
export const DeleteSymptomsRequest = new DeleteSymptomsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSymptomsResponse$Type extends MessageType<ListSymptomsResponse> {
    constructor() {
        super("base.examination.ListSymptomsResponse", [
            { no: 1, name: "symptoms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "total_elements", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "total_pages", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "is_first", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "is_last", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "page_elements", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "page_num", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ListSymptomsResponse>): ListSymptomsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.symptoms = [];
        message.totalElements = "0";
        message.totalPages = 0;
        message.isFirst = false;
        message.isLast = false;
        message.pageElements = 0;
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<ListSymptomsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListSymptomsResponse): ListSymptomsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string symptoms */ 1:
                    message.symptoms.push(reader.string());
                    break;
                case /* int64 total_elements */ 2:
                    message.totalElements = reader.int64().toString();
                    break;
                case /* int32 total_pages */ 3:
                    message.totalPages = reader.int32();
                    break;
                case /* bool is_first */ 4:
                    message.isFirst = reader.bool();
                    break;
                case /* bool is_last */ 5:
                    message.isLast = reader.bool();
                    break;
                case /* int32 page_elements */ 6:
                    message.pageElements = reader.int32();
                    break;
                case /* int32 page_num */ 7:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 page_size */ 8:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListSymptomsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string symptoms = 1; */
        for (let i = 0; i < message.symptoms.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.symptoms[i]);
        /* int64 total_elements = 2; */
        if (message.totalElements !== "0")
            writer.tag(2, WireType.Varint).int64(message.totalElements);
        /* int32 total_pages = 3; */
        if (message.totalPages !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalPages);
        /* bool is_first = 4; */
        if (message.isFirst !== false)
            writer.tag(4, WireType.Varint).bool(message.isFirst);
        /* bool is_last = 5; */
        if (message.isLast !== false)
            writer.tag(5, WireType.Varint).bool(message.isLast);
        /* int32 page_elements = 6; */
        if (message.pageElements !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageElements);
        /* int32 page_num = 7; */
        if (message.pageNum !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageNum);
        /* int32 page_size = 8; */
        if (message.pageSize !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ListSymptomsResponse
 */
export const ListSymptomsResponse = new ListSymptomsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PageListExamineeResponse$Type extends MessageType<PageListExamineeResponse> {
    constructor() {
        super("base.examination.PageListExamineeResponse", [
            { no: 1, name: "examinees", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExamineeResult },
            { no: 2, name: "total_elements", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "total_pages", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "is_first", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "is_last", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "page_elements", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "page_num", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<PageListExamineeResponse>): PageListExamineeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinees = [];
        message.totalElements = "0";
        message.totalPages = 0;
        message.isFirst = false;
        message.isLast = false;
        message.pageElements = 0;
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<PageListExamineeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PageListExamineeResponse): PageListExamineeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ExamineeResult examinees */ 1:
                    message.examinees.push(ExamineeResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 total_elements */ 2:
                    message.totalElements = reader.int64().toString();
                    break;
                case /* int32 total_pages */ 3:
                    message.totalPages = reader.int32();
                    break;
                case /* bool is_first */ 4:
                    message.isFirst = reader.bool();
                    break;
                case /* bool is_last */ 5:
                    message.isLast = reader.bool();
                    break;
                case /* int32 page_elements */ 6:
                    message.pageElements = reader.int32();
                    break;
                case /* int32 page_num */ 7:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 page_size */ 8:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PageListExamineeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ExamineeResult examinees = 1; */
        for (let i = 0; i < message.examinees.length; i++)
            ExamineeResult.internalBinaryWrite(message.examinees[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 total_elements = 2; */
        if (message.totalElements !== "0")
            writer.tag(2, WireType.Varint).int64(message.totalElements);
        /* int32 total_pages = 3; */
        if (message.totalPages !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalPages);
        /* bool is_first = 4; */
        if (message.isFirst !== false)
            writer.tag(4, WireType.Varint).bool(message.isFirst);
        /* bool is_last = 5; */
        if (message.isLast !== false)
            writer.tag(5, WireType.Varint).bool(message.isLast);
        /* int32 page_elements = 6; */
        if (message.pageElements !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageElements);
        /* int32 page_num = 7; */
        if (message.pageNum !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageNum);
        /* int32 page_size = 8; */
        if (message.pageSize !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.PageListExamineeResponse
 */
export const PageListExamineeResponse = new PageListExamineeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSymptomsRequest$Type extends MessageType<ListSymptomsRequest> {
    constructor() {
        super("base.examination.ListSymptomsRequest", [
            { no: 1, name: "page_num", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "examiner_account_id", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<ListSymptomsRequest>): ListSymptomsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<ListSymptomsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListSymptomsRequest): ListSymptomsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_num */ 1:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* google.protobuf.Int64Value examiner_account_id */ 3:
                    message.examinerAccountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examinerAccountId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListSymptomsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_num = 1; */
        if (message.pageNum !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageNum);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* google.protobuf.Int64Value examiner_account_id = 3; */
        if (message.examinerAccountId)
            Int64Value.internalBinaryWrite(message.examinerAccountId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ListSymptomsRequest
 */
export const ListSymptomsRequest = new ListSymptomsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PageListExamineeRequest$Type extends MessageType<PageListExamineeRequest> {
    constructor() {
        super("base.examination.PageListExamineeRequest", [
            { no: 1, name: "page_num", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "examiner_account_id", kind: "message", T: () => Int64Value },
            { no: 6, name: "examinee_name", kind: "message", T: () => StringValue },
            { no: 7, name: "client", kind: "message", T: () => StringValue },
            { no: 8, name: "phone", kind: "message", T: () => StringValue },
            { no: 9, name: "start_timestamp", kind: "message", T: () => Int64Value },
            { no: 10, name: "end_timestamp", kind: "message", T: () => Int64Value },
            { no: 11, name: "examinee_name_initial", kind: "message", T: () => StringValue },
            { no: 12, name: "clients", kind: "message", T: () => ListValue },
            { no: 13, name: "organization_id", kind: "message", T: () => Int64Value },
            { no: 14, name: "registered", kind: "message", T: () => BoolValue },
            { no: 15, name: "order_by", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<PageListExamineeRequest>): PageListExamineeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<PageListExamineeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PageListExamineeRequest): PageListExamineeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_num */ 1:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* google.protobuf.Int64Value examiner_account_id */ 5:
                    message.examinerAccountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examinerAccountId);
                    break;
                case /* google.protobuf.StringValue examinee_name */ 6:
                    message.examineeName = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.examineeName);
                    break;
                case /* google.protobuf.StringValue client */ 7:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                case /* google.protobuf.StringValue phone */ 8:
                    message.phone = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.phone);
                    break;
                case /* google.protobuf.Int64Value start_timestamp */ 9:
                    message.startTimestamp = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.startTimestamp);
                    break;
                case /* google.protobuf.Int64Value end_timestamp */ 10:
                    message.endTimestamp = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.endTimestamp);
                    break;
                case /* google.protobuf.StringValue examinee_name_initial */ 11:
                    message.examineeNameInitial = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.examineeNameInitial);
                    break;
                case /* google.protobuf.ListValue clients */ 12:
                    message.clients = ListValue.internalBinaryRead(reader, reader.uint32(), options, message.clients);
                    break;
                case /* google.protobuf.Int64Value organization_id */ 13:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.BoolValue registered */ 14:
                    message.registered = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.registered);
                    break;
                case /* google.protobuf.StringValue order_by */ 15:
                    message.orderBy = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.orderBy);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PageListExamineeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_num = 1; */
        if (message.pageNum !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageNum);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* google.protobuf.Int64Value examiner_account_id = 5; */
        if (message.examinerAccountId)
            Int64Value.internalBinaryWrite(message.examinerAccountId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue examinee_name = 6; */
        if (message.examineeName)
            StringValue.internalBinaryWrite(message.examineeName, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue client = 7; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue phone = 8; */
        if (message.phone)
            StringValue.internalBinaryWrite(message.phone, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value start_timestamp = 9; */
        if (message.startTimestamp)
            Int64Value.internalBinaryWrite(message.startTimestamp, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value end_timestamp = 10; */
        if (message.endTimestamp)
            Int64Value.internalBinaryWrite(message.endTimestamp, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue examinee_name_initial = 11; */
        if (message.examineeNameInitial)
            StringValue.internalBinaryWrite(message.examineeNameInitial, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.ListValue clients = 12; */
        if (message.clients)
            ListValue.internalBinaryWrite(message.clients, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value organization_id = 13; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.BoolValue registered = 14; */
        if (message.registered)
            BoolValue.internalBinaryWrite(message.registered, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue order_by = 15; */
        if (message.orderBy)
            StringValue.internalBinaryWrite(message.orderBy, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.PageListExamineeRequest
 */
export const PageListExamineeRequest = new PageListExamineeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExaminerByAccountIdResponse$Type extends MessageType<GetExaminerByAccountIdResponse> {
    constructor() {
        super("base.examination.GetExaminerByAccountIdResponse", [
            { no: 1, name: "examinerResult", kind: "message", T: () => ExaminerResult }
        ]);
    }
    create(value?: PartialMessage<GetExaminerByAccountIdResponse>): GetExaminerByAccountIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetExaminerByAccountIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExaminerByAccountIdResponse): GetExaminerByAccountIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.examination.ExaminerResult examinerResult */ 1:
                    message.examinerResult = ExaminerResult.internalBinaryRead(reader, reader.uint32(), options, message.examinerResult);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExaminerByAccountIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.examination.ExaminerResult examinerResult = 1; */
        if (message.examinerResult)
            ExaminerResult.internalBinaryWrite(message.examinerResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExaminerByAccountIdResponse
 */
export const GetExaminerByAccountIdResponse = new GetExaminerByAccountIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExamineeResponse$Type extends MessageType<ListExamineeResponse> {
    constructor() {
        super("base.examination.ListExamineeResponse", [
            { no: 1, name: "examineeResult", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExamineeResult }
        ]);
    }
    create(value?: PartialMessage<ListExamineeResponse>): ListExamineeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeResult = [];
        if (value !== undefined)
            reflectionMergePartial<ListExamineeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExamineeResponse): ListExamineeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ExamineeResult examineeResult */ 1:
                    message.examineeResult.push(ExamineeResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExamineeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ExamineeResult examineeResult = 1; */
        for (let i = 0; i < message.examineeResult.length; i++)
            ExamineeResult.internalBinaryWrite(message.examineeResult[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ListExamineeResponse
 */
export const ListExamineeResponse = new ListExamineeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExamineeRequest$Type extends MessageType<ListExamineeRequest> {
    constructor() {
        super("base.examination.ListExamineeRequest", [
            { no: 1, name: "name", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "client", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "phone", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "creatorAccountId", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ },
            { no: 5, name: "ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<ListExamineeRequest>): ListExamineeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = [];
        message.client = [];
        message.phone = [];
        message.creatorAccountId = [];
        message.ids = [];
        if (value !== undefined)
            reflectionMergePartial<ListExamineeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExamineeRequest): ListExamineeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string name */ 1:
                    message.name.push(reader.string());
                    break;
                case /* repeated string client */ 2:
                    message.client.push(reader.string());
                    break;
                case /* repeated string phone */ 3:
                    message.phone.push(reader.string());
                    break;
                case /* repeated int64 creatorAccountId */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.creatorAccountId.push(reader.int64().toString());
                    else
                        message.creatorAccountId.push(reader.int64().toString());
                    break;
                case /* repeated int64 ids */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.ids.push(reader.int64().toString());
                    else
                        message.ids.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExamineeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string name = 1; */
        for (let i = 0; i < message.name.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.name[i]);
        /* repeated string client = 2; */
        for (let i = 0; i < message.client.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.client[i]);
        /* repeated string phone = 3; */
        for (let i = 0; i < message.phone.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.phone[i]);
        /* repeated int64 creatorAccountId = 4; */
        if (message.creatorAccountId.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.creatorAccountId.length; i++)
                writer.int64(message.creatorAccountId[i]);
            writer.join();
        }
        /* repeated int64 ids = 5; */
        if (message.ids.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.ids.length; i++)
                writer.int64(message.ids[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ListExamineeRequest
 */
export const ListExamineeRequest = new ListExamineeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountExamineeByExaminersRequest$Type extends MessageType<CountExamineeByExaminersRequest> {
    constructor() {
        super("base.examination.CountExamineeByExaminersRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "examiner_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CountExamineeByExaminersRequest>): CountExamineeByExaminersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        message.examinerIds = [];
        if (value !== undefined)
            reflectionMergePartial<CountExamineeByExaminersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountExamineeByExaminersRequest): CountExamineeByExaminersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organization_id */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* repeated int64 examiner_ids */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.examinerIds.push(reader.int64().toString());
                    else
                        message.examinerIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountExamineeByExaminersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organization_id = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* repeated int64 examiner_ids = 2; */
        if (message.examinerIds.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.examinerIds.length; i++)
                writer.int64(message.examinerIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.CountExamineeByExaminersRequest
 */
export const CountExamineeByExaminersRequest = new CountExamineeByExaminersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountExamineeByExaminersResponse$Type extends MessageType<CountExamineeByExaminersResponse> {
    constructor() {
        super("base.examination.CountExamineeByExaminersResponse", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CountExamineeByExaminersResponse_Result }
        ]);
    }
    create(value?: PartialMessage<CountExamineeByExaminersResponse>): CountExamineeByExaminersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        if (value !== undefined)
            reflectionMergePartial<CountExamineeByExaminersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountExamineeByExaminersResponse): CountExamineeByExaminersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.CountExamineeByExaminersResponse.Result results */ 1:
                    message.results.push(CountExamineeByExaminersResponse_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountExamineeByExaminersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.CountExamineeByExaminersResponse.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            CountExamineeByExaminersResponse_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.CountExamineeByExaminersResponse
 */
export const CountExamineeByExaminersResponse = new CountExamineeByExaminersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountExamineeByExaminersResponse_Result$Type extends MessageType<CountExamineeByExaminersResponse_Result> {
    constructor() {
        super("base.examination.CountExamineeByExaminersResponse.Result", [
            { no: 1, name: "examiner_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<CountExamineeByExaminersResponse_Result>): CountExamineeByExaminersResponse_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinerId = "0";
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<CountExamineeByExaminersResponse_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountExamineeByExaminersResponse_Result): CountExamineeByExaminersResponse_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examiner_id */ 1:
                    message.examinerId = reader.int64().toString();
                    break;
                case /* int32 count */ 2:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountExamineeByExaminersResponse_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examiner_id = 1; */
        if (message.examinerId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examinerId);
        /* int32 count = 2; */
        if (message.count !== 0)
            writer.tag(2, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.CountExamineeByExaminersResponse.Result
 */
export const CountExamineeByExaminersResponse_Result = new CountExamineeByExaminersResponse_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExamineeListByExamineeAccountIdsResponse$Type extends MessageType<ListExamineeListByExamineeAccountIdsResponse> {
    constructor() {
        super("base.examination.ListExamineeListByExamineeAccountIdsResponse", [
            { no: 1, name: "examineeResult", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExamineeResult }
        ]);
    }
    create(value?: PartialMessage<ListExamineeListByExamineeAccountIdsResponse>): ListExamineeListByExamineeAccountIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeResult = [];
        if (value !== undefined)
            reflectionMergePartial<ListExamineeListByExamineeAccountIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExamineeListByExamineeAccountIdsResponse): ListExamineeListByExamineeAccountIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ExamineeResult examineeResult */ 1:
                    message.examineeResult.push(ExamineeResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExamineeListByExamineeAccountIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ExamineeResult examineeResult = 1; */
        for (let i = 0; i < message.examineeResult.length; i++)
            ExamineeResult.internalBinaryWrite(message.examineeResult[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ListExamineeListByExamineeAccountIdsResponse
 */
export const ListExamineeListByExamineeAccountIdsResponse = new ListExamineeListByExamineeAccountIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExamineeListByExamineeAccountIdsRequest$Type extends MessageType<ListExamineeListByExamineeAccountIdsRequest> {
    constructor() {
        super("base.examination.ListExamineeListByExamineeAccountIdsRequest", [
            { no: 1, name: "examineeAccountIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "client", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListExamineeListByExamineeAccountIdsRequest>): ListExamineeListByExamineeAccountIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeAccountIds = [];
        message.client = [];
        if (value !== undefined)
            reflectionMergePartial<ListExamineeListByExamineeAccountIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExamineeListByExamineeAccountIdsRequest): ListExamineeListByExamineeAccountIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 examineeAccountIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.examineeAccountIds.push(reader.int64().toString());
                    else
                        message.examineeAccountIds.push(reader.int64().toString());
                    break;
                case /* repeated string client */ 2:
                    message.client.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExamineeListByExamineeAccountIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 examineeAccountIds = 1; */
        if (message.examineeAccountIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.examineeAccountIds.length; i++)
                writer.int64(message.examineeAccountIds[i]);
            writer.join();
        }
        /* repeated string client = 2; */
        for (let i = 0; i < message.client.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.client[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ListExamineeListByExamineeAccountIdsRequest
 */
export const ListExamineeListByExamineeAccountIdsRequest = new ListExamineeListByExamineeAccountIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExaminationReportByOrganizationIdAndTypeResponse$Type extends MessageType<ListExaminationReportByOrganizationIdAndTypeResponse> {
    constructor() {
        super("base.examination.ListExaminationReportByOrganizationIdAndTypeResponse", [
            { no: 1, name: "examinationReportResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExaminationReportResult }
        ]);
    }
    create(value?: PartialMessage<ListExaminationReportByOrganizationIdAndTypeResponse>): ListExaminationReportByOrganizationIdAndTypeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportResults = [];
        if (value !== undefined)
            reflectionMergePartial<ListExaminationReportByOrganizationIdAndTypeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExaminationReportByOrganizationIdAndTypeResponse): ListExaminationReportByOrganizationIdAndTypeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ExaminationReportResult examinationReportResults */ 1:
                    message.examinationReportResults.push(ExaminationReportResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExaminationReportByOrganizationIdAndTypeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ExaminationReportResult examinationReportResults = 1; */
        for (let i = 0; i < message.examinationReportResults.length; i++)
            ExaminationReportResult.internalBinaryWrite(message.examinationReportResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ListExaminationReportByOrganizationIdAndTypeResponse
 */
export const ListExaminationReportByOrganizationIdAndTypeResponse = new ListExaminationReportByOrganizationIdAndTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExaminationReportByOrganizationIdAndTypeRequest$Type extends MessageType<ListExaminationReportByOrganizationIdAndTypeRequest> {
    constructor() {
        super("base.examination.ListExaminationReportByOrganizationIdAndTypeRequest", [
            { no: 1, name: "organizationIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "examinationReportType", kind: "enum", T: () => ["base.examination.ExaminationReportType", ExaminationReportType] }
        ]);
    }
    create(value?: PartialMessage<ListExaminationReportByOrganizationIdAndTypeRequest>): ListExaminationReportByOrganizationIdAndTypeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationIds = [];
        message.examinationReportType = 0;
        if (value !== undefined)
            reflectionMergePartial<ListExaminationReportByOrganizationIdAndTypeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExaminationReportByOrganizationIdAndTypeRequest): ListExaminationReportByOrganizationIdAndTypeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 organizationIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.organizationIds.push(reader.int64().toString());
                    else
                        message.organizationIds.push(reader.int64().toString());
                    break;
                case /* base.examination.ExaminationReportType examinationReportType */ 2:
                    message.examinationReportType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExaminationReportByOrganizationIdAndTypeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 organizationIds = 1; */
        if (message.organizationIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.organizationIds.length; i++)
                writer.int64(message.organizationIds[i]);
            writer.join();
        }
        /* base.examination.ExaminationReportType examinationReportType = 2; */
        if (message.examinationReportType !== 0)
            writer.tag(2, WireType.Varint).int32(message.examinationReportType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ListExaminationReportByOrganizationIdAndTypeRequest
 */
export const ListExaminationReportByOrganizationIdAndTypeRequest = new ListExaminationReportByOrganizationIdAndTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExaminationReportPageByAccessTokenAndTypeResponse$Type extends MessageType<GetExaminationReportPageByAccessTokenAndTypeResponse> {
    constructor() {
        super("base.examination.GetExaminationReportPageByAccessTokenAndTypeResponse", [
            { no: 1, name: "examinationReportResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExaminationReportResult },
            { no: 2, name: "totalElements", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "totalPages", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "isFirst", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "isLast", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "numberOfElements", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetExaminationReportPageByAccessTokenAndTypeResponse>): GetExaminationReportPageByAccessTokenAndTypeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportResults = [];
        message.totalElements = "0";
        message.totalPages = 0;
        message.isFirst = false;
        message.isLast = false;
        message.number = 0;
        message.numberOfElements = 0;
        message.size = 0;
        if (value !== undefined)
            reflectionMergePartial<GetExaminationReportPageByAccessTokenAndTypeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExaminationReportPageByAccessTokenAndTypeResponse): GetExaminationReportPageByAccessTokenAndTypeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ExaminationReportResult examinationReportResults */ 1:
                    message.examinationReportResults.push(ExaminationReportResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 totalElements */ 2:
                    message.totalElements = reader.int64().toString();
                    break;
                case /* int32 totalPages */ 3:
                    message.totalPages = reader.int32();
                    break;
                case /* bool isFirst */ 4:
                    message.isFirst = reader.bool();
                    break;
                case /* bool isLast */ 5:
                    message.isLast = reader.bool();
                    break;
                case /* int32 number */ 6:
                    message.number = reader.int32();
                    break;
                case /* int32 numberOfElements */ 7:
                    message.numberOfElements = reader.int32();
                    break;
                case /* int32 size */ 8:
                    message.size = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExaminationReportPageByAccessTokenAndTypeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ExaminationReportResult examinationReportResults = 1; */
        for (let i = 0; i < message.examinationReportResults.length; i++)
            ExaminationReportResult.internalBinaryWrite(message.examinationReportResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 totalElements = 2; */
        if (message.totalElements !== "0")
            writer.tag(2, WireType.Varint).int64(message.totalElements);
        /* int32 totalPages = 3; */
        if (message.totalPages !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalPages);
        /* bool isFirst = 4; */
        if (message.isFirst !== false)
            writer.tag(4, WireType.Varint).bool(message.isFirst);
        /* bool isLast = 5; */
        if (message.isLast !== false)
            writer.tag(5, WireType.Varint).bool(message.isLast);
        /* int32 number = 6; */
        if (message.number !== 0)
            writer.tag(6, WireType.Varint).int32(message.number);
        /* int32 numberOfElements = 7; */
        if (message.numberOfElements !== 0)
            writer.tag(7, WireType.Varint).int32(message.numberOfElements);
        /* int32 size = 8; */
        if (message.size !== 0)
            writer.tag(8, WireType.Varint).int32(message.size);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExaminationReportPageByAccessTokenAndTypeResponse
 */
export const GetExaminationReportPageByAccessTokenAndTypeResponse = new GetExaminationReportPageByAccessTokenAndTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExaminationReportPageByAccessTokenAndTypeRequest$Type extends MessageType<GetExaminationReportPageByAccessTokenAndTypeRequest> {
    constructor() {
        super("base.examination.GetExaminationReportPageByAccessTokenAndTypeRequest", [
            { no: 2, name: "examinationReportType", kind: "enum", T: () => ["base.examination.ExaminationReportType", ExaminationReportType] },
            { no: 3, name: "clientList", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pageNum", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "pageSize", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetExaminationReportPageByAccessTokenAndTypeRequest>): GetExaminationReportPageByAccessTokenAndTypeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportType = 0;
        message.clientList = [];
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<GetExaminationReportPageByAccessTokenAndTypeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExaminationReportPageByAccessTokenAndTypeRequest): GetExaminationReportPageByAccessTokenAndTypeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.examination.ExaminationReportType examinationReportType */ 2:
                    message.examinationReportType = reader.int32();
                    break;
                case /* repeated string clientList */ 3:
                    message.clientList.push(reader.string());
                    break;
                case /* int32 pageNum */ 4:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 pageSize */ 5:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExaminationReportPageByAccessTokenAndTypeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.examination.ExaminationReportType examinationReportType = 2; */
        if (message.examinationReportType !== 0)
            writer.tag(2, WireType.Varint).int32(message.examinationReportType);
        /* repeated string clientList = 3; */
        for (let i = 0; i < message.clientList.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.clientList[i]);
        /* int32 pageNum = 4; */
        if (message.pageNum !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageNum);
        /* int32 pageSize = 5; */
        if (message.pageSize !== 0)
            writer.tag(5, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExaminationReportPageByAccessTokenAndTypeRequest
 */
export const GetExaminationReportPageByAccessTokenAndTypeRequest = new GetExaminationReportPageByAccessTokenAndTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExamineeListByIdsRequest$Type extends MessageType<GetExamineeListByIdsRequest> {
    constructor() {
        super("base.examination.GetExamineeListByIdsRequest", [
            { no: 1, name: "examineeId", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetExamineeListByIdsRequest>): GetExamineeListByIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeId = [];
        if (value !== undefined)
            reflectionMergePartial<GetExamineeListByIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExamineeListByIdsRequest): GetExamineeListByIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 examineeId */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.examineeId.push(reader.int64().toString());
                    else
                        message.examineeId.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExamineeListByIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 examineeId = 1; */
        if (message.examineeId.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.examineeId.length; i++)
                writer.int64(message.examineeId[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExamineeListByIdsRequest
 */
export const GetExamineeListByIdsRequest = new GetExamineeListByIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExamineeListByIdsResponse$Type extends MessageType<GetExamineeListByIdsResponse> {
    constructor() {
        super("base.examination.GetExamineeListByIdsResponse", [
            { no: 1, name: "examineeResult", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExamineeResult }
        ]);
    }
    create(value?: PartialMessage<GetExamineeListByIdsResponse>): GetExamineeListByIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeResult = [];
        if (value !== undefined)
            reflectionMergePartial<GetExamineeListByIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExamineeListByIdsResponse): GetExamineeListByIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ExamineeResult examineeResult */ 1:
                    message.examineeResult.push(ExamineeResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExamineeListByIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ExamineeResult examineeResult = 1; */
        for (let i = 0; i < message.examineeResult.length; i++)
            ExamineeResult.internalBinaryWrite(message.examineeResult[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExamineeListByIdsResponse
 */
export const GetExamineeListByIdsResponse = new GetExamineeListByIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteExaminationRelationshipByAccountIdRequest$Type extends MessageType<DeleteExaminationRelationshipByAccountIdRequest> {
    constructor() {
        super("base.examination.DeleteExaminationRelationshipByAccountIdRequest", [
            { no: 1, name: "examineeId", kind: "message", T: () => Int64Value },
            { no: 2, name: "accountId", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<DeleteExaminationRelationshipByAccountIdRequest>): DeleteExaminationRelationshipByAccountIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteExaminationRelationshipByAccountIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteExaminationRelationshipByAccountIdRequest): DeleteExaminationRelationshipByAccountIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value examineeId */ 1:
                    message.examineeId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examineeId);
                    break;
                case /* google.protobuf.Int64Value accountId */ 2:
                    message.accountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteExaminationRelationshipByAccountIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value examineeId = 1; */
        if (message.examineeId)
            Int64Value.internalBinaryWrite(message.examineeId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value accountId = 2; */
        if (message.accountId)
            Int64Value.internalBinaryWrite(message.accountId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.DeleteExaminationRelationshipByAccountIdRequest
 */
export const DeleteExaminationRelationshipByAccountIdRequest = new DeleteExaminationRelationshipByAccountIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteExaminationRelationshipByAccountIdResponse$Type extends MessageType<DeleteExaminationRelationshipByAccountIdResponse> {
    constructor() {
        super("base.examination.DeleteExaminationRelationshipByAccountIdResponse", [
            { no: 1, name: "isDeleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteExaminationRelationshipByAccountIdResponse>): DeleteExaminationRelationshipByAccountIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isDeleted = false;
        if (value !== undefined)
            reflectionMergePartial<DeleteExaminationRelationshipByAccountIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteExaminationRelationshipByAccountIdResponse): DeleteExaminationRelationshipByAccountIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isDeleted */ 1:
                    message.isDeleted = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteExaminationRelationshipByAccountIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isDeleted = 1; */
        if (message.isDeleted !== false)
            writer.tag(1, WireType.Varint).bool(message.isDeleted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.DeleteExaminationRelationshipByAccountIdResponse
 */
export const DeleteExaminationRelationshipByAccountIdResponse = new DeleteExaminationRelationshipByAccountIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchDeleteExaminationRelationshipByOrganizationRequest$Type extends MessageType<BatchDeleteExaminationRelationshipByOrganizationRequest> {
    constructor() {
        super("base.examination.BatchDeleteExaminationRelationshipByOrganizationRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "examinee_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<BatchDeleteExaminationRelationshipByOrganizationRequest>): BatchDeleteExaminationRelationshipByOrganizationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        message.examineeIds = [];
        if (value !== undefined)
            reflectionMergePartial<BatchDeleteExaminationRelationshipByOrganizationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BatchDeleteExaminationRelationshipByOrganizationRequest): BatchDeleteExaminationRelationshipByOrganizationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organization_id */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* repeated int64 examinee_ids */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.examineeIds.push(reader.int64().toString());
                    else
                        message.examineeIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BatchDeleteExaminationRelationshipByOrganizationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organization_id = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* repeated int64 examinee_ids = 2; */
        if (message.examineeIds.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.examineeIds.length; i++)
                writer.int64(message.examineeIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.BatchDeleteExaminationRelationshipByOrganizationRequest
 */
export const BatchDeleteExaminationRelationshipByOrganizationRequest = new BatchDeleteExaminationRelationshipByOrganizationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchDeleteExaminationRelationshipByOrganizationResponse$Type extends MessageType<BatchDeleteExaminationRelationshipByOrganizationResponse> {
    constructor() {
        super("base.examination.BatchDeleteExaminationRelationshipByOrganizationResponse", [
            { no: 1, name: "examinee_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<BatchDeleteExaminationRelationshipByOrganizationResponse>): BatchDeleteExaminationRelationshipByOrganizationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeIds = [];
        if (value !== undefined)
            reflectionMergePartial<BatchDeleteExaminationRelationshipByOrganizationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BatchDeleteExaminationRelationshipByOrganizationResponse): BatchDeleteExaminationRelationshipByOrganizationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 examinee_ids */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.examineeIds.push(reader.int64().toString());
                    else
                        message.examineeIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BatchDeleteExaminationRelationshipByOrganizationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 examinee_ids = 1; */
        if (message.examineeIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.examineeIds.length; i++)
                writer.int64(message.examineeIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.BatchDeleteExaminationRelationshipByOrganizationResponse
 */
export const BatchDeleteExaminationRelationshipByOrganizationResponse = new BatchDeleteExaminationRelationshipByOrganizationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchDeleteExaminationRelationshipByExaminerAccountIdRequest$Type extends MessageType<BatchDeleteExaminationRelationshipByExaminerAccountIdRequest> {
    constructor() {
        super("base.examination.BatchDeleteExaminationRelationshipByExaminerAccountIdRequest", [
            { no: 1, name: "examiner_account_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "examinee_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<BatchDeleteExaminationRelationshipByExaminerAccountIdRequest>): BatchDeleteExaminationRelationshipByExaminerAccountIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinerAccountId = "0";
        message.examineeIds = [];
        if (value !== undefined)
            reflectionMergePartial<BatchDeleteExaminationRelationshipByExaminerAccountIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BatchDeleteExaminationRelationshipByExaminerAccountIdRequest): BatchDeleteExaminationRelationshipByExaminerAccountIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examiner_account_id */ 1:
                    message.examinerAccountId = reader.int64().toString();
                    break;
                case /* repeated int64 examinee_ids */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.examineeIds.push(reader.int64().toString());
                    else
                        message.examineeIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BatchDeleteExaminationRelationshipByExaminerAccountIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examiner_account_id = 1; */
        if (message.examinerAccountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examinerAccountId);
        /* repeated int64 examinee_ids = 2; */
        if (message.examineeIds.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.examineeIds.length; i++)
                writer.int64(message.examineeIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.BatchDeleteExaminationRelationshipByExaminerAccountIdRequest
 */
export const BatchDeleteExaminationRelationshipByExaminerAccountIdRequest = new BatchDeleteExaminationRelationshipByExaminerAccountIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchDeleteExaminationRelationshipByExaminerAccountIdResponse$Type extends MessageType<BatchDeleteExaminationRelationshipByExaminerAccountIdResponse> {
    constructor() {
        super("base.examination.BatchDeleteExaminationRelationshipByExaminerAccountIdResponse", [
            { no: 1, name: "examinee_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<BatchDeleteExaminationRelationshipByExaminerAccountIdResponse>): BatchDeleteExaminationRelationshipByExaminerAccountIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeIds = [];
        if (value !== undefined)
            reflectionMergePartial<BatchDeleteExaminationRelationshipByExaminerAccountIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BatchDeleteExaminationRelationshipByExaminerAccountIdResponse): BatchDeleteExaminationRelationshipByExaminerAccountIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 examinee_ids */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.examineeIds.push(reader.int64().toString());
                    else
                        message.examineeIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BatchDeleteExaminationRelationshipByExaminerAccountIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 examinee_ids = 1; */
        if (message.examineeIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.examineeIds.length; i++)
                writer.int64(message.examineeIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.BatchDeleteExaminationRelationshipByExaminerAccountIdResponse
 */
export const BatchDeleteExaminationRelationshipByExaminerAccountIdResponse = new BatchDeleteExaminationRelationshipByExaminerAccountIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExaminationReportByExamineeReportDetailIdRequest$Type extends MessageType<GetExaminationReportByExamineeReportDetailIdRequest> {
    constructor() {
        super("base.examination.GetExaminationReportByExamineeReportDetailIdRequest", [
            { no: 1, name: "examineeReportDetailId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetExaminationReportByExamineeReportDetailIdRequest>): GetExaminationReportByExamineeReportDetailIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeReportDetailId = "";
        if (value !== undefined)
            reflectionMergePartial<GetExaminationReportByExamineeReportDetailIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExaminationReportByExamineeReportDetailIdRequest): GetExaminationReportByExamineeReportDetailIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string examineeReportDetailId */ 1:
                    message.examineeReportDetailId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExaminationReportByExamineeReportDetailIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string examineeReportDetailId = 1; */
        if (message.examineeReportDetailId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.examineeReportDetailId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExaminationReportByExamineeReportDetailIdRequest
 */
export const GetExaminationReportByExamineeReportDetailIdRequest = new GetExaminationReportByExamineeReportDetailIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExaminationReportByExamineeReportDetailIdResponse$Type extends MessageType<GetExaminationReportByExamineeReportDetailIdResponse> {
    constructor() {
        super("base.examination.GetExaminationReportByExamineeReportDetailIdResponse", [
            { no: 1, name: "examinationReportResult", kind: "message", T: () => ExaminationReportResult }
        ]);
    }
    create(value?: PartialMessage<GetExaminationReportByExamineeReportDetailIdResponse>): GetExaminationReportByExamineeReportDetailIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetExaminationReportByExamineeReportDetailIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExaminationReportByExamineeReportDetailIdResponse): GetExaminationReportByExamineeReportDetailIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.examination.ExaminationReportResult examinationReportResult */ 1:
                    message.examinationReportResult = ExaminationReportResult.internalBinaryRead(reader, reader.uint32(), options, message.examinationReportResult);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExaminationReportByExamineeReportDetailIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.examination.ExaminationReportResult examinationReportResult = 1; */
        if (message.examinationReportResult)
            ExaminationReportResult.internalBinaryWrite(message.examinationReportResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExaminationReportByExamineeReportDetailIdResponse
 */
export const GetExaminationReportByExamineeReportDetailIdResponse = new GetExaminationReportByExamineeReportDetailIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchGetExaminationReportsByDetailIdRequest$Type extends MessageType<BatchGetExaminationReportsByDetailIdRequest> {
    constructor() {
        super("base.examination.BatchGetExaminationReportsByDetailIdRequest", [
            { no: 1, name: "detail_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<BatchGetExaminationReportsByDetailIdRequest>): BatchGetExaminationReportsByDetailIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.detailIds = [];
        if (value !== undefined)
            reflectionMergePartial<BatchGetExaminationReportsByDetailIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BatchGetExaminationReportsByDetailIdRequest): BatchGetExaminationReportsByDetailIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string detail_ids */ 1:
                    message.detailIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BatchGetExaminationReportsByDetailIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string detail_ids = 1; */
        for (let i = 0; i < message.detailIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.detailIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.BatchGetExaminationReportsByDetailIdRequest
 */
export const BatchGetExaminationReportsByDetailIdRequest = new BatchGetExaminationReportsByDetailIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchGetExaminationReportsByDetailIdResponse$Type extends MessageType<BatchGetExaminationReportsByDetailIdResponse> {
    constructor() {
        super("base.examination.BatchGetExaminationReportsByDetailIdResponse", [
            { no: 1, name: "reports", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExaminationReportResult }
        ]);
    }
    create(value?: PartialMessage<BatchGetExaminationReportsByDetailIdResponse>): BatchGetExaminationReportsByDetailIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.reports = [];
        if (value !== undefined)
            reflectionMergePartial<BatchGetExaminationReportsByDetailIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BatchGetExaminationReportsByDetailIdResponse): BatchGetExaminationReportsByDetailIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ExaminationReportResult reports */ 1:
                    message.reports.push(ExaminationReportResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BatchGetExaminationReportsByDetailIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ExaminationReportResult reports = 1; */
        for (let i = 0; i < message.reports.length; i++)
            ExaminationReportResult.internalBinaryWrite(message.reports[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.BatchGetExaminationReportsByDetailIdResponse
 */
export const BatchGetExaminationReportsByDetailIdResponse = new BatchGetExaminationReportsByDetailIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExaminationReportByExamineeReportDetailIdRequest$Type extends MessageType<UpdateExaminationReportByExamineeReportDetailIdRequest> {
    constructor() {
        super("base.examination.UpdateExaminationReportByExamineeReportDetailIdRequest", [
            { no: 1, name: "examinationReportInfo", kind: "message", T: () => ExaminationReportInfo }
        ]);
    }
    create(value?: PartialMessage<UpdateExaminationReportByExamineeReportDetailIdRequest>): UpdateExaminationReportByExamineeReportDetailIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateExaminationReportByExamineeReportDetailIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateExaminationReportByExamineeReportDetailIdRequest): UpdateExaminationReportByExamineeReportDetailIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.examination.ExaminationReportInfo examinationReportInfo */ 1:
                    message.examinationReportInfo = ExaminationReportInfo.internalBinaryRead(reader, reader.uint32(), options, message.examinationReportInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateExaminationReportByExamineeReportDetailIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.examination.ExaminationReportInfo examinationReportInfo = 1; */
        if (message.examinationReportInfo)
            ExaminationReportInfo.internalBinaryWrite(message.examinationReportInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.UpdateExaminationReportByExamineeReportDetailIdRequest
 */
export const UpdateExaminationReportByExamineeReportDetailIdRequest = new UpdateExaminationReportByExamineeReportDetailIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExaminationReportByExamineeReportDetailIdResponse$Type extends MessageType<UpdateExaminationReportByExamineeReportDetailIdResponse> {
    constructor() {
        super("base.examination.UpdateExaminationReportByExamineeReportDetailIdResponse", [
            { no: 1, name: "isUpdated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateExaminationReportByExamineeReportDetailIdResponse>): UpdateExaminationReportByExamineeReportDetailIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isUpdated = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateExaminationReportByExamineeReportDetailIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateExaminationReportByExamineeReportDetailIdResponse): UpdateExaminationReportByExamineeReportDetailIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isUpdated */ 1:
                    message.isUpdated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateExaminationReportByExamineeReportDetailIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isUpdated = 1; */
        if (message.isUpdated !== false)
            writer.tag(1, WireType.Varint).bool(message.isUpdated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.UpdateExaminationReportByExamineeReportDetailIdResponse
 */
export const UpdateExaminationReportByExamineeReportDetailIdResponse = new UpdateExaminationReportByExamineeReportDetailIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExaminationReportPageByExamineeIdRequest$Type extends MessageType<GetExaminationReportPageByExamineeIdRequest> {
    constructor() {
        super("base.examination.GetExaminationReportPageByExamineeIdRequest", [
            { no: 1, name: "examineeId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "self_examine", kind: "message", T: () => BoolValue },
            { no: 2, name: "pageNum", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "pageSize", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetExaminationReportPageByExamineeIdRequest>): GetExaminationReportPageByExamineeIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeId = "0";
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<GetExaminationReportPageByExamineeIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExaminationReportPageByExamineeIdRequest): GetExaminationReportPageByExamineeIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examineeId */ 1:
                    message.examineeId = reader.int64().toString();
                    break;
                case /* google.protobuf.BoolValue self_examine */ 4:
                    message.selfExamine = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.selfExamine);
                    break;
                case /* int32 pageNum */ 2:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 pageSize */ 3:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExaminationReportPageByExamineeIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examineeId = 1; */
        if (message.examineeId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examineeId);
        /* int32 pageNum = 2; */
        if (message.pageNum !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageNum);
        /* int32 pageSize = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* google.protobuf.BoolValue self_examine = 4; */
        if (message.selfExamine)
            BoolValue.internalBinaryWrite(message.selfExamine, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExaminationReportPageByExamineeIdRequest
 */
export const GetExaminationReportPageByExamineeIdRequest = new GetExaminationReportPageByExamineeIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExaminationReportPageByExamineeIdResponse$Type extends MessageType<GetExaminationReportPageByExamineeIdResponse> {
    constructor() {
        super("base.examination.GetExaminationReportPageByExamineeIdResponse", [
            { no: 1, name: "examinationReportResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExaminationReportResult },
            { no: 2, name: "totalElements", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "totalPages", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "isFirst", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "isLast", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "numberOfElements", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetExaminationReportPageByExamineeIdResponse>): GetExaminationReportPageByExamineeIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportResults = [];
        message.totalElements = "0";
        message.totalPages = 0;
        message.isFirst = false;
        message.isLast = false;
        message.number = 0;
        message.numberOfElements = 0;
        message.size = 0;
        if (value !== undefined)
            reflectionMergePartial<GetExaminationReportPageByExamineeIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExaminationReportPageByExamineeIdResponse): GetExaminationReportPageByExamineeIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ExaminationReportResult examinationReportResults */ 1:
                    message.examinationReportResults.push(ExaminationReportResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 totalElements */ 2:
                    message.totalElements = reader.int64().toString();
                    break;
                case /* int32 totalPages */ 3:
                    message.totalPages = reader.int32();
                    break;
                case /* bool isFirst */ 4:
                    message.isFirst = reader.bool();
                    break;
                case /* bool isLast */ 5:
                    message.isLast = reader.bool();
                    break;
                case /* int32 number */ 6:
                    message.number = reader.int32();
                    break;
                case /* int32 numberOfElements */ 7:
                    message.numberOfElements = reader.int32();
                    break;
                case /* int32 size */ 8:
                    message.size = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExaminationReportPageByExamineeIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ExaminationReportResult examinationReportResults = 1; */
        for (let i = 0; i < message.examinationReportResults.length; i++)
            ExaminationReportResult.internalBinaryWrite(message.examinationReportResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 totalElements = 2; */
        if (message.totalElements !== "0")
            writer.tag(2, WireType.Varint).int64(message.totalElements);
        /* int32 totalPages = 3; */
        if (message.totalPages !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalPages);
        /* bool isFirst = 4; */
        if (message.isFirst !== false)
            writer.tag(4, WireType.Varint).bool(message.isFirst);
        /* bool isLast = 5; */
        if (message.isLast !== false)
            writer.tag(5, WireType.Varint).bool(message.isLast);
        /* int32 number = 6; */
        if (message.number !== 0)
            writer.tag(6, WireType.Varint).int32(message.number);
        /* int32 numberOfElements = 7; */
        if (message.numberOfElements !== 0)
            writer.tag(7, WireType.Varint).int32(message.numberOfElements);
        /* int32 size = 8; */
        if (message.size !== 0)
            writer.tag(8, WireType.Varint).int32(message.size);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExaminationReportPageByExamineeIdResponse
 */
export const GetExaminationReportPageByExamineeIdResponse = new GetExaminationReportPageByExamineeIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExaminationReportPageByExamineeIdAndTypeRequest$Type extends MessageType<GetExaminationReportPageByExamineeIdAndTypeRequest> {
    constructor() {
        super("base.examination.GetExaminationReportPageByExamineeIdAndTypeRequest", [
            { no: 1, name: "examineeId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "examinationReportType", kind: "enum", T: () => ["base.examination.ExaminationReportType", ExaminationReportType] },
            { no: 5, name: "self_examine", kind: "message", T: () => BoolValue },
            { no: 3, name: "pageNum", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "pageSize", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetExaminationReportPageByExamineeIdAndTypeRequest>): GetExaminationReportPageByExamineeIdAndTypeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeId = "0";
        message.examinationReportType = 0;
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<GetExaminationReportPageByExamineeIdAndTypeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExaminationReportPageByExamineeIdAndTypeRequest): GetExaminationReportPageByExamineeIdAndTypeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examineeId */ 1:
                    message.examineeId = reader.int64().toString();
                    break;
                case /* base.examination.ExaminationReportType examinationReportType */ 2:
                    message.examinationReportType = reader.int32();
                    break;
                case /* google.protobuf.BoolValue self_examine */ 5:
                    message.selfExamine = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.selfExamine);
                    break;
                case /* int32 pageNum */ 3:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 pageSize */ 4:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExaminationReportPageByExamineeIdAndTypeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examineeId = 1; */
        if (message.examineeId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examineeId);
        /* base.examination.ExaminationReportType examinationReportType = 2; */
        if (message.examinationReportType !== 0)
            writer.tag(2, WireType.Varint).int32(message.examinationReportType);
        /* int32 pageNum = 3; */
        if (message.pageNum !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageNum);
        /* int32 pageSize = 4; */
        if (message.pageSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageSize);
        /* google.protobuf.BoolValue self_examine = 5; */
        if (message.selfExamine)
            BoolValue.internalBinaryWrite(message.selfExamine, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExaminationReportPageByExamineeIdAndTypeRequest
 */
export const GetExaminationReportPageByExamineeIdAndTypeRequest = new GetExaminationReportPageByExamineeIdAndTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExaminationReportPageByExamineeIdAndTypeResponse$Type extends MessageType<GetExaminationReportPageByExamineeIdAndTypeResponse> {
    constructor() {
        super("base.examination.GetExaminationReportPageByExamineeIdAndTypeResponse", [
            { no: 1, name: "examinationReportResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExaminationReportResult },
            { no: 2, name: "totalElements", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "totalPages", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "isFirst", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "isLast", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "numberOfElements", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetExaminationReportPageByExamineeIdAndTypeResponse>): GetExaminationReportPageByExamineeIdAndTypeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportResults = [];
        message.totalElements = "0";
        message.totalPages = 0;
        message.isFirst = false;
        message.isLast = false;
        message.number = 0;
        message.numberOfElements = 0;
        message.size = 0;
        if (value !== undefined)
            reflectionMergePartial<GetExaminationReportPageByExamineeIdAndTypeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExaminationReportPageByExamineeIdAndTypeResponse): GetExaminationReportPageByExamineeIdAndTypeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ExaminationReportResult examinationReportResults */ 1:
                    message.examinationReportResults.push(ExaminationReportResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 totalElements */ 2:
                    message.totalElements = reader.int64().toString();
                    break;
                case /* int32 totalPages */ 3:
                    message.totalPages = reader.int32();
                    break;
                case /* bool isFirst */ 4:
                    message.isFirst = reader.bool();
                    break;
                case /* bool isLast */ 5:
                    message.isLast = reader.bool();
                    break;
                case /* int32 number */ 6:
                    message.number = reader.int32();
                    break;
                case /* int32 numberOfElements */ 7:
                    message.numberOfElements = reader.int32();
                    break;
                case /* int32 size */ 8:
                    message.size = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExaminationReportPageByExamineeIdAndTypeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ExaminationReportResult examinationReportResults = 1; */
        for (let i = 0; i < message.examinationReportResults.length; i++)
            ExaminationReportResult.internalBinaryWrite(message.examinationReportResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 totalElements = 2; */
        if (message.totalElements !== "0")
            writer.tag(2, WireType.Varint).int64(message.totalElements);
        /* int32 totalPages = 3; */
        if (message.totalPages !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalPages);
        /* bool isFirst = 4; */
        if (message.isFirst !== false)
            writer.tag(4, WireType.Varint).bool(message.isFirst);
        /* bool isLast = 5; */
        if (message.isLast !== false)
            writer.tag(5, WireType.Varint).bool(message.isLast);
        /* int32 number = 6; */
        if (message.number !== 0)
            writer.tag(6, WireType.Varint).int32(message.number);
        /* int32 numberOfElements = 7; */
        if (message.numberOfElements !== 0)
            writer.tag(7, WireType.Varint).int32(message.numberOfElements);
        /* int32 size = 8; */
        if (message.size !== 0)
            writer.tag(8, WireType.Varint).int32(message.size);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExaminationReportPageByExamineeIdAndTypeResponse
 */
export const GetExaminationReportPageByExamineeIdAndTypeResponse = new GetExaminationReportPageByExamineeIdAndTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExaminationReportPageByAccountIdRequest$Type extends MessageType<GetExaminationReportPageByAccountIdRequest> {
    constructor() {
        super("base.examination.GetExaminationReportPageByAccountIdRequest", [
            { no: 1, name: "accountId", kind: "message", T: () => Int64Value },
            { no: 2, name: "clientList", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "pageNum", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "pageSize", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "self_examine", kind: "message", T: () => BoolValue }
        ]);
    }
    create(value?: PartialMessage<GetExaminationReportPageByAccountIdRequest>): GetExaminationReportPageByAccountIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientList = [];
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<GetExaminationReportPageByAccountIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExaminationReportPageByAccountIdRequest): GetExaminationReportPageByAccountIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value accountId */ 1:
                    message.accountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                case /* repeated string clientList */ 2:
                    message.clientList.push(reader.string());
                    break;
                case /* int32 pageNum */ 3:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 pageSize */ 4:
                    message.pageSize = reader.int32();
                    break;
                case /* google.protobuf.BoolValue self_examine */ 5:
                    message.selfExamine = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.selfExamine);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExaminationReportPageByAccountIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value accountId = 1; */
        if (message.accountId)
            Int64Value.internalBinaryWrite(message.accountId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string clientList = 2; */
        for (let i = 0; i < message.clientList.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.clientList[i]);
        /* int32 pageNum = 3; */
        if (message.pageNum !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageNum);
        /* int32 pageSize = 4; */
        if (message.pageSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageSize);
        /* google.protobuf.BoolValue self_examine = 5; */
        if (message.selfExamine)
            BoolValue.internalBinaryWrite(message.selfExamine, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExaminationReportPageByAccountIdRequest
 */
export const GetExaminationReportPageByAccountIdRequest = new GetExaminationReportPageByAccountIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExaminationReportPageByAccountIdResponse$Type extends MessageType<GetExaminationReportPageByAccountIdResponse> {
    constructor() {
        super("base.examination.GetExaminationReportPageByAccountIdResponse", [
            { no: 1, name: "examinationReportResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExaminationReportResult },
            { no: 2, name: "totalElements", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "totalPages", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "isFirst", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "isLast", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "numberOfElements", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetExaminationReportPageByAccountIdResponse>): GetExaminationReportPageByAccountIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportResults = [];
        message.totalElements = "0";
        message.totalPages = 0;
        message.isFirst = false;
        message.isLast = false;
        message.number = 0;
        message.numberOfElements = 0;
        message.size = 0;
        if (value !== undefined)
            reflectionMergePartial<GetExaminationReportPageByAccountIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExaminationReportPageByAccountIdResponse): GetExaminationReportPageByAccountIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ExaminationReportResult examinationReportResults */ 1:
                    message.examinationReportResults.push(ExaminationReportResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 totalElements */ 2:
                    message.totalElements = reader.int64().toString();
                    break;
                case /* int32 totalPages */ 3:
                    message.totalPages = reader.int32();
                    break;
                case /* bool isFirst */ 4:
                    message.isFirst = reader.bool();
                    break;
                case /* bool isLast */ 5:
                    message.isLast = reader.bool();
                    break;
                case /* int32 number */ 6:
                    message.number = reader.int32();
                    break;
                case /* int32 numberOfElements */ 7:
                    message.numberOfElements = reader.int32();
                    break;
                case /* int32 size */ 8:
                    message.size = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExaminationReportPageByAccountIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ExaminationReportResult examinationReportResults = 1; */
        for (let i = 0; i < message.examinationReportResults.length; i++)
            ExaminationReportResult.internalBinaryWrite(message.examinationReportResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 totalElements = 2; */
        if (message.totalElements !== "0")
            writer.tag(2, WireType.Varint).int64(message.totalElements);
        /* int32 totalPages = 3; */
        if (message.totalPages !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalPages);
        /* bool isFirst = 4; */
        if (message.isFirst !== false)
            writer.tag(4, WireType.Varint).bool(message.isFirst);
        /* bool isLast = 5; */
        if (message.isLast !== false)
            writer.tag(5, WireType.Varint).bool(message.isLast);
        /* int32 number = 6; */
        if (message.number !== 0)
            writer.tag(6, WireType.Varint).int32(message.number);
        /* int32 numberOfElements = 7; */
        if (message.numberOfElements !== 0)
            writer.tag(7, WireType.Varint).int32(message.numberOfElements);
        /* int32 size = 8; */
        if (message.size !== 0)
            writer.tag(8, WireType.Varint).int32(message.size);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExaminationReportPageByAccountIdResponse
 */
export const GetExaminationReportPageByAccountIdResponse = new GetExaminationReportPageByAccountIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExaminationReportPageByAccountIdAndTypeRequest$Type extends MessageType<GetExaminationReportPageByAccountIdAndTypeRequest> {
    constructor() {
        super("base.examination.GetExaminationReportPageByAccountIdAndTypeRequest", [
            { no: 1, name: "accountId", kind: "message", T: () => Int64Value },
            { no: 2, name: "examinationReportType", kind: "enum", T: () => ["base.examination.ExaminationReportType", ExaminationReportType] },
            { no: 3, name: "clientList", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pageNum", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "pageSize", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "self_examine", kind: "message", T: () => BoolValue }
        ]);
    }
    create(value?: PartialMessage<GetExaminationReportPageByAccountIdAndTypeRequest>): GetExaminationReportPageByAccountIdAndTypeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportType = 0;
        message.clientList = [];
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<GetExaminationReportPageByAccountIdAndTypeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExaminationReportPageByAccountIdAndTypeRequest): GetExaminationReportPageByAccountIdAndTypeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value accountId */ 1:
                    message.accountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                case /* base.examination.ExaminationReportType examinationReportType */ 2:
                    message.examinationReportType = reader.int32();
                    break;
                case /* repeated string clientList */ 3:
                    message.clientList.push(reader.string());
                    break;
                case /* int32 pageNum */ 4:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 pageSize */ 5:
                    message.pageSize = reader.int32();
                    break;
                case /* google.protobuf.BoolValue self_examine */ 6:
                    message.selfExamine = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.selfExamine);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExaminationReportPageByAccountIdAndTypeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value accountId = 1; */
        if (message.accountId)
            Int64Value.internalBinaryWrite(message.accountId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* base.examination.ExaminationReportType examinationReportType = 2; */
        if (message.examinationReportType !== 0)
            writer.tag(2, WireType.Varint).int32(message.examinationReportType);
        /* repeated string clientList = 3; */
        for (let i = 0; i < message.clientList.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.clientList[i]);
        /* int32 pageNum = 4; */
        if (message.pageNum !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageNum);
        /* int32 pageSize = 5; */
        if (message.pageSize !== 0)
            writer.tag(5, WireType.Varint).int32(message.pageSize);
        /* google.protobuf.BoolValue self_examine = 6; */
        if (message.selfExamine)
            BoolValue.internalBinaryWrite(message.selfExamine, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExaminationReportPageByAccountIdAndTypeRequest
 */
export const GetExaminationReportPageByAccountIdAndTypeRequest = new GetExaminationReportPageByAccountIdAndTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExaminationReportPageByAccountIdAndTypeResponse$Type extends MessageType<GetExaminationReportPageByAccountIdAndTypeResponse> {
    constructor() {
        super("base.examination.GetExaminationReportPageByAccountIdAndTypeResponse", [
            { no: 1, name: "examinationReportResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExaminationReportResult },
            { no: 2, name: "totalElements", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "totalPages", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "isFirst", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "isLast", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "numberOfElements", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetExaminationReportPageByAccountIdAndTypeResponse>): GetExaminationReportPageByAccountIdAndTypeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportResults = [];
        message.totalElements = "0";
        message.totalPages = 0;
        message.isFirst = false;
        message.isLast = false;
        message.number = 0;
        message.numberOfElements = 0;
        message.size = 0;
        if (value !== undefined)
            reflectionMergePartial<GetExaminationReportPageByAccountIdAndTypeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExaminationReportPageByAccountIdAndTypeResponse): GetExaminationReportPageByAccountIdAndTypeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ExaminationReportResult examinationReportResults */ 1:
                    message.examinationReportResults.push(ExaminationReportResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 totalElements */ 2:
                    message.totalElements = reader.int64().toString();
                    break;
                case /* int32 totalPages */ 3:
                    message.totalPages = reader.int32();
                    break;
                case /* bool isFirst */ 4:
                    message.isFirst = reader.bool();
                    break;
                case /* bool isLast */ 5:
                    message.isLast = reader.bool();
                    break;
                case /* int32 number */ 6:
                    message.number = reader.int32();
                    break;
                case /* int32 numberOfElements */ 7:
                    message.numberOfElements = reader.int32();
                    break;
                case /* int32 size */ 8:
                    message.size = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExaminationReportPageByAccountIdAndTypeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ExaminationReportResult examinationReportResults = 1; */
        for (let i = 0; i < message.examinationReportResults.length; i++)
            ExaminationReportResult.internalBinaryWrite(message.examinationReportResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 totalElements = 2; */
        if (message.totalElements !== "0")
            writer.tag(2, WireType.Varint).int64(message.totalElements);
        /* int32 totalPages = 3; */
        if (message.totalPages !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalPages);
        /* bool isFirst = 4; */
        if (message.isFirst !== false)
            writer.tag(4, WireType.Varint).bool(message.isFirst);
        /* bool isLast = 5; */
        if (message.isLast !== false)
            writer.tag(5, WireType.Varint).bool(message.isLast);
        /* int32 number = 6; */
        if (message.number !== 0)
            writer.tag(6, WireType.Varint).int32(message.number);
        /* int32 numberOfElements = 7; */
        if (message.numberOfElements !== 0)
            writer.tag(7, WireType.Varint).int32(message.numberOfElements);
        /* int32 size = 8; */
        if (message.size !== 0)
            writer.tag(8, WireType.Varint).int32(message.size);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExaminationReportPageByAccountIdAndTypeResponse
 */
export const GetExaminationReportPageByAccountIdAndTypeResponse = new GetExaminationReportPageByAccountIdAndTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExaminationRelationshipByIdRequest$Type extends MessageType<UpdateExaminationRelationshipByIdRequest> {
    constructor() {
        super("base.examination.UpdateExaminationRelationshipByIdRequest", [
            { no: 1, name: "examinationRelationshipId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "examinable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateExaminationRelationshipByIdRequest>): UpdateExaminationRelationshipByIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationRelationshipId = "0";
        message.examinable = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateExaminationRelationshipByIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateExaminationRelationshipByIdRequest): UpdateExaminationRelationshipByIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examinationRelationshipId */ 1:
                    message.examinationRelationshipId = reader.int64().toString();
                    break;
                case /* bool examinable */ 2:
                    message.examinable = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateExaminationRelationshipByIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examinationRelationshipId = 1; */
        if (message.examinationRelationshipId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examinationRelationshipId);
        /* bool examinable = 2; */
        if (message.examinable !== false)
            writer.tag(2, WireType.Varint).bool(message.examinable);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.UpdateExaminationRelationshipByIdRequest
 */
export const UpdateExaminationRelationshipByIdRequest = new UpdateExaminationRelationshipByIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExaminationRelationshipByIdResponse$Type extends MessageType<UpdateExaminationRelationshipByIdResponse> {
    constructor() {
        super("base.examination.UpdateExaminationRelationshipByIdResponse", [
            { no: 1, name: "done", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateExaminationRelationshipByIdResponse>): UpdateExaminationRelationshipByIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.done = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateExaminationRelationshipByIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateExaminationRelationshipByIdResponse): UpdateExaminationRelationshipByIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool done */ 1:
                    message.done = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateExaminationRelationshipByIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool done = 1; */
        if (message.done !== false)
            writer.tag(1, WireType.Varint).bool(message.done);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.UpdateExaminationRelationshipByIdResponse
 */
export const UpdateExaminationRelationshipByIdResponse = new UpdateExaminationRelationshipByIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExaminationRelationshipByAccessTokenRequest$Type extends MessageType<GetExaminationRelationshipByAccessTokenRequest> {
    constructor() {
        super("base.examination.GetExaminationRelationshipByAccessTokenRequest", []);
    }
    create(value?: PartialMessage<GetExaminationRelationshipByAccessTokenRequest>): GetExaminationRelationshipByAccessTokenRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetExaminationRelationshipByAccessTokenRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExaminationRelationshipByAccessTokenRequest): GetExaminationRelationshipByAccessTokenRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExaminationRelationshipByAccessTokenRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExaminationRelationshipByAccessTokenRequest
 */
export const GetExaminationRelationshipByAccessTokenRequest = new GetExaminationRelationshipByAccessTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExaminationRelationshipByAccessTokenResponse$Type extends MessageType<GetExaminationRelationshipByAccessTokenResponse> {
    constructor() {
        super("base.examination.GetExaminationRelationshipByAccessTokenResponse", [
            { no: 1, name: "examinationRelationship", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExaminationRelationshipResult }
        ]);
    }
    create(value?: PartialMessage<GetExaminationRelationshipByAccessTokenResponse>): GetExaminationRelationshipByAccessTokenResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationRelationship = [];
        if (value !== undefined)
            reflectionMergePartial<GetExaminationRelationshipByAccessTokenResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExaminationRelationshipByAccessTokenResponse): GetExaminationRelationshipByAccessTokenResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ExaminationRelationshipResult examinationRelationship */ 1:
                    message.examinationRelationship.push(ExaminationRelationshipResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExaminationRelationshipByAccessTokenResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ExaminationRelationshipResult examinationRelationship = 1; */
        for (let i = 0; i < message.examinationRelationship.length; i++)
            ExaminationRelationshipResult.internalBinaryWrite(message.examinationRelationship[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExaminationRelationshipByAccessTokenResponse
 */
export const GetExaminationRelationshipByAccessTokenResponse = new GetExaminationRelationshipByAccessTokenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExaminationRelationshipResult$Type extends MessageType<ExaminationRelationshipResult> {
    constructor() {
        super("base.examination.ExaminationRelationshipResult", [
            { no: 1, name: "id", kind: "message", T: () => Int64Value },
            { no: 2, name: "examinerAccountId", kind: "message", T: () => Int64Value },
            { no: 3, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 4, name: "examinable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "examinee", kind: "message", T: () => ExamineeResult }
        ]);
    }
    create(value?: PartialMessage<ExaminationRelationshipResult>): ExaminationRelationshipResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinable = false;
        if (value !== undefined)
            reflectionMergePartial<ExaminationRelationshipResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExaminationRelationshipResult): ExaminationRelationshipResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value id */ 1:
                    message.id = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Int64Value examinerAccountId */ 2:
                    message.examinerAccountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examinerAccountId);
                    break;
                case /* google.protobuf.Int64Value organizationId */ 3:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* bool examinable */ 4:
                    message.examinable = reader.bool();
                    break;
                case /* base.examination.ExamineeResult examinee */ 5:
                    message.examinee = ExamineeResult.internalBinaryRead(reader, reader.uint32(), options, message.examinee);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExaminationRelationshipResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value id = 1; */
        if (message.id)
            Int64Value.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value examinerAccountId = 2; */
        if (message.examinerAccountId)
            Int64Value.internalBinaryWrite(message.examinerAccountId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value organizationId = 3; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool examinable = 4; */
        if (message.examinable !== false)
            writer.tag(4, WireType.Varint).bool(message.examinable);
        /* base.examination.ExamineeResult examinee = 5; */
        if (message.examinee)
            ExamineeResult.internalBinaryWrite(message.examinee, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ExaminationRelationshipResult
 */
export const ExaminationRelationshipResult = new ExaminationRelationshipResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExaminersRequest$Type extends MessageType<ListExaminersRequest> {
    constructor() {
        super("base.examination.ListExaminersRequest", [
            { no: 2, name: "examinee_id", kind: "scalar", oneof: "examinee", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "examinee_account_id", kind: "scalar", oneof: "examinee", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<ListExaminersRequest>): ListExaminersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinee = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<ListExaminersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExaminersRequest): ListExaminersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examinee_id */ 2:
                    message.examinee = {
                        oneofKind: "examineeId",
                        examineeId: reader.int64().toString()
                    };
                    break;
                case /* int64 examinee_account_id */ 3:
                    message.examinee = {
                        oneofKind: "examineeAccountId",
                        examineeAccountId: reader.int64().toString()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExaminersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examinee_id = 2; */
        if (message.examinee.oneofKind === "examineeId")
            writer.tag(2, WireType.Varint).int64(message.examinee.examineeId);
        /* int64 examinee_account_id = 3; */
        if (message.examinee.oneofKind === "examineeAccountId")
            writer.tag(3, WireType.Varint).int64(message.examinee.examineeAccountId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ListExaminersRequest
 */
export const ListExaminersRequest = new ListExaminersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExaminersResponse$Type extends MessageType<ListExaminersResponse> {
    constructor() {
        super("base.examination.ListExaminersResponse", [
            { no: 1, name: "examiner_account_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<ListExaminersResponse>): ListExaminersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinerAccountIds = [];
        if (value !== undefined)
            reflectionMergePartial<ListExaminersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExaminersResponse): ListExaminersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 examiner_account_ids */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.examinerAccountIds.push(reader.int64().toString());
                    else
                        message.examinerAccountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExaminersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 examiner_account_ids = 1; */
        if (message.examinerAccountIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.examinerAccountIds.length; i++)
                writer.int64(message.examinerAccountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ListExaminersResponse
 */
export const ListExaminersResponse = new ListExaminersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ShareExamineeRequest$Type extends MessageType<ShareExamineeRequest> {
    constructor() {
        super("base.examination.ShareExamineeRequest", [
            { no: 1, name: "examineeId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "examinable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ShareExamineeRequest>): ShareExamineeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeId = "0";
        message.examinable = false;
        if (value !== undefined)
            reflectionMergePartial<ShareExamineeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ShareExamineeRequest): ShareExamineeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examineeId */ 1:
                    message.examineeId = reader.int64().toString();
                    break;
                case /* bool examinable */ 2:
                    message.examinable = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ShareExamineeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examineeId = 1; */
        if (message.examineeId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examineeId);
        /* bool examinable = 2; */
        if (message.examinable !== false)
            writer.tag(2, WireType.Varint).bool(message.examinable);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ShareExamineeRequest
 */
export const ShareExamineeRequest = new ShareExamineeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ShareExamineeResponse$Type extends MessageType<ShareExamineeResponse> {
    constructor() {
        super("base.examination.ShareExamineeResponse", [
            { no: 1, name: "done", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ShareExamineeResponse>): ShareExamineeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.done = false;
        if (value !== undefined)
            reflectionMergePartial<ShareExamineeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ShareExamineeResponse): ShareExamineeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool done */ 1:
                    message.done = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ShareExamineeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool done = 1; */
        if (message.done !== false)
            writer.tag(1, WireType.Varint).bool(message.done);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ShareExamineeResponse
 */
export const ShareExamineeResponse = new ShareExamineeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMyAllExaminersRequest$Type extends MessageType<GetMyAllExaminersRequest> {
    constructor() {
        super("base.examination.GetMyAllExaminersRequest", []);
    }
    create(value?: PartialMessage<GetMyAllExaminersRequest>): GetMyAllExaminersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetMyAllExaminersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMyAllExaminersRequest): GetMyAllExaminersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMyAllExaminersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetMyAllExaminersRequest
 */
export const GetMyAllExaminersRequest = new GetMyAllExaminersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMyAllExaminersResponse$Type extends MessageType<GetMyAllExaminersResponse> {
    constructor() {
        super("base.examination.GetMyAllExaminersResponse", [
            { no: 1, name: "examinerResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExaminerResult }
        ]);
    }
    create(value?: PartialMessage<GetMyAllExaminersResponse>): GetMyAllExaminersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinerResults = [];
        if (value !== undefined)
            reflectionMergePartial<GetMyAllExaminersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMyAllExaminersResponse): GetMyAllExaminersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ExaminerResult examinerResults */ 1:
                    message.examinerResults.push(ExaminerResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMyAllExaminersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ExaminerResult examinerResults = 1; */
        for (let i = 0; i < message.examinerResults.length; i++)
            ExaminerResult.internalBinaryWrite(message.examinerResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetMyAllExaminersResponse
 */
export const GetMyAllExaminersResponse = new GetMyAllExaminersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExaminerRequest$Type extends MessageType<CreateExaminerRequest> {
    constructor() {
        super("base.examination.CreateExaminerRequest", [
            { no: 1, name: "examinerInfo", kind: "message", T: () => ExaminerInfo }
        ]);
    }
    create(value?: PartialMessage<CreateExaminerRequest>): CreateExaminerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateExaminerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateExaminerRequest): CreateExaminerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.examination.ExaminerInfo examinerInfo */ 1:
                    message.examinerInfo = ExaminerInfo.internalBinaryRead(reader, reader.uint32(), options, message.examinerInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateExaminerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.examination.ExaminerInfo examinerInfo = 1; */
        if (message.examinerInfo)
            ExaminerInfo.internalBinaryWrite(message.examinerInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.CreateExaminerRequest
 */
export const CreateExaminerRequest = new CreateExaminerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExaminerResponse$Type extends MessageType<CreateExaminerResponse> {
    constructor() {
        super("base.examination.CreateExaminerResponse", [
            { no: 1, name: "examinerId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateExaminerResponse>): CreateExaminerResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinerId = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateExaminerResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateExaminerResponse): CreateExaminerResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examinerId */ 1:
                    message.examinerId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateExaminerResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examinerId = 1; */
        if (message.examinerId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examinerId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.CreateExaminerResponse
 */
export const CreateExaminerResponse = new CreateExaminerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExaminerByAccountIdRequest$Type extends MessageType<CreateExaminerByAccountIdRequest> {
    constructor() {
        super("base.examination.CreateExaminerByAccountIdRequest", [
            { no: 1, name: "examinerInfo", kind: "message", T: () => ExaminerInfo }
        ]);
    }
    create(value?: PartialMessage<CreateExaminerByAccountIdRequest>): CreateExaminerByAccountIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateExaminerByAccountIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateExaminerByAccountIdRequest): CreateExaminerByAccountIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.examination.ExaminerInfo examinerInfo */ 1:
                    message.examinerInfo = ExaminerInfo.internalBinaryRead(reader, reader.uint32(), options, message.examinerInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateExaminerByAccountIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.examination.ExaminerInfo examinerInfo = 1; */
        if (message.examinerInfo)
            ExaminerInfo.internalBinaryWrite(message.examinerInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.CreateExaminerByAccountIdRequest
 */
export const CreateExaminerByAccountIdRequest = new CreateExaminerByAccountIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExaminerByAccountIdRequest$Type extends MessageType<GetExaminerByAccountIdRequest> {
    constructor() {
        super("base.examination.GetExaminerByAccountIdRequest", [
            { no: 1, name: "examinerId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetExaminerByAccountIdRequest>): GetExaminerByAccountIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinerId = "0";
        if (value !== undefined)
            reflectionMergePartial<GetExaminerByAccountIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExaminerByAccountIdRequest): GetExaminerByAccountIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examinerId */ 1:
                    message.examinerId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExaminerByAccountIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examinerId = 1; */
        if (message.examinerId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examinerId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExaminerByAccountIdRequest
 */
export const GetExaminerByAccountIdRequest = new GetExaminerByAccountIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExaminerByAccountIdResponse$Type extends MessageType<CreateExaminerByAccountIdResponse> {
    constructor() {
        super("base.examination.CreateExaminerByAccountIdResponse", [
            { no: 1, name: "examinerId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateExaminerByAccountIdResponse>): CreateExaminerByAccountIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinerId = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateExaminerByAccountIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateExaminerByAccountIdResponse): CreateExaminerByAccountIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examinerId */ 1:
                    message.examinerId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateExaminerByAccountIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examinerId = 1; */
        if (message.examinerId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examinerId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.CreateExaminerByAccountIdResponse
 */
export const CreateExaminerByAccountIdResponse = new CreateExaminerByAccountIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddExamineeToExaminationRelationshipRequest$Type extends MessageType<AddExamineeToExaminationRelationshipRequest> {
    constructor() {
        super("base.examination.AddExamineeToExaminationRelationshipRequest", [
            { no: 1, name: "examineeId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<AddExamineeToExaminationRelationshipRequest>): AddExamineeToExaminationRelationshipRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeId = "0";
        if (value !== undefined)
            reflectionMergePartial<AddExamineeToExaminationRelationshipRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddExamineeToExaminationRelationshipRequest): AddExamineeToExaminationRelationshipRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examineeId */ 1:
                    message.examineeId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddExamineeToExaminationRelationshipRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examineeId = 1; */
        if (message.examineeId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examineeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.AddExamineeToExaminationRelationshipRequest
 */
export const AddExamineeToExaminationRelationshipRequest = new AddExamineeToExaminationRelationshipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddExamineeToExaminationRelationshipResponse$Type extends MessageType<AddExamineeToExaminationRelationshipResponse> {
    constructor() {
        super("base.examination.AddExamineeToExaminationRelationshipResponse", [
            { no: 1, name: "isadded", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AddExamineeToExaminationRelationshipResponse>): AddExamineeToExaminationRelationshipResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isadded = false;
        if (value !== undefined)
            reflectionMergePartial<AddExamineeToExaminationRelationshipResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddExamineeToExaminationRelationshipResponse): AddExamineeToExaminationRelationshipResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isadded */ 1:
                    message.isadded = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddExamineeToExaminationRelationshipResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isadded = 1; */
        if (message.isadded !== false)
            writer.tag(1, WireType.Varint).bool(message.isadded);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.AddExamineeToExaminationRelationshipResponse
 */
export const AddExamineeToExaminationRelationshipResponse = new AddExamineeToExaminationRelationshipResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddExamineeRequest$Type extends MessageType<AddExamineeRequest> {
    constructor() {
        super("base.examination.AddExamineeRequest", [
            { no: 1, name: "name", kind: "message", T: () => StringValue },
            { no: 2, name: "gender", kind: "enum", T: () => ["base.examination.Gender", Gender] },
            { no: 3, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 5, name: "birthTimeStamp", kind: "message", T: () => Int64Value },
            { no: 6, name: "age", kind: "message", T: () => Int32Value },
            { no: 7, name: "phone", kind: "message", T: () => StringValue },
            { no: 8, name: "heightScalar", kind: "message", T: () => StringValue },
            { no: 9, name: "heightUnit", kind: "message", T: () => StringValue },
            { no: 10, name: "weightScalar", kind: "message", T: () => StringValue },
            { no: 11, name: "weightUnit", kind: "message", T: () => StringValue },
            { no: 12, name: "userId", kind: "message", T: () => Int64Value },
            { no: 13, name: "userType", kind: "message", T: () => StringValue },
            { no: 14, name: "examinable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "client", kind: "message", T: () => StringValue },
            { no: 16, name: "description", kind: "message", T: () => StringValue },
            { no: 17, name: "inPerson", kind: "message", T: () => BoolValue },
            { no: 18, name: "email", kind: "message", T: () => StringValue },
            { no: 19, name: "idNumber", kind: "message", T: () => StringValue },
            { no: 20, name: "patient_id", kind: "message", T: () => StringValue },
            { no: 21, name: "symptoms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AddExamineeRequest>): AddExamineeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.gender = 0;
        message.examinable = false;
        message.symptoms = [];
        if (value !== undefined)
            reflectionMergePartial<AddExamineeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddExamineeRequest): AddExamineeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.StringValue name */ 1:
                    message.name = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                case /* base.examination.Gender gender */ 2:
                    message.gender = reader.int32();
                    break;
                case /* google.protobuf.Int64Value organizationId */ 3:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.Int64Value birthTimeStamp */ 5:
                    message.birthTimeStamp = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.birthTimeStamp);
                    break;
                case /* google.protobuf.Int32Value age */ 6:
                    message.age = Int32Value.internalBinaryRead(reader, reader.uint32(), options, message.age);
                    break;
                case /* google.protobuf.StringValue phone */ 7:
                    message.phone = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.phone);
                    break;
                case /* google.protobuf.StringValue heightScalar */ 8:
                    message.heightScalar = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.heightScalar);
                    break;
                case /* google.protobuf.StringValue heightUnit */ 9:
                    message.heightUnit = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.heightUnit);
                    break;
                case /* google.protobuf.StringValue weightScalar */ 10:
                    message.weightScalar = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.weightScalar);
                    break;
                case /* google.protobuf.StringValue weightUnit */ 11:
                    message.weightUnit = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.weightUnit);
                    break;
                case /* google.protobuf.Int64Value userId */ 12:
                    message.userId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.userId);
                    break;
                case /* google.protobuf.StringValue userType */ 13:
                    message.userType = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.userType);
                    break;
                case /* bool examinable */ 14:
                    message.examinable = reader.bool();
                    break;
                case /* google.protobuf.StringValue client */ 15:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                case /* google.protobuf.StringValue description */ 16:
                    message.description = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.description);
                    break;
                case /* google.protobuf.BoolValue inPerson */ 17:
                    message.inPerson = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.inPerson);
                    break;
                case /* google.protobuf.StringValue email */ 18:
                    message.email = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.email);
                    break;
                case /* google.protobuf.StringValue idNumber */ 19:
                    message.idNumber = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.idNumber);
                    break;
                case /* google.protobuf.StringValue patient_id */ 20:
                    message.patientId = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.patientId);
                    break;
                case /* repeated string symptoms */ 21:
                    message.symptoms.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddExamineeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.StringValue name = 1; */
        if (message.name)
            StringValue.internalBinaryWrite(message.name, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* base.examination.Gender gender = 2; */
        if (message.gender !== 0)
            writer.tag(2, WireType.Varint).int32(message.gender);
        /* google.protobuf.Int64Value organizationId = 3; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value birthTimeStamp = 5; */
        if (message.birthTimeStamp)
            Int64Value.internalBinaryWrite(message.birthTimeStamp, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int32Value age = 6; */
        if (message.age)
            Int32Value.internalBinaryWrite(message.age, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue phone = 7; */
        if (message.phone)
            StringValue.internalBinaryWrite(message.phone, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue heightScalar = 8; */
        if (message.heightScalar)
            StringValue.internalBinaryWrite(message.heightScalar, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue heightUnit = 9; */
        if (message.heightUnit)
            StringValue.internalBinaryWrite(message.heightUnit, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue weightScalar = 10; */
        if (message.weightScalar)
            StringValue.internalBinaryWrite(message.weightScalar, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue weightUnit = 11; */
        if (message.weightUnit)
            StringValue.internalBinaryWrite(message.weightUnit, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value userId = 12; */
        if (message.userId)
            Int64Value.internalBinaryWrite(message.userId, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue userType = 13; */
        if (message.userType)
            StringValue.internalBinaryWrite(message.userType, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* bool examinable = 14; */
        if (message.examinable !== false)
            writer.tag(14, WireType.Varint).bool(message.examinable);
        /* google.protobuf.StringValue client = 15; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue description = 16; */
        if (message.description)
            StringValue.internalBinaryWrite(message.description, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.BoolValue inPerson = 17; */
        if (message.inPerson)
            BoolValue.internalBinaryWrite(message.inPerson, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue email = 18; */
        if (message.email)
            StringValue.internalBinaryWrite(message.email, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue idNumber = 19; */
        if (message.idNumber)
            StringValue.internalBinaryWrite(message.idNumber, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue patient_id = 20; */
        if (message.patientId)
            StringValue.internalBinaryWrite(message.patientId, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* repeated string symptoms = 21; */
        for (let i = 0; i < message.symptoms.length; i++)
            writer.tag(21, WireType.LengthDelimited).string(message.symptoms[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.AddExamineeRequest
 */
export const AddExamineeRequest = new AddExamineeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddExamineeByAccountIdRequest$Type extends MessageType<AddExamineeByAccountIdRequest> {
    constructor() {
        super("base.examination.AddExamineeByAccountIdRequest", [
            { no: 1, name: "name", kind: "message", T: () => StringValue },
            { no: 2, name: "gender", kind: "enum", T: () => ["base.examination.Gender", Gender] },
            { no: 3, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 4, name: "creatorAccountId", kind: "message", T: () => Int64Value },
            { no: 5, name: "birthTimeStamp", kind: "message", T: () => Int64Value },
            { no: 6, name: "age", kind: "message", T: () => Int32Value },
            { no: 7, name: "phone", kind: "message", T: () => StringValue },
            { no: 8, name: "heightScalar", kind: "message", T: () => StringValue },
            { no: 9, name: "heightUnit", kind: "message", T: () => StringValue },
            { no: 10, name: "weightScalar", kind: "message", T: () => StringValue },
            { no: 11, name: "weightUnit", kind: "message", T: () => StringValue },
            { no: 12, name: "accountId", kind: "message", T: () => Int64Value },
            { no: 13, name: "client", kind: "message", T: () => StringValue },
            { no: 14, name: "description", kind: "message", T: () => StringValue },
            { no: 15, name: "inPerson", kind: "message", T: () => BoolValue },
            { no: 16, name: "email", kind: "message", T: () => StringValue },
            { no: 17, name: "idNumber", kind: "message", T: () => StringValue },
            { no: 18, name: "patient_id", kind: "message", T: () => StringValue },
            { no: 21, name: "symptoms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AddExamineeByAccountIdRequest>): AddExamineeByAccountIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.gender = 0;
        message.symptoms = [];
        if (value !== undefined)
            reflectionMergePartial<AddExamineeByAccountIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddExamineeByAccountIdRequest): AddExamineeByAccountIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.StringValue name */ 1:
                    message.name = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                case /* base.examination.Gender gender */ 2:
                    message.gender = reader.int32();
                    break;
                case /* google.protobuf.Int64Value organizationId */ 3:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.Int64Value creatorAccountId */ 4:
                    message.creatorAccountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.creatorAccountId);
                    break;
                case /* google.protobuf.Int64Value birthTimeStamp */ 5:
                    message.birthTimeStamp = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.birthTimeStamp);
                    break;
                case /* google.protobuf.Int32Value age */ 6:
                    message.age = Int32Value.internalBinaryRead(reader, reader.uint32(), options, message.age);
                    break;
                case /* google.protobuf.StringValue phone */ 7:
                    message.phone = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.phone);
                    break;
                case /* google.protobuf.StringValue heightScalar */ 8:
                    message.heightScalar = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.heightScalar);
                    break;
                case /* google.protobuf.StringValue heightUnit */ 9:
                    message.heightUnit = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.heightUnit);
                    break;
                case /* google.protobuf.StringValue weightScalar */ 10:
                    message.weightScalar = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.weightScalar);
                    break;
                case /* google.protobuf.StringValue weightUnit */ 11:
                    message.weightUnit = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.weightUnit);
                    break;
                case /* google.protobuf.Int64Value accountId */ 12:
                    message.accountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                case /* google.protobuf.StringValue client */ 13:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                case /* google.protobuf.StringValue description */ 14:
                    message.description = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.description);
                    break;
                case /* google.protobuf.BoolValue inPerson */ 15:
                    message.inPerson = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.inPerson);
                    break;
                case /* google.protobuf.StringValue email */ 16:
                    message.email = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.email);
                    break;
                case /* google.protobuf.StringValue idNumber */ 17:
                    message.idNumber = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.idNumber);
                    break;
                case /* google.protobuf.StringValue patient_id */ 18:
                    message.patientId = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.patientId);
                    break;
                case /* repeated string symptoms */ 21:
                    message.symptoms.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddExamineeByAccountIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.StringValue name = 1; */
        if (message.name)
            StringValue.internalBinaryWrite(message.name, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* base.examination.Gender gender = 2; */
        if (message.gender !== 0)
            writer.tag(2, WireType.Varint).int32(message.gender);
        /* google.protobuf.Int64Value organizationId = 3; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value creatorAccountId = 4; */
        if (message.creatorAccountId)
            Int64Value.internalBinaryWrite(message.creatorAccountId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value birthTimeStamp = 5; */
        if (message.birthTimeStamp)
            Int64Value.internalBinaryWrite(message.birthTimeStamp, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int32Value age = 6; */
        if (message.age)
            Int32Value.internalBinaryWrite(message.age, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue phone = 7; */
        if (message.phone)
            StringValue.internalBinaryWrite(message.phone, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue heightScalar = 8; */
        if (message.heightScalar)
            StringValue.internalBinaryWrite(message.heightScalar, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue heightUnit = 9; */
        if (message.heightUnit)
            StringValue.internalBinaryWrite(message.heightUnit, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue weightScalar = 10; */
        if (message.weightScalar)
            StringValue.internalBinaryWrite(message.weightScalar, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue weightUnit = 11; */
        if (message.weightUnit)
            StringValue.internalBinaryWrite(message.weightUnit, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value accountId = 12; */
        if (message.accountId)
            Int64Value.internalBinaryWrite(message.accountId, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue client = 13; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue description = 14; */
        if (message.description)
            StringValue.internalBinaryWrite(message.description, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.BoolValue inPerson = 15; */
        if (message.inPerson)
            BoolValue.internalBinaryWrite(message.inPerson, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue email = 16; */
        if (message.email)
            StringValue.internalBinaryWrite(message.email, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue idNumber = 17; */
        if (message.idNumber)
            StringValue.internalBinaryWrite(message.idNumber, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue patient_id = 18; */
        if (message.patientId)
            StringValue.internalBinaryWrite(message.patientId, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* repeated string symptoms = 21; */
        for (let i = 0; i < message.symptoms.length; i++)
            writer.tag(21, WireType.LengthDelimited).string(message.symptoms[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.AddExamineeByAccountIdRequest
 */
export const AddExamineeByAccountIdRequest = new AddExamineeByAccountIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddExamineeResponse$Type extends MessageType<AddExamineeResponse> {
    constructor() {
        super("base.examination.AddExamineeResponse", [
            { no: 1, name: "examineeId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "examinee", kind: "message", T: () => ExamineeResult }
        ]);
    }
    create(value?: PartialMessage<AddExamineeResponse>): AddExamineeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeId = "0";
        if (value !== undefined)
            reflectionMergePartial<AddExamineeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddExamineeResponse): AddExamineeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examineeId */ 1:
                    message.examineeId = reader.int64().toString();
                    break;
                case /* base.examination.ExamineeResult examinee */ 2:
                    message.examinee = ExamineeResult.internalBinaryRead(reader, reader.uint32(), options, message.examinee);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddExamineeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examineeId = 1; */
        if (message.examineeId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examineeId);
        /* base.examination.ExamineeResult examinee = 2; */
        if (message.examinee)
            ExamineeResult.internalBinaryWrite(message.examinee, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.AddExamineeResponse
 */
export const AddExamineeResponse = new AddExamineeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddExamineeByAccountIdResponse$Type extends MessageType<AddExamineeByAccountIdResponse> {
    constructor() {
        super("base.examination.AddExamineeByAccountIdResponse", [
            { no: 1, name: "examineeId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<AddExamineeByAccountIdResponse>): AddExamineeByAccountIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeId = "0";
        if (value !== undefined)
            reflectionMergePartial<AddExamineeByAccountIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddExamineeByAccountIdResponse): AddExamineeByAccountIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examineeId */ 1:
                    message.examineeId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddExamineeByAccountIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examineeId = 1; */
        if (message.examineeId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examineeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.AddExamineeByAccountIdResponse
 */
export const AddExamineeByAccountIdResponse = new AddExamineeByAccountIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddExamineeMyselfRequest$Type extends MessageType<AddExamineeMyselfRequest> {
    constructor() {
        super("base.examination.AddExamineeMyselfRequest", [
            { no: 1, name: "name", kind: "message", T: () => StringValue },
            { no: 2, name: "gender", kind: "enum", T: () => ["base.examination.Gender", Gender] },
            { no: 3, name: "organizationId", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<AddExamineeMyselfRequest>): AddExamineeMyselfRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.gender = 0;
        if (value !== undefined)
            reflectionMergePartial<AddExamineeMyselfRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddExamineeMyselfRequest): AddExamineeMyselfRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.StringValue name */ 1:
                    message.name = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                case /* base.examination.Gender gender */ 2:
                    message.gender = reader.int32();
                    break;
                case /* google.protobuf.Int64Value organizationId */ 3:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddExamineeMyselfRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.StringValue name = 1; */
        if (message.name)
            StringValue.internalBinaryWrite(message.name, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* base.examination.Gender gender = 2; */
        if (message.gender !== 0)
            writer.tag(2, WireType.Varint).int32(message.gender);
        /* google.protobuf.Int64Value organizationId = 3; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.AddExamineeMyselfRequest
 */
export const AddExamineeMyselfRequest = new AddExamineeMyselfRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddExamineeMyselfResponse$Type extends MessageType<AddExamineeMyselfResponse> {
    constructor() {
        super("base.examination.AddExamineeMyselfResponse", [
            { no: 1, name: "examineeId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<AddExamineeMyselfResponse>): AddExamineeMyselfResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeId = "0";
        if (value !== undefined)
            reflectionMergePartial<AddExamineeMyselfResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddExamineeMyselfResponse): AddExamineeMyselfResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examineeId */ 1:
                    message.examineeId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddExamineeMyselfResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examineeId = 1; */
        if (message.examineeId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examineeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.AddExamineeMyselfResponse
 */
export const AddExamineeMyselfResponse = new AddExamineeMyselfResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExamineeRequest$Type extends MessageType<CreateExamineeRequest> {
    constructor() {
        super("base.examination.CreateExamineeRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "gender", kind: "enum", T: () => ["base.examination.Gender", Gender] },
            { no: 3, name: "birthdate", kind: "message", T: () => Timestamp },
            { no: 4, name: "height", kind: "message", T: () => Int32Value },
            { no: 5, name: "weight", kind: "message", T: () => Int32Value },
            { no: 6, name: "description", kind: "message", T: () => StringValue },
            { no: 7, name: "symptoms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "phone_number", kind: "message", T: () => StringValue },
            { no: 9, name: "email", kind: "message", T: () => StringValue },
            { no: 10, name: "id_number", kind: "message", T: () => StringValue },
            { no: 11, name: "creator_account_id", kind: "message", T: () => Int64Value },
            { no: 12, name: "examinee_account_id", kind: "message", T: () => Int64Value },
            { no: 13, name: "client", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<CreateExamineeRequest>): CreateExamineeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.gender = 0;
        message.symptoms = [];
        if (value !== undefined)
            reflectionMergePartial<CreateExamineeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateExamineeRequest): CreateExamineeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* base.examination.Gender gender */ 2:
                    message.gender = reader.int32();
                    break;
                case /* google.protobuf.Timestamp birthdate */ 3:
                    message.birthdate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.birthdate);
                    break;
                case /* google.protobuf.Int32Value height */ 4:
                    message.height = Int32Value.internalBinaryRead(reader, reader.uint32(), options, message.height);
                    break;
                case /* google.protobuf.Int32Value weight */ 5:
                    message.weight = Int32Value.internalBinaryRead(reader, reader.uint32(), options, message.weight);
                    break;
                case /* google.protobuf.StringValue description */ 6:
                    message.description = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.description);
                    break;
                case /* repeated string symptoms */ 7:
                    message.symptoms.push(reader.string());
                    break;
                case /* google.protobuf.StringValue phone_number */ 8:
                    message.phoneNumber = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.phoneNumber);
                    break;
                case /* google.protobuf.StringValue email */ 9:
                    message.email = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.email);
                    break;
                case /* google.protobuf.StringValue id_number */ 10:
                    message.idNumber = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.idNumber);
                    break;
                case /* google.protobuf.Int64Value creator_account_id */ 11:
                    message.creatorAccountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.creatorAccountId);
                    break;
                case /* google.protobuf.Int64Value examinee_account_id */ 12:
                    message.examineeAccountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examineeAccountId);
                    break;
                case /* google.protobuf.StringValue client */ 13:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateExamineeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* base.examination.Gender gender = 2; */
        if (message.gender !== 0)
            writer.tag(2, WireType.Varint).int32(message.gender);
        /* google.protobuf.Timestamp birthdate = 3; */
        if (message.birthdate)
            Timestamp.internalBinaryWrite(message.birthdate, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int32Value height = 4; */
        if (message.height)
            Int32Value.internalBinaryWrite(message.height, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int32Value weight = 5; */
        if (message.weight)
            Int32Value.internalBinaryWrite(message.weight, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue description = 6; */
        if (message.description)
            StringValue.internalBinaryWrite(message.description, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated string symptoms = 7; */
        for (let i = 0; i < message.symptoms.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.symptoms[i]);
        /* google.protobuf.StringValue phone_number = 8; */
        if (message.phoneNumber)
            StringValue.internalBinaryWrite(message.phoneNumber, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue email = 9; */
        if (message.email)
            StringValue.internalBinaryWrite(message.email, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue id_number = 10; */
        if (message.idNumber)
            StringValue.internalBinaryWrite(message.idNumber, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value creator_account_id = 11; */
        if (message.creatorAccountId)
            Int64Value.internalBinaryWrite(message.creatorAccountId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value examinee_account_id = 12; */
        if (message.examineeAccountId)
            Int64Value.internalBinaryWrite(message.examineeAccountId, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue client = 13; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.CreateExamineeRequest
 */
export const CreateExamineeRequest = new CreateExamineeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExamineeResponse$Type extends MessageType<CreateExamineeResponse> {
    constructor() {
        super("base.examination.CreateExamineeResponse", [
            { no: 1, name: "examinee_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateExamineeResponse>): CreateExamineeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeId = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateExamineeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateExamineeResponse): CreateExamineeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examinee_id */ 1:
                    message.examineeId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateExamineeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examinee_id = 1; */
        if (message.examineeId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examineeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.CreateExamineeResponse
 */
export const CreateExamineeResponse = new CreateExamineeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchCreateExamineesRequest$Type extends MessageType<BatchCreateExamineesRequest> {
    constructor() {
        super("base.examination.BatchCreateExamineesRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "creator_account_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "client", kind: "message", T: () => StringValue },
            { no: 4, name: "examinees", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BatchCreateExamineesRequest_Examinee },
            { no: 5, name: "relate_account_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<BatchCreateExamineesRequest>): BatchCreateExamineesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        message.creatorAccountId = "0";
        message.examinees = [];
        message.relateAccountIds = [];
        if (value !== undefined)
            reflectionMergePartial<BatchCreateExamineesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BatchCreateExamineesRequest): BatchCreateExamineesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organization_id */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* int64 creator_account_id */ 2:
                    message.creatorAccountId = reader.int64().toString();
                    break;
                case /* google.protobuf.StringValue client */ 3:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                case /* repeated base.examination.BatchCreateExamineesRequest.Examinee examinees */ 4:
                    message.examinees.push(BatchCreateExamineesRequest_Examinee.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated int64 relate_account_ids */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.relateAccountIds.push(reader.int64().toString());
                    else
                        message.relateAccountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BatchCreateExamineesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organization_id = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* int64 creator_account_id = 2; */
        if (message.creatorAccountId !== "0")
            writer.tag(2, WireType.Varint).int64(message.creatorAccountId);
        /* google.protobuf.StringValue client = 3; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated base.examination.BatchCreateExamineesRequest.Examinee examinees = 4; */
        for (let i = 0; i < message.examinees.length; i++)
            BatchCreateExamineesRequest_Examinee.internalBinaryWrite(message.examinees[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated int64 relate_account_ids = 5; */
        if (message.relateAccountIds.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.relateAccountIds.length; i++)
                writer.int64(message.relateAccountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.BatchCreateExamineesRequest
 */
export const BatchCreateExamineesRequest = new BatchCreateExamineesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchCreateExamineesRequest_Examinee$Type extends MessageType<BatchCreateExamineesRequest_Examinee> {
    constructor() {
        super("base.examination.BatchCreateExamineesRequest.Examinee", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "gender", kind: "enum", T: () => ["base.examination.Gender", Gender] },
            { no: 3, name: "birth_date", kind: "message", T: () => Timestamp },
            { no: 4, name: "height", kind: "message", T: () => Int32Value },
            { no: 5, name: "weight", kind: "message", T: () => Int32Value },
            { no: 6, name: "phone_number", kind: "message", T: () => StringValue },
            { no: 7, name: "description", kind: "message", T: () => StringValue },
            { no: 21, name: "symptoms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<BatchCreateExamineesRequest_Examinee>): BatchCreateExamineesRequest_Examinee {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.gender = 0;
        message.symptoms = [];
        if (value !== undefined)
            reflectionMergePartial<BatchCreateExamineesRequest_Examinee>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BatchCreateExamineesRequest_Examinee): BatchCreateExamineesRequest_Examinee {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* base.examination.Gender gender */ 2:
                    message.gender = reader.int32();
                    break;
                case /* google.protobuf.Timestamp birth_date */ 3:
                    message.birthDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.birthDate);
                    break;
                case /* google.protobuf.Int32Value height */ 4:
                    message.height = Int32Value.internalBinaryRead(reader, reader.uint32(), options, message.height);
                    break;
                case /* google.protobuf.Int32Value weight */ 5:
                    message.weight = Int32Value.internalBinaryRead(reader, reader.uint32(), options, message.weight);
                    break;
                case /* google.protobuf.StringValue phone_number */ 6:
                    message.phoneNumber = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.phoneNumber);
                    break;
                case /* google.protobuf.StringValue description */ 7:
                    message.description = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.description);
                    break;
                case /* repeated string symptoms */ 21:
                    message.symptoms.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BatchCreateExamineesRequest_Examinee, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* base.examination.Gender gender = 2; */
        if (message.gender !== 0)
            writer.tag(2, WireType.Varint).int32(message.gender);
        /* google.protobuf.Timestamp birth_date = 3; */
        if (message.birthDate)
            Timestamp.internalBinaryWrite(message.birthDate, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int32Value height = 4; */
        if (message.height)
            Int32Value.internalBinaryWrite(message.height, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int32Value weight = 5; */
        if (message.weight)
            Int32Value.internalBinaryWrite(message.weight, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue phone_number = 6; */
        if (message.phoneNumber)
            StringValue.internalBinaryWrite(message.phoneNumber, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue description = 7; */
        if (message.description)
            StringValue.internalBinaryWrite(message.description, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated string symptoms = 21; */
        for (let i = 0; i < message.symptoms.length; i++)
            writer.tag(21, WireType.LengthDelimited).string(message.symptoms[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.BatchCreateExamineesRequest.Examinee
 */
export const BatchCreateExamineesRequest_Examinee = new BatchCreateExamineesRequest_Examinee$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchCreateExamineesResponse$Type extends MessageType<BatchCreateExamineesResponse> {
    constructor() {
        super("base.examination.BatchCreateExamineesResponse", [
            { no: 1, name: "examinees", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BatchCreateExamineesResponse_Examinee }
        ]);
    }
    create(value?: PartialMessage<BatchCreateExamineesResponse>): BatchCreateExamineesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinees = [];
        if (value !== undefined)
            reflectionMergePartial<BatchCreateExamineesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BatchCreateExamineesResponse): BatchCreateExamineesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.BatchCreateExamineesResponse.Examinee examinees */ 1:
                    message.examinees.push(BatchCreateExamineesResponse_Examinee.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BatchCreateExamineesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.BatchCreateExamineesResponse.Examinee examinees = 1; */
        for (let i = 0; i < message.examinees.length; i++)
            BatchCreateExamineesResponse_Examinee.internalBinaryWrite(message.examinees[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.BatchCreateExamineesResponse
 */
export const BatchCreateExamineesResponse = new BatchCreateExamineesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchCreateExamineesResponse_Examinee$Type extends MessageType<BatchCreateExamineesResponse_Examinee> {
    constructor() {
        super("base.examination.BatchCreateExamineesResponse.Examinee", [
            { no: 1, name: "organization_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "creator_account_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "client", kind: "message", T: () => StringValue },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "gender", kind: "enum", T: () => ["base.examination.Gender", Gender] },
            { no: 6, name: "birth_date", kind: "message", T: () => Timestamp },
            { no: 7, name: "age", kind: "message", T: () => Int32Value },
            { no: 8, name: "height", kind: "message", T: () => Int32Value },
            { no: 9, name: "height_unit", kind: "message", T: () => StringValue },
            { no: 10, name: "weight", kind: "message", T: () => Int32Value },
            { no: 11, name: "weight_unit", kind: "message", T: () => StringValue },
            { no: 12, name: "phone_number", kind: "message", T: () => StringValue },
            { no: 13, name: "description", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<BatchCreateExamineesResponse_Examinee>): BatchCreateExamineesResponse_Examinee {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        message.creatorAccountId = "0";
        message.name = "";
        message.gender = 0;
        if (value !== undefined)
            reflectionMergePartial<BatchCreateExamineesResponse_Examinee>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BatchCreateExamineesResponse_Examinee): BatchCreateExamineesResponse_Examinee {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organization_id */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* int64 creator_account_id */ 2:
                    message.creatorAccountId = reader.int64().toString();
                    break;
                case /* google.protobuf.StringValue client */ 3:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                case /* base.examination.Gender gender */ 5:
                    message.gender = reader.int32();
                    break;
                case /* google.protobuf.Timestamp birth_date */ 6:
                    message.birthDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.birthDate);
                    break;
                case /* google.protobuf.Int32Value age */ 7:
                    message.age = Int32Value.internalBinaryRead(reader, reader.uint32(), options, message.age);
                    break;
                case /* google.protobuf.Int32Value height */ 8:
                    message.height = Int32Value.internalBinaryRead(reader, reader.uint32(), options, message.height);
                    break;
                case /* google.protobuf.StringValue height_unit */ 9:
                    message.heightUnit = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.heightUnit);
                    break;
                case /* google.protobuf.Int32Value weight */ 10:
                    message.weight = Int32Value.internalBinaryRead(reader, reader.uint32(), options, message.weight);
                    break;
                case /* google.protobuf.StringValue weight_unit */ 11:
                    message.weightUnit = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.weightUnit);
                    break;
                case /* google.protobuf.StringValue phone_number */ 12:
                    message.phoneNumber = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.phoneNumber);
                    break;
                case /* google.protobuf.StringValue description */ 13:
                    message.description = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.description);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BatchCreateExamineesResponse_Examinee, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organization_id = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* int64 creator_account_id = 2; */
        if (message.creatorAccountId !== "0")
            writer.tag(2, WireType.Varint).int64(message.creatorAccountId);
        /* google.protobuf.StringValue client = 3; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        /* base.examination.Gender gender = 5; */
        if (message.gender !== 0)
            writer.tag(5, WireType.Varint).int32(message.gender);
        /* google.protobuf.Timestamp birth_date = 6; */
        if (message.birthDate)
            Timestamp.internalBinaryWrite(message.birthDate, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int32Value age = 7; */
        if (message.age)
            Int32Value.internalBinaryWrite(message.age, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int32Value height = 8; */
        if (message.height)
            Int32Value.internalBinaryWrite(message.height, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue height_unit = 9; */
        if (message.heightUnit)
            StringValue.internalBinaryWrite(message.heightUnit, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int32Value weight = 10; */
        if (message.weight)
            Int32Value.internalBinaryWrite(message.weight, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue weight_unit = 11; */
        if (message.weightUnit)
            StringValue.internalBinaryWrite(message.weightUnit, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue phone_number = 12; */
        if (message.phoneNumber)
            StringValue.internalBinaryWrite(message.phoneNumber, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue description = 13; */
        if (message.description)
            StringValue.internalBinaryWrite(message.description, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.BatchCreateExamineesResponse.Examinee
 */
export const BatchCreateExamineesResponse_Examinee = new BatchCreateExamineesResponse_Examinee$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPresignedPutObjectUrlRequest$Type extends MessageType<GetPresignedPutObjectUrlRequest> {
    constructor() {
        super("base.examination.GetPresignedPutObjectUrlRequest", [
            { no: 1, name: "object_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetPresignedPutObjectUrlRequest>): GetPresignedPutObjectUrlRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.objectType = "";
        message.key = "";
        if (value !== undefined)
            reflectionMergePartial<GetPresignedPutObjectUrlRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPresignedPutObjectUrlRequest): GetPresignedPutObjectUrlRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string object_type */ 1:
                    message.objectType = reader.string();
                    break;
                case /* string key */ 2:
                    message.key = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPresignedPutObjectUrlRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string object_type = 1; */
        if (message.objectType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.objectType);
        /* string key = 2; */
        if (message.key !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.key);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetPresignedPutObjectUrlRequest
 */
export const GetPresignedPutObjectUrlRequest = new GetPresignedPutObjectUrlRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPresignedPutObjectUrlResponse$Type extends MessageType<GetPresignedPutObjectUrlResponse> {
    constructor() {
        super("base.examination.GetPresignedPutObjectUrlResponse", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetPresignedPutObjectUrlResponse>): GetPresignedPutObjectUrlResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.key = "";
        message.url = "";
        if (value !== undefined)
            reflectionMergePartial<GetPresignedPutObjectUrlResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPresignedPutObjectUrlResponse): GetPresignedPutObjectUrlResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* string url */ 2:
                    message.url = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPresignedPutObjectUrlResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* string url = 2; */
        if (message.url !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.url);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetPresignedPutObjectUrlResponse
 */
export const GetPresignedPutObjectUrlResponse = new GetPresignedPutObjectUrlResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchCreateExamineesWithExcelRequest$Type extends MessageType<BatchCreateExamineesWithExcelRequest> {
    constructor() {
        super("base.examination.BatchCreateExamineesWithExcelRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "creator_account_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "client", kind: "message", T: () => StringValue },
            { no: 4, name: "filename", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "relate_account_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<BatchCreateExamineesWithExcelRequest>): BatchCreateExamineesWithExcelRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        message.creatorAccountId = "0";
        message.filename = "";
        message.relateAccountIds = [];
        if (value !== undefined)
            reflectionMergePartial<BatchCreateExamineesWithExcelRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BatchCreateExamineesWithExcelRequest): BatchCreateExamineesWithExcelRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organization_id */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* int64 creator_account_id */ 2:
                    message.creatorAccountId = reader.int64().toString();
                    break;
                case /* google.protobuf.StringValue client */ 3:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                case /* string filename */ 4:
                    message.filename = reader.string();
                    break;
                case /* repeated int64 relate_account_ids */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.relateAccountIds.push(reader.int64().toString());
                    else
                        message.relateAccountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BatchCreateExamineesWithExcelRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organization_id = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* int64 creator_account_id = 2; */
        if (message.creatorAccountId !== "0")
            writer.tag(2, WireType.Varint).int64(message.creatorAccountId);
        /* google.protobuf.StringValue client = 3; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string filename = 4; */
        if (message.filename !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.filename);
        /* repeated int64 relate_account_ids = 5; */
        if (message.relateAccountIds.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.relateAccountIds.length; i++)
                writer.int64(message.relateAccountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.BatchCreateExamineesWithExcelRequest
 */
export const BatchCreateExamineesWithExcelRequest = new BatchCreateExamineesWithExcelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchCreateExamineesWithExcelResponse$Type extends MessageType<BatchCreateExamineesWithExcelResponse> {
    constructor() {
        super("base.examination.BatchCreateExamineesWithExcelResponse", [
            { no: 1, name: "valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "invalid_row_descriptions", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<BatchCreateExamineesWithExcelResponse>): BatchCreateExamineesWithExcelResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.valid = false;
        message.invalidRowDescriptions = [];
        if (value !== undefined)
            reflectionMergePartial<BatchCreateExamineesWithExcelResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BatchCreateExamineesWithExcelResponse): BatchCreateExamineesWithExcelResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool valid */ 1:
                    message.valid = reader.bool();
                    break;
                case /* repeated string invalid_row_descriptions */ 2:
                    message.invalidRowDescriptions.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BatchCreateExamineesWithExcelResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool valid = 1; */
        if (message.valid !== false)
            writer.tag(1, WireType.Varint).bool(message.valid);
        /* repeated string invalid_row_descriptions = 2; */
        for (let i = 0; i < message.invalidRowDescriptions.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.invalidRowDescriptions[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.BatchCreateExamineesWithExcelResponse
 */
export const BatchCreateExamineesWithExcelResponse = new BatchCreateExamineesWithExcelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBatchCreateExamineesExcelTemplateResponse$Type extends MessageType<GetBatchCreateExamineesExcelTemplateResponse> {
    constructor() {
        super("base.examination.GetBatchCreateExamineesExcelTemplateResponse", [
            { no: 1, name: "template_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetBatchCreateExamineesExcelTemplateResponse>): GetBatchCreateExamineesExcelTemplateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.templateUrl = "";
        if (value !== undefined)
            reflectionMergePartial<GetBatchCreateExamineesExcelTemplateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetBatchCreateExamineesExcelTemplateResponse): GetBatchCreateExamineesExcelTemplateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string template_url */ 1:
                    message.templateUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetBatchCreateExamineesExcelTemplateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string template_url = 1; */
        if (message.templateUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.templateUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetBatchCreateExamineesExcelTemplateResponse
 */
export const GetBatchCreateExamineesExcelTemplateResponse = new GetBatchCreateExamineesExcelTemplateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BindExamineeToExaminerRequest$Type extends MessageType<BindExamineeToExaminerRequest> {
    constructor() {
        super("base.examination.BindExamineeToExaminerRequest", [
            { no: 1, name: "examiner_account_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "examinee_id", kind: "scalar", oneof: "examinee", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "examinee_account_id", kind: "scalar", oneof: "examinee", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<BindExamineeToExaminerRequest>): BindExamineeToExaminerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinerAccountId = "0";
        message.examinee = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<BindExamineeToExaminerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BindExamineeToExaminerRequest): BindExamineeToExaminerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examiner_account_id */ 1:
                    message.examinerAccountId = reader.int64().toString();
                    break;
                case /* int64 examinee_id */ 2:
                    message.examinee = {
                        oneofKind: "examineeId",
                        examineeId: reader.int64().toString()
                    };
                    break;
                case /* int64 examinee_account_id */ 3:
                    message.examinee = {
                        oneofKind: "examineeAccountId",
                        examineeAccountId: reader.int64().toString()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BindExamineeToExaminerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examiner_account_id = 1; */
        if (message.examinerAccountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examinerAccountId);
        /* int64 examinee_id = 2; */
        if (message.examinee.oneofKind === "examineeId")
            writer.tag(2, WireType.Varint).int64(message.examinee.examineeId);
        /* int64 examinee_account_id = 3; */
        if (message.examinee.oneofKind === "examineeAccountId")
            writer.tag(3, WireType.Varint).int64(message.examinee.examineeAccountId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.BindExamineeToExaminerRequest
 */
export const BindExamineeToExaminerRequest = new BindExamineeToExaminerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnbindExamineeFromExaminerRequest$Type extends MessageType<UnbindExamineeFromExaminerRequest> {
    constructor() {
        super("base.examination.UnbindExamineeFromExaminerRequest", [
            { no: 1, name: "examiner_account_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "examinee_id", kind: "scalar", oneof: "examinee", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "examinee_account_id", kind: "scalar", oneof: "examinee", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<UnbindExamineeFromExaminerRequest>): UnbindExamineeFromExaminerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinerAccountId = "0";
        message.examinee = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<UnbindExamineeFromExaminerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UnbindExamineeFromExaminerRequest): UnbindExamineeFromExaminerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examiner_account_id */ 1:
                    message.examinerAccountId = reader.int64().toString();
                    break;
                case /* int64 examinee_id */ 2:
                    message.examinee = {
                        oneofKind: "examineeId",
                        examineeId: reader.int64().toString()
                    };
                    break;
                case /* int64 examinee_account_id */ 3:
                    message.examinee = {
                        oneofKind: "examineeAccountId",
                        examineeAccountId: reader.int64().toString()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UnbindExamineeFromExaminerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examiner_account_id = 1; */
        if (message.examinerAccountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examinerAccountId);
        /* int64 examinee_id = 2; */
        if (message.examinee.oneofKind === "examineeId")
            writer.tag(2, WireType.Varint).int64(message.examinee.examineeId);
        /* int64 examinee_account_id = 3; */
        if (message.examinee.oneofKind === "examineeAccountId")
            writer.tag(3, WireType.Varint).int64(message.examinee.examineeAccountId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.UnbindExamineeFromExaminerRequest
 */
export const UnbindExamineeFromExaminerRequest = new UnbindExamineeFromExaminerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportExamineesListRequest$Type extends MessageType<ExportExamineesListRequest> {
    constructor() {
        super("base.examination.ExportExamineesListRequest", [
            { no: 1, name: "page_num", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 5, name: "end_time", kind: "message", T: () => Timestamp },
            { no: 6, name: "organization_id", kind: "message", T: () => Int64Value },
            { no: 7, name: "examiner_account_id", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<ExportExamineesListRequest>): ExportExamineesListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageNum = 0;
        message.pageSize = 0;
        message.type = "";
        if (value !== undefined)
            reflectionMergePartial<ExportExamineesListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportExamineesListRequest): ExportExamineesListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_num */ 1:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string type */ 3:
                    message.type = reader.string();
                    break;
                case /* google.protobuf.Timestamp start_time */ 4:
                    message.startTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startTime);
                    break;
                case /* google.protobuf.Timestamp end_time */ 5:
                    message.endTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.endTime);
                    break;
                case /* google.protobuf.Int64Value organization_id */ 6:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.Int64Value examiner_account_id */ 7:
                    message.examinerAccountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examinerAccountId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportExamineesListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_num = 1; */
        if (message.pageNum !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageNum);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string type = 3; */
        if (message.type !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.type);
        /* google.protobuf.Timestamp start_time = 4; */
        if (message.startTime)
            Timestamp.internalBinaryWrite(message.startTime, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp end_time = 5; */
        if (message.endTime)
            Timestamp.internalBinaryWrite(message.endTime, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value organization_id = 6; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value examiner_account_id = 7; */
        if (message.examinerAccountId)
            Int64Value.internalBinaryWrite(message.examinerAccountId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ExportExamineesListRequest
 */
export const ExportExamineesListRequest = new ExportExamineesListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportExamineesListResponse$Type extends MessageType<ExportExamineesListResponse> {
    constructor() {
        super("base.examination.ExportExamineesListResponse", [
            { no: 1, name: "file_extension", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 5, name: "total_elements", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 6, name: "total_pages", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "is_first", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "is_last", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "page_elements", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "page_num", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ExportExamineesListResponse>): ExportExamineesListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fileExtension = "";
        message.data = new Uint8Array(0);
        message.totalElements = "0";
        message.totalPages = 0;
        message.isFirst = false;
        message.isLast = false;
        message.pageElements = 0;
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<ExportExamineesListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportExamineesListResponse): ExportExamineesListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_extension */ 1:
                    message.fileExtension = reader.string();
                    break;
                case /* bytes data */ 2:
                    message.data = reader.bytes();
                    break;
                case /* int64 total_elements */ 5:
                    message.totalElements = reader.int64().toString();
                    break;
                case /* int32 total_pages */ 6:
                    message.totalPages = reader.int32();
                    break;
                case /* bool is_first */ 7:
                    message.isFirst = reader.bool();
                    break;
                case /* bool is_last */ 8:
                    message.isLast = reader.bool();
                    break;
                case /* int32 page_elements */ 9:
                    message.pageElements = reader.int32();
                    break;
                case /* int32 page_num */ 10:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 page_size */ 11:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportExamineesListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string file_extension = 1; */
        if (message.fileExtension !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileExtension);
        /* bytes data = 2; */
        if (message.data.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.data);
        /* int64 total_elements = 5; */
        if (message.totalElements !== "0")
            writer.tag(5, WireType.Varint).int64(message.totalElements);
        /* int32 total_pages = 6; */
        if (message.totalPages !== 0)
            writer.tag(6, WireType.Varint).int32(message.totalPages);
        /* bool is_first = 7; */
        if (message.isFirst !== false)
            writer.tag(7, WireType.Varint).bool(message.isFirst);
        /* bool is_last = 8; */
        if (message.isLast !== false)
            writer.tag(8, WireType.Varint).bool(message.isLast);
        /* int32 page_elements = 9; */
        if (message.pageElements !== 0)
            writer.tag(9, WireType.Varint).int32(message.pageElements);
        /* int32 page_num = 10; */
        if (message.pageNum !== 0)
            writer.tag(10, WireType.Varint).int32(message.pageNum);
        /* int32 page_size = 11; */
        if (message.pageSize !== 0)
            writer.tag(11, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ExportExamineesListResponse
 */
export const ExportExamineesListResponse = new ExportExamineesListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExamineeIdEncryptAlphabetResponse$Type extends MessageType<GetExamineeIdEncryptAlphabetResponse> {
    constructor() {
        super("base.examination.GetExamineeIdEncryptAlphabetResponse", [
            { no: 1, name: "alphabet", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetExamineeIdEncryptAlphabetResponse>): GetExamineeIdEncryptAlphabetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.alphabet = "";
        if (value !== undefined)
            reflectionMergePartial<GetExamineeIdEncryptAlphabetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExamineeIdEncryptAlphabetResponse): GetExamineeIdEncryptAlphabetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string alphabet */ 1:
                    message.alphabet = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExamineeIdEncryptAlphabetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string alphabet = 1; */
        if (message.alphabet !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.alphabet);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExamineeIdEncryptAlphabetResponse
 */
export const GetExamineeIdEncryptAlphabetResponse = new GetExamineeIdEncryptAlphabetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DecodeExamineeIdCodeRequest$Type extends MessageType<DecodeExamineeIdCodeRequest> {
    constructor() {
        super("base.examination.DecodeExamineeIdCodeRequest", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DecodeExamineeIdCodeRequest>): DecodeExamineeIdCodeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        if (value !== undefined)
            reflectionMergePartial<DecodeExamineeIdCodeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DecodeExamineeIdCodeRequest): DecodeExamineeIdCodeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DecodeExamineeIdCodeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.DecodeExamineeIdCodeRequest
 */
export const DecodeExamineeIdCodeRequest = new DecodeExamineeIdCodeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DecodeExamineeIdCodeResponse$Type extends MessageType<DecodeExamineeIdCodeResponse> {
    constructor() {
        super("base.examination.DecodeExamineeIdCodeResponse", [
            { no: 1, name: "examinee_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<DecodeExamineeIdCodeResponse>): DecodeExamineeIdCodeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeId = "0";
        if (value !== undefined)
            reflectionMergePartial<DecodeExamineeIdCodeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DecodeExamineeIdCodeResponse): DecodeExamineeIdCodeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examinee_id */ 1:
                    message.examineeId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DecodeExamineeIdCodeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examinee_id = 1; */
        if (message.examineeId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examineeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.DecodeExamineeIdCodeResponse
 */
export const DecodeExamineeIdCodeResponse = new DecodeExamineeIdCodeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAccountIdForExamineeRequest$Type extends MessageType<SetAccountIdForExamineeRequest> {
    constructor() {
        super("base.examination.SetAccountIdForExamineeRequest", [
            { no: 1, name: "examineeId", kind: "message", T: () => Int64Value },
            { no: 2, name: "inPerson", kind: "message", T: () => BoolValue }
        ]);
    }
    create(value?: PartialMessage<SetAccountIdForExamineeRequest>): SetAccountIdForExamineeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetAccountIdForExamineeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetAccountIdForExamineeRequest): SetAccountIdForExamineeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value examineeId */ 1:
                    message.examineeId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examineeId);
                    break;
                case /* google.protobuf.BoolValue inPerson */ 2:
                    message.inPerson = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.inPerson);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetAccountIdForExamineeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value examineeId = 1; */
        if (message.examineeId)
            Int64Value.internalBinaryWrite(message.examineeId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.BoolValue inPerson = 2; */
        if (message.inPerson)
            BoolValue.internalBinaryWrite(message.inPerson, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.SetAccountIdForExamineeRequest
 */
export const SetAccountIdForExamineeRequest = new SetAccountIdForExamineeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAccountIdForExamineeResponse$Type extends MessageType<SetAccountIdForExamineeResponse> {
    constructor() {
        super("base.examination.SetAccountIdForExamineeResponse", [
            { no: 1, name: "isUpdated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SetAccountIdForExamineeResponse>): SetAccountIdForExamineeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isUpdated = false;
        if (value !== undefined)
            reflectionMergePartial<SetAccountIdForExamineeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetAccountIdForExamineeResponse): SetAccountIdForExamineeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isUpdated */ 1:
                    message.isUpdated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetAccountIdForExamineeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isUpdated = 1; */
        if (message.isUpdated !== false)
            writer.tag(1, WireType.Varint).bool(message.isUpdated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.SetAccountIdForExamineeResponse
 */
export const SetAccountIdForExamineeResponse = new SetAccountIdForExamineeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetExamineeAccountIdRequest$Type extends MessageType<SetExamineeAccountIdRequest> {
    constructor() {
        super("base.examination.SetExamineeAccountIdRequest", [
            { no: 1, name: "examinee_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "account_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<SetExamineeAccountIdRequest>): SetExamineeAccountIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeId = "0";
        message.accountId = "0";
        if (value !== undefined)
            reflectionMergePartial<SetExamineeAccountIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetExamineeAccountIdRequest): SetExamineeAccountIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examinee_id */ 1:
                    message.examineeId = reader.int64().toString();
                    break;
                case /* int64 account_id */ 2:
                    message.accountId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetExamineeAccountIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examinee_id = 1; */
        if (message.examineeId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examineeId);
        /* int64 account_id = 2; */
        if (message.accountId !== "0")
            writer.tag(2, WireType.Varint).int64(message.accountId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.SetExamineeAccountIdRequest
 */
export const SetExamineeAccountIdRequest = new SetExamineeAccountIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExamineeRequest$Type extends MessageType<UpdateExamineeRequest> {
    constructor() {
        super("base.examination.UpdateExamineeRequest", [
            { no: 1, name: "examineeId", kind: "message", T: () => Int64Value },
            { no: 2, name: "name", kind: "message", T: () => StringValue },
            { no: 3, name: "gender", kind: "enum", T: () => ["base.examination.Gender", Gender] },
            { no: 5, name: "birthTimeStamp", kind: "message", T: () => Int64Value },
            { no: 6, name: "age", kind: "message", T: () => Int32Value },
            { no: 7, name: "phone", kind: "message", T: () => StringValue },
            { no: 8, name: "heightScalar", kind: "message", T: () => StringValue },
            { no: 9, name: "heightUnit", kind: "message", T: () => StringValue },
            { no: 10, name: "weightScalar", kind: "message", T: () => StringValue },
            { no: 11, name: "weightUnit", kind: "message", T: () => StringValue },
            { no: 16, name: "description", kind: "message", T: () => StringValue },
            { no: 17, name: "inPerson", kind: "message", T: () => BoolValue },
            { no: 18, name: "email", kind: "message", T: () => StringValue },
            { no: 19, name: "creationTimestamp", kind: "message", T: () => Int64Value },
            { no: 20, name: "idNumber", kind: "message", T: () => StringValue },
            { no: 21, name: "patient_id", kind: "message", T: () => StringValue },
            { no: 31, name: "symptoms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateExamineeRequest>): UpdateExamineeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.gender = 0;
        message.symptoms = [];
        if (value !== undefined)
            reflectionMergePartial<UpdateExamineeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateExamineeRequest): UpdateExamineeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value examineeId */ 1:
                    message.examineeId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examineeId);
                    break;
                case /* google.protobuf.StringValue name */ 2:
                    message.name = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                case /* base.examination.Gender gender */ 3:
                    message.gender = reader.int32();
                    break;
                case /* google.protobuf.Int64Value birthTimeStamp */ 5:
                    message.birthTimeStamp = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.birthTimeStamp);
                    break;
                case /* google.protobuf.Int32Value age */ 6:
                    message.age = Int32Value.internalBinaryRead(reader, reader.uint32(), options, message.age);
                    break;
                case /* google.protobuf.StringValue phone */ 7:
                    message.phone = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.phone);
                    break;
                case /* google.protobuf.StringValue heightScalar */ 8:
                    message.heightScalar = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.heightScalar);
                    break;
                case /* google.protobuf.StringValue heightUnit */ 9:
                    message.heightUnit = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.heightUnit);
                    break;
                case /* google.protobuf.StringValue weightScalar */ 10:
                    message.weightScalar = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.weightScalar);
                    break;
                case /* google.protobuf.StringValue weightUnit */ 11:
                    message.weightUnit = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.weightUnit);
                    break;
                case /* google.protobuf.StringValue description */ 16:
                    message.description = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.description);
                    break;
                case /* google.protobuf.BoolValue inPerson */ 17:
                    message.inPerson = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.inPerson);
                    break;
                case /* google.protobuf.StringValue email */ 18:
                    message.email = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.email);
                    break;
                case /* google.protobuf.Int64Value creationTimestamp */ 19:
                    message.creationTimestamp = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.creationTimestamp);
                    break;
                case /* google.protobuf.StringValue idNumber */ 20:
                    message.idNumber = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.idNumber);
                    break;
                case /* google.protobuf.StringValue patient_id */ 21:
                    message.patientId = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.patientId);
                    break;
                case /* repeated string symptoms */ 31:
                    message.symptoms.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateExamineeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value examineeId = 1; */
        if (message.examineeId)
            Int64Value.internalBinaryWrite(message.examineeId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue name = 2; */
        if (message.name)
            StringValue.internalBinaryWrite(message.name, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* base.examination.Gender gender = 3; */
        if (message.gender !== 0)
            writer.tag(3, WireType.Varint).int32(message.gender);
        /* google.protobuf.Int64Value birthTimeStamp = 5; */
        if (message.birthTimeStamp)
            Int64Value.internalBinaryWrite(message.birthTimeStamp, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int32Value age = 6; */
        if (message.age)
            Int32Value.internalBinaryWrite(message.age, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue phone = 7; */
        if (message.phone)
            StringValue.internalBinaryWrite(message.phone, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue heightScalar = 8; */
        if (message.heightScalar)
            StringValue.internalBinaryWrite(message.heightScalar, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue heightUnit = 9; */
        if (message.heightUnit)
            StringValue.internalBinaryWrite(message.heightUnit, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue weightScalar = 10; */
        if (message.weightScalar)
            StringValue.internalBinaryWrite(message.weightScalar, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue weightUnit = 11; */
        if (message.weightUnit)
            StringValue.internalBinaryWrite(message.weightUnit, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue description = 16; */
        if (message.description)
            StringValue.internalBinaryWrite(message.description, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.BoolValue inPerson = 17; */
        if (message.inPerson)
            BoolValue.internalBinaryWrite(message.inPerson, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue email = 18; */
        if (message.email)
            StringValue.internalBinaryWrite(message.email, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value creationTimestamp = 19; */
        if (message.creationTimestamp)
            Int64Value.internalBinaryWrite(message.creationTimestamp, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue idNumber = 20; */
        if (message.idNumber)
            StringValue.internalBinaryWrite(message.idNumber, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue patient_id = 21; */
        if (message.patientId)
            StringValue.internalBinaryWrite(message.patientId, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* repeated string symptoms = 31; */
        for (let i = 0; i < message.symptoms.length; i++)
            writer.tag(31, WireType.LengthDelimited).string(message.symptoms[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.UpdateExamineeRequest
 */
export const UpdateExamineeRequest = new UpdateExamineeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExamineeResponse$Type extends MessageType<UpdateExamineeResponse> {
    constructor() {
        super("base.examination.UpdateExamineeResponse", [
            { no: 1, name: "isUpdated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateExamineeResponse>): UpdateExamineeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isUpdated = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateExamineeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateExamineeResponse): UpdateExamineeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isUpdated */ 1:
                    message.isUpdated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateExamineeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isUpdated = 1; */
        if (message.isUpdated !== false)
            writer.tag(1, WireType.Varint).bool(message.isUpdated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.UpdateExamineeResponse
 */
export const UpdateExamineeResponse = new UpdateExamineeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteExaminationRelationshipRequest$Type extends MessageType<DeleteExaminationRelationshipRequest> {
    constructor() {
        super("base.examination.DeleteExaminationRelationshipRequest", [
            { no: 1, name: "examineeId", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<DeleteExaminationRelationshipRequest>): DeleteExaminationRelationshipRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteExaminationRelationshipRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteExaminationRelationshipRequest): DeleteExaminationRelationshipRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value examineeId */ 1:
                    message.examineeId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examineeId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteExaminationRelationshipRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value examineeId = 1; */
        if (message.examineeId)
            Int64Value.internalBinaryWrite(message.examineeId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.DeleteExaminationRelationshipRequest
 */
export const DeleteExaminationRelationshipRequest = new DeleteExaminationRelationshipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteExaminationRelationshipResponse$Type extends MessageType<DeleteExaminationRelationshipResponse> {
    constructor() {
        super("base.examination.DeleteExaminationRelationshipResponse", [
            { no: 1, name: "isDeleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteExaminationRelationshipResponse>): DeleteExaminationRelationshipResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isDeleted = false;
        if (value !== undefined)
            reflectionMergePartial<DeleteExaminationRelationshipResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteExaminationRelationshipResponse): DeleteExaminationRelationshipResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isDeleted */ 1:
                    message.isDeleted = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteExaminationRelationshipResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isDeleted = 1; */
        if (message.isDeleted !== false)
            writer.tag(1, WireType.Varint).bool(message.isDeleted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.DeleteExaminationRelationshipResponse
 */
export const DeleteExaminationRelationshipResponse = new DeleteExaminationRelationshipResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExamineeByIdRequest$Type extends MessageType<GetExamineeByIdRequest> {
    constructor() {
        super("base.examination.GetExamineeByIdRequest", [
            { no: 1, name: "examineeId", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<GetExamineeByIdRequest>): GetExamineeByIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetExamineeByIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExamineeByIdRequest): GetExamineeByIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value examineeId */ 1:
                    message.examineeId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examineeId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExamineeByIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value examineeId = 1; */
        if (message.examineeId)
            Int64Value.internalBinaryWrite(message.examineeId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExamineeByIdRequest
 */
export const GetExamineeByIdRequest = new GetExamineeByIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExamineeByIdResponse$Type extends MessageType<GetExamineeByIdResponse> {
    constructor() {
        super("base.examination.GetExamineeByIdResponse", [
            { no: 1, name: "examineeResult", kind: "message", T: () => ExamineeResult }
        ]);
    }
    create(value?: PartialMessage<GetExamineeByIdResponse>): GetExamineeByIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetExamineeByIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExamineeByIdResponse): GetExamineeByIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.examination.ExamineeResult examineeResult */ 1:
                    message.examineeResult = ExamineeResult.internalBinaryRead(reader, reader.uint32(), options, message.examineeResult);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExamineeByIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.examination.ExamineeResult examineeResult = 1; */
        if (message.examineeResult)
            ExamineeResult.internalBinaryWrite(message.examineeResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExamineeByIdResponse
 */
export const GetExamineeByIdResponse = new GetExamineeByIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExamineeByAccountIdRequest$Type extends MessageType<GetExamineeByAccountIdRequest> {
    constructor() {
        super("base.examination.GetExamineeByAccountIdRequest", [
            { no: 1, name: "account_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetExamineeByAccountIdRequest>): GetExamineeByAccountIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        if (value !== undefined)
            reflectionMergePartial<GetExamineeByAccountIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExamineeByAccountIdRequest): GetExamineeByAccountIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 account_id */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExamineeByAccountIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 account_id = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExamineeByAccountIdRequest
 */
export const GetExamineeByAccountIdRequest = new GetExamineeByAccountIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExamineeByAccountIdResponse$Type extends MessageType<GetExamineeByAccountIdResponse> {
    constructor() {
        super("base.examination.GetExamineeByAccountIdResponse", [
            { no: 1, name: "examinee", kind: "message", T: () => ExamineeResult }
        ]);
    }
    create(value?: PartialMessage<GetExamineeByAccountIdResponse>): GetExamineeByAccountIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetExamineeByAccountIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExamineeByAccountIdResponse): GetExamineeByAccountIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.examination.ExamineeResult examinee */ 1:
                    message.examinee = ExamineeResult.internalBinaryRead(reader, reader.uint32(), options, message.examinee);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExamineeByAccountIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.examination.ExamineeResult examinee = 1; */
        if (message.examinee)
            ExamineeResult.internalBinaryWrite(message.examinee, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExamineeByAccountIdResponse
 */
export const GetExamineeByAccountIdResponse = new GetExamineeByAccountIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMyExamineeRequest$Type extends MessageType<GetMyExamineeRequest> {
    constructor() {
        super("base.examination.GetMyExamineeRequest", [
            { no: 1, name: "examinee_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetMyExamineeRequest>): GetMyExamineeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeId = "0";
        if (value !== undefined)
            reflectionMergePartial<GetMyExamineeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMyExamineeRequest): GetMyExamineeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examinee_id */ 1:
                    message.examineeId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMyExamineeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examinee_id = 1; */
        if (message.examineeId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examineeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetMyExamineeRequest
 */
export const GetMyExamineeRequest = new GetMyExamineeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMyExamineeResponse$Type extends MessageType<GetMyExamineeResponse> {
    constructor() {
        super("base.examination.GetMyExamineeResponse", [
            { no: 1, name: "examineeResult", kind: "message", T: () => ExamineeResult }
        ]);
    }
    create(value?: PartialMessage<GetMyExamineeResponse>): GetMyExamineeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetMyExamineeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMyExamineeResponse): GetMyExamineeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.examination.ExamineeResult examineeResult */ 1:
                    message.examineeResult = ExamineeResult.internalBinaryRead(reader, reader.uint32(), options, message.examineeResult);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMyExamineeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.examination.ExamineeResult examineeResult = 1; */
        if (message.examineeResult)
            ExamineeResult.internalBinaryWrite(message.examineeResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetMyExamineeResponse
 */
export const GetMyExamineeResponse = new GetMyExamineeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMyExamineeListRequest$Type extends MessageType<GetMyExamineeListRequest> {
    constructor() {
        super("base.examination.GetMyExamineeListRequest", [
            { no: 1, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 2, name: "clientList", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "examiner_account_id", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<GetMyExamineeListRequest>): GetMyExamineeListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientList = [];
        if (value !== undefined)
            reflectionMergePartial<GetMyExamineeListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMyExamineeListRequest): GetMyExamineeListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value organizationId */ 1:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* repeated string clientList */ 2:
                    message.clientList.push(reader.string());
                    break;
                case /* google.protobuf.Int64Value examiner_account_id */ 3:
                    message.examinerAccountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examinerAccountId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMyExamineeListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value organizationId = 1; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string clientList = 2; */
        for (let i = 0; i < message.clientList.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.clientList[i]);
        /* google.protobuf.Int64Value examiner_account_id = 3; */
        if (message.examinerAccountId)
            Int64Value.internalBinaryWrite(message.examinerAccountId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetMyExamineeListRequest
 */
export const GetMyExamineeListRequest = new GetMyExamineeListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMyExamineeListResponse$Type extends MessageType<GetMyExamineeListResponse> {
    constructor() {
        super("base.examination.GetMyExamineeListResponse", [
            { no: 1, name: "examinerAccountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "ExamineeResults", kind: "message", jsonName: "ExamineeResults", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExamineeResult }
        ]);
    }
    create(value?: PartialMessage<GetMyExamineeListResponse>): GetMyExamineeListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinerAccountId = "0";
        message.examineeResults = [];
        if (value !== undefined)
            reflectionMergePartial<GetMyExamineeListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMyExamineeListResponse): GetMyExamineeListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examinerAccountId */ 1:
                    message.examinerAccountId = reader.int64().toString();
                    break;
                case /* repeated base.examination.ExamineeResult ExamineeResults */ 2:
                    message.examineeResults.push(ExamineeResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMyExamineeListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examinerAccountId = 1; */
        if (message.examinerAccountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examinerAccountId);
        /* repeated base.examination.ExamineeResult ExamineeResults = 2; */
        for (let i = 0; i < message.examineeResults.length; i++)
            ExamineeResult.internalBinaryWrite(message.examineeResults[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetMyExamineeListResponse
 */
export const GetMyExamineeListResponse = new GetMyExamineeListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExamineeListByOrganizationIdRequest$Type extends MessageType<GetExamineeListByOrganizationIdRequest> {
    constructor() {
        super("base.examination.GetExamineeListByOrganizationIdRequest", [
            { no: 1, name: "page_num", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "organization_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "client", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "examinee_name", kind: "message", T: () => StringValue },
            { no: 6, name: "clients", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetExamineeListByOrganizationIdRequest>): GetExamineeListByOrganizationIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageNum = 0;
        message.pageSize = 0;
        message.organizationId = "0";
        message.client = "";
        message.clients = [];
        if (value !== undefined)
            reflectionMergePartial<GetExamineeListByOrganizationIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExamineeListByOrganizationIdRequest): GetExamineeListByOrganizationIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_num */ 1:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* int64 organization_id */ 3:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* string client */ 4:
                    message.client = reader.string();
                    break;
                case /* google.protobuf.StringValue examinee_name */ 5:
                    message.examineeName = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.examineeName);
                    break;
                case /* repeated string clients */ 6:
                    message.clients.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExamineeListByOrganizationIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_num = 1; */
        if (message.pageNum !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageNum);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* int64 organization_id = 3; */
        if (message.organizationId !== "0")
            writer.tag(3, WireType.Varint).int64(message.organizationId);
        /* string client = 4; */
        if (message.client !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.client);
        /* google.protobuf.StringValue examinee_name = 5; */
        if (message.examineeName)
            StringValue.internalBinaryWrite(message.examineeName, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated string clients = 6; */
        for (let i = 0; i < message.clients.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.clients[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExamineeListByOrganizationIdRequest
 */
export const GetExamineeListByOrganizationIdRequest = new GetExamineeListByOrganizationIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExamineeListByOrganizationIdResponse$Type extends MessageType<GetExamineeListByOrganizationIdResponse> {
    constructor() {
        super("base.examination.GetExamineeListByOrganizationIdResponse", [
            { no: 1, name: "examinees", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExamineeResult },
            { no: 2, name: "total_elements", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "total_pages", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "is_first", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "is_last", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "page_elements", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "page_num", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetExamineeListByOrganizationIdResponse>): GetExamineeListByOrganizationIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinees = [];
        message.totalElements = "0";
        message.totalPages = 0;
        message.isFirst = false;
        message.isLast = false;
        message.pageElements = 0;
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<GetExamineeListByOrganizationIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExamineeListByOrganizationIdResponse): GetExamineeListByOrganizationIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ExamineeResult examinees */ 1:
                    message.examinees.push(ExamineeResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 total_elements */ 2:
                    message.totalElements = reader.int64().toString();
                    break;
                case /* int32 total_pages */ 3:
                    message.totalPages = reader.int32();
                    break;
                case /* bool is_first */ 4:
                    message.isFirst = reader.bool();
                    break;
                case /* bool is_last */ 5:
                    message.isLast = reader.bool();
                    break;
                case /* int32 page_elements */ 6:
                    message.pageElements = reader.int32();
                    break;
                case /* int32 page_num */ 7:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 page_size */ 8:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExamineeListByOrganizationIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ExamineeResult examinees = 1; */
        for (let i = 0; i < message.examinees.length; i++)
            ExamineeResult.internalBinaryWrite(message.examinees[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 total_elements = 2; */
        if (message.totalElements !== "0")
            writer.tag(2, WireType.Varint).int64(message.totalElements);
        /* int32 total_pages = 3; */
        if (message.totalPages !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalPages);
        /* bool is_first = 4; */
        if (message.isFirst !== false)
            writer.tag(4, WireType.Varint).bool(message.isFirst);
        /* bool is_last = 5; */
        if (message.isLast !== false)
            writer.tag(5, WireType.Varint).bool(message.isLast);
        /* int32 page_elements = 6; */
        if (message.pageElements !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageElements);
        /* int32 page_num = 7; */
        if (message.pageNum !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageNum);
        /* int32 page_size = 8; */
        if (message.pageSize !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExamineeListByOrganizationIdResponse
 */
export const GetExamineeListByOrganizationIdResponse = new GetExamineeListByOrganizationIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExamineesExaminationReportListRequest$Type extends MessageType<GetExamineesExaminationReportListRequest> {
    constructor() {
        super("base.examination.GetExamineesExaminationReportListRequest", [
            { no: 1, name: "examinees", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetExamineesExaminationReportListRequest>): GetExamineesExaminationReportListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinees = [];
        if (value !== undefined)
            reflectionMergePartial<GetExamineesExaminationReportListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExamineesExaminationReportListRequest): GetExamineesExaminationReportListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 examinees */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.examinees.push(reader.int64().toString());
                    else
                        message.examinees.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExamineesExaminationReportListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 examinees = 1; */
        if (message.examinees.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.examinees.length; i++)
                writer.int64(message.examinees[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExamineesExaminationReportListRequest
 */
export const GetExamineesExaminationReportListRequest = new GetExamineesExaminationReportListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExamineesExaminationReportListByReportTypeRequest$Type extends MessageType<GetExamineesExaminationReportListByReportTypeRequest> {
    constructor() {
        super("base.examination.GetExamineesExaminationReportListByReportTypeRequest", [
            { no: 1, name: "examinees", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "examinationReportType", kind: "enum", T: () => ["base.examination.ExaminationReportType", ExaminationReportType] }
        ]);
    }
    create(value?: PartialMessage<GetExamineesExaminationReportListByReportTypeRequest>): GetExamineesExaminationReportListByReportTypeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinees = [];
        message.examinationReportType = 0;
        if (value !== undefined)
            reflectionMergePartial<GetExamineesExaminationReportListByReportTypeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExamineesExaminationReportListByReportTypeRequest): GetExamineesExaminationReportListByReportTypeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 examinees */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.examinees.push(reader.int64().toString());
                    else
                        message.examinees.push(reader.int64().toString());
                    break;
                case /* base.examination.ExaminationReportType examinationReportType */ 2:
                    message.examinationReportType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExamineesExaminationReportListByReportTypeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 examinees = 1; */
        if (message.examinees.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.examinees.length; i++)
                writer.int64(message.examinees[i]);
            writer.join();
        }
        /* base.examination.ExaminationReportType examinationReportType = 2; */
        if (message.examinationReportType !== 0)
            writer.tag(2, WireType.Varint).int32(message.examinationReportType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExamineesExaminationReportListByReportTypeRequest
 */
export const GetExamineesExaminationReportListByReportTypeRequest = new GetExamineesExaminationReportListByReportTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExaminationReportMapValue$Type extends MessageType<ExaminationReportMapValue> {
    constructor() {
        super("base.examination.ExaminationReportMapValue", [
            { no: 1, name: "examinationReportRelationshipResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExaminationReportRelationshipDtoResult }
        ]);
    }
    create(value?: PartialMessage<ExaminationReportMapValue>): ExaminationReportMapValue {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportRelationshipResults = [];
        if (value !== undefined)
            reflectionMergePartial<ExaminationReportMapValue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExaminationReportMapValue): ExaminationReportMapValue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ExaminationReportRelationshipDtoResult examinationReportRelationshipResults */ 1:
                    message.examinationReportRelationshipResults.push(ExaminationReportRelationshipDtoResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExaminationReportMapValue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ExaminationReportRelationshipDtoResult examinationReportRelationshipResults = 1; */
        for (let i = 0; i < message.examinationReportRelationshipResults.length; i++)
            ExaminationReportRelationshipDtoResult.internalBinaryWrite(message.examinationReportRelationshipResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ExaminationReportMapValue
 */
export const ExaminationReportMapValue = new ExaminationReportMapValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExamineesExaminationReportListResponse$Type extends MessageType<GetExamineesExaminationReportListResponse> {
    constructor() {
        super("base.examination.GetExamineesExaminationReportListResponse", [
            { no: 1, name: "examinationReportRelationshipMapResults", kind: "map", K: 3 /*ScalarType.INT64*/, V: { kind: "message", T: () => ExaminationReportMapValue } }
        ]);
    }
    create(value?: PartialMessage<GetExamineesExaminationReportListResponse>): GetExamineesExaminationReportListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportRelationshipMapResults = {};
        if (value !== undefined)
            reflectionMergePartial<GetExamineesExaminationReportListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExamineesExaminationReportListResponse): GetExamineesExaminationReportListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<int64, base.examination.ExaminationReportMapValue> examinationReportRelationshipMapResults */ 1:
                    this.binaryReadMap1(message.examinationReportRelationshipMapResults, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: GetExamineesExaminationReportListResponse["examinationReportRelationshipMapResults"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetExamineesExaminationReportListResponse["examinationReportRelationshipMapResults"] | undefined, val: GetExamineesExaminationReportListResponse["examinationReportRelationshipMapResults"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int64().toString();
                    break;
                case 2:
                    val = ExaminationReportMapValue.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for base.examination.GetExamineesExaminationReportListResponse.examinationReportRelationshipMapResults");
            }
        }
        map[key ?? "0"] = val ?? ExaminationReportMapValue.create();
    }
    internalBinaryWrite(message: GetExamineesExaminationReportListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<int64, base.examination.ExaminationReportMapValue> examinationReportRelationshipMapResults = 1; */
        for (let k of globalThis.Object.keys(message.examinationReportRelationshipMapResults)) {
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int64(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            ExaminationReportMapValue.internalBinaryWrite(message.examinationReportRelationshipMapResults[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExamineesExaminationReportListResponse
 */
export const GetExamineesExaminationReportListResponse = new GetExamineesExaminationReportListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExamineesExaminationReportListByReportTypeResponse$Type extends MessageType<GetExamineesExaminationReportListByReportTypeResponse> {
    constructor() {
        super("base.examination.GetExamineesExaminationReportListByReportTypeResponse", [
            { no: 1, name: "examinationReportRelationshipMapResults", kind: "map", K: 3 /*ScalarType.INT64*/, V: { kind: "message", T: () => ExaminationReportMapValue } }
        ]);
    }
    create(value?: PartialMessage<GetExamineesExaminationReportListByReportTypeResponse>): GetExamineesExaminationReportListByReportTypeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportRelationshipMapResults = {};
        if (value !== undefined)
            reflectionMergePartial<GetExamineesExaminationReportListByReportTypeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExamineesExaminationReportListByReportTypeResponse): GetExamineesExaminationReportListByReportTypeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<int64, base.examination.ExaminationReportMapValue> examinationReportRelationshipMapResults */ 1:
                    this.binaryReadMap1(message.examinationReportRelationshipMapResults, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: GetExamineesExaminationReportListByReportTypeResponse["examinationReportRelationshipMapResults"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetExamineesExaminationReportListByReportTypeResponse["examinationReportRelationshipMapResults"] | undefined, val: GetExamineesExaminationReportListByReportTypeResponse["examinationReportRelationshipMapResults"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int64().toString();
                    break;
                case 2:
                    val = ExaminationReportMapValue.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for base.examination.GetExamineesExaminationReportListByReportTypeResponse.examinationReportRelationshipMapResults");
            }
        }
        map[key ?? "0"] = val ?? ExaminationReportMapValue.create();
    }
    internalBinaryWrite(message: GetExamineesExaminationReportListByReportTypeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<int64, base.examination.ExaminationReportMapValue> examinationReportRelationshipMapResults = 1; */
        for (let k of globalThis.Object.keys(message.examinationReportRelationshipMapResults)) {
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int64(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            ExaminationReportMapValue.internalBinaryWrite(message.examinationReportRelationshipMapResults[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExamineesExaminationReportListByReportTypeResponse
 */
export const GetExamineesExaminationReportListByReportTypeResponse = new GetExamineesExaminationReportListByReportTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMyExaminationReportListRequest$Type extends MessageType<GetMyExaminationReportListRequest> {
    constructor() {
        super("base.examination.GetMyExaminationReportListRequest", [
            { no: 1, name: "organizationId", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<GetMyExaminationReportListRequest>): GetMyExaminationReportListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetMyExaminationReportListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMyExaminationReportListRequest): GetMyExaminationReportListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value organizationId */ 1:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMyExaminationReportListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value organizationId = 1; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetMyExaminationReportListRequest
 */
export const GetMyExaminationReportListRequest = new GetMyExaminationReportListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMyExaminationReportListResponse$Type extends MessageType<GetMyExaminationReportListResponse> {
    constructor() {
        super("base.examination.GetMyExaminationReportListResponse", [
            { no: 1, name: "examinationReportRelationshipResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExaminationReportRelationshipDtoResult }
        ]);
    }
    create(value?: PartialMessage<GetMyExaminationReportListResponse>): GetMyExaminationReportListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportRelationshipResults = [];
        if (value !== undefined)
            reflectionMergePartial<GetMyExaminationReportListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMyExaminationReportListResponse): GetMyExaminationReportListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ExaminationReportRelationshipDtoResult examinationReportRelationshipResults */ 1:
                    message.examinationReportRelationshipResults.push(ExaminationReportRelationshipDtoResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMyExaminationReportListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ExaminationReportRelationshipDtoResult examinationReportRelationshipResults = 1; */
        for (let i = 0; i < message.examinationReportRelationshipResults.length; i++)
            ExaminationReportRelationshipDtoResult.internalBinaryWrite(message.examinationReportRelationshipResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetMyExaminationReportListResponse
 */
export const GetMyExaminationReportListResponse = new GetMyExaminationReportListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExaminationReportRelationshipResult$Type extends MessageType<ExaminationReportRelationshipResult> {
    constructor() {
        super("base.examination.ExaminationReportRelationshipResult", [
            { no: 4, name: "examinationReportRelationshipId", kind: "message", T: () => Int64Value },
            { no: 1, name: "accountId", kind: "message", T: () => Int64Value },
            { no: 2, name: "relationship", kind: "enum", T: () => ["base.examination.Relationship", Relationship] },
            { no: 3, name: "examinationReportResults", kind: "message", T: () => ExaminationReportResult }
        ]);
    }
    create(value?: PartialMessage<ExaminationReportRelationshipResult>): ExaminationReportRelationshipResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.relationship = 0;
        if (value !== undefined)
            reflectionMergePartial<ExaminationReportRelationshipResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExaminationReportRelationshipResult): ExaminationReportRelationshipResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value examinationReportRelationshipId */ 4:
                    message.examinationReportRelationshipId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examinationReportRelationshipId);
                    break;
                case /* google.protobuf.Int64Value accountId */ 1:
                    message.accountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                case /* base.examination.Relationship relationship */ 2:
                    message.relationship = reader.int32();
                    break;
                case /* base.examination.ExaminationReportResult examinationReportResults */ 3:
                    message.examinationReportResults = ExaminationReportResult.internalBinaryRead(reader, reader.uint32(), options, message.examinationReportResults);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExaminationReportRelationshipResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value accountId = 1; */
        if (message.accountId)
            Int64Value.internalBinaryWrite(message.accountId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* base.examination.Relationship relationship = 2; */
        if (message.relationship !== 0)
            writer.tag(2, WireType.Varint).int32(message.relationship);
        /* base.examination.ExaminationReportResult examinationReportResults = 3; */
        if (message.examinationReportResults)
            ExaminationReportResult.internalBinaryWrite(message.examinationReportResults, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value examinationReportRelationshipId = 4; */
        if (message.examinationReportRelationshipId)
            Int64Value.internalBinaryWrite(message.examinationReportRelationshipId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ExaminationReportRelationshipResult
 */
export const ExaminationReportRelationshipResult = new ExaminationReportRelationshipResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExaminationReportRelationshipDtoResult$Type extends MessageType<ExaminationReportRelationshipDtoResult> {
    constructor() {
        super("base.examination.ExaminationReportRelationshipDtoResult", [
            { no: 1, name: "accountId", kind: "message", T: () => Int64Value },
            { no: 2, name: "relationshipMap", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => RelationshipDetailResult } },
            { no: 3, name: "examinationReportResults", kind: "message", T: () => ExaminationReportResult }
        ]);
    }
    create(value?: PartialMessage<ExaminationReportRelationshipDtoResult>): ExaminationReportRelationshipDtoResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.relationshipMap = {};
        if (value !== undefined)
            reflectionMergePartial<ExaminationReportRelationshipDtoResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExaminationReportRelationshipDtoResult): ExaminationReportRelationshipDtoResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value accountId */ 1:
                    message.accountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                case /* map<string, base.examination.RelationshipDetailResult> relationshipMap */ 2:
                    this.binaryReadMap2(message.relationshipMap, reader, options);
                    break;
                case /* base.examination.ExaminationReportResult examinationReportResults */ 3:
                    message.examinationReportResults = ExaminationReportResult.internalBinaryRead(reader, reader.uint32(), options, message.examinationReportResults);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: ExaminationReportRelationshipDtoResult["relationshipMap"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ExaminationReportRelationshipDtoResult["relationshipMap"] | undefined, val: ExaminationReportRelationshipDtoResult["relationshipMap"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = RelationshipDetailResult.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for base.examination.ExaminationReportRelationshipDtoResult.relationshipMap");
            }
        }
        map[key ?? ""] = val ?? RelationshipDetailResult.create();
    }
    internalBinaryWrite(message: ExaminationReportRelationshipDtoResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value accountId = 1; */
        if (message.accountId)
            Int64Value.internalBinaryWrite(message.accountId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, base.examination.RelationshipDetailResult> relationshipMap = 2; */
        for (let k of globalThis.Object.keys(message.relationshipMap)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            RelationshipDetailResult.internalBinaryWrite(message.relationshipMap[k], writer, options);
            writer.join().join();
        }
        /* base.examination.ExaminationReportResult examinationReportResults = 3; */
        if (message.examinationReportResults)
            ExaminationReportResult.internalBinaryWrite(message.examinationReportResults, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ExaminationReportRelationshipDtoResult
 */
export const ExaminationReportRelationshipDtoResult = new ExaminationReportRelationshipDtoResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RelationshipDetailResult$Type extends MessageType<RelationshipDetailResult> {
    constructor() {
        super("base.examination.RelationshipDetailResult", [
            { no: 1, name: "examinationReportRelationshipId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<RelationshipDetailResult>): RelationshipDetailResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportRelationshipId = "0";
        if (value !== undefined)
            reflectionMergePartial<RelationshipDetailResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RelationshipDetailResult): RelationshipDetailResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examinationReportRelationshipId */ 1:
                    message.examinationReportRelationshipId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RelationshipDetailResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examinationReportRelationshipId = 1; */
        if (message.examinationReportRelationshipId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examinationReportRelationshipId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.RelationshipDetailResult
 */
export const RelationshipDetailResult = new RelationshipDetailResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExaminationReportResult$Type extends MessageType<ExaminationReportResult> {
    constructor() {
        super("base.examination.ExaminationReportResult", [
            { no: 6, name: "examinationReportId", kind: "message", T: () => Int64Value },
            { no: 1, name: "examinerAccountId", kind: "message", T: () => Int64Value },
            { no: 2, name: "examineeResult", kind: "message", T: () => ExamineeResult },
            { no: 3, name: "examineeReportDetailType", kind: "message", T: () => StringValue },
            { no: 4, name: "examineeReportDetailId", kind: "message", T: () => StringValue },
            { no: 5, name: "creationTimestamp", kind: "message", T: () => Int64Value },
            { no: 7, name: "doctorAdvice", kind: "message", T: () => StringValue },
            { no: 8, name: "examinerResult", kind: "message", T: () => ExaminerResult },
            { no: 9, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 10, name: "evaluator_account_id", kind: "message", T: () => Int64Value },
            { no: 11, name: "evaluate_time", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<ExaminationReportResult>): ExaminationReportResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ExaminationReportResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExaminationReportResult): ExaminationReportResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value examinationReportId */ 6:
                    message.examinationReportId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examinationReportId);
                    break;
                case /* google.protobuf.Int64Value examinerAccountId */ 1:
                    message.examinerAccountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examinerAccountId);
                    break;
                case /* base.examination.ExamineeResult examineeResult */ 2:
                    message.examineeResult = ExamineeResult.internalBinaryRead(reader, reader.uint32(), options, message.examineeResult);
                    break;
                case /* google.protobuf.StringValue examineeReportDetailType */ 3:
                    message.examineeReportDetailType = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.examineeReportDetailType);
                    break;
                case /* google.protobuf.StringValue examineeReportDetailId */ 4:
                    message.examineeReportDetailId = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.examineeReportDetailId);
                    break;
                case /* google.protobuf.Int64Value creationTimestamp */ 5:
                    message.creationTimestamp = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.creationTimestamp);
                    break;
                case /* google.protobuf.StringValue doctorAdvice */ 7:
                    message.doctorAdvice = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.doctorAdvice);
                    break;
                case /* base.examination.ExaminerResult examinerResult */ 8:
                    message.examinerResult = ExaminerResult.internalBinaryRead(reader, reader.uint32(), options, message.examinerResult);
                    break;
                case /* google.protobuf.Int64Value organizationId */ 9:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.Int64Value evaluator_account_id */ 10:
                    message.evaluatorAccountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.evaluatorAccountId);
                    break;
                case /* google.protobuf.Timestamp evaluate_time */ 11:
                    message.evaluateTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.evaluateTime);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExaminationReportResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value examinerAccountId = 1; */
        if (message.examinerAccountId)
            Int64Value.internalBinaryWrite(message.examinerAccountId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* base.examination.ExamineeResult examineeResult = 2; */
        if (message.examineeResult)
            ExamineeResult.internalBinaryWrite(message.examineeResult, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue examineeReportDetailType = 3; */
        if (message.examineeReportDetailType)
            StringValue.internalBinaryWrite(message.examineeReportDetailType, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue examineeReportDetailId = 4; */
        if (message.examineeReportDetailId)
            StringValue.internalBinaryWrite(message.examineeReportDetailId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value creationTimestamp = 5; */
        if (message.creationTimestamp)
            Int64Value.internalBinaryWrite(message.creationTimestamp, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value examinationReportId = 6; */
        if (message.examinationReportId)
            Int64Value.internalBinaryWrite(message.examinationReportId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue doctorAdvice = 7; */
        if (message.doctorAdvice)
            StringValue.internalBinaryWrite(message.doctorAdvice, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* base.examination.ExaminerResult examinerResult = 8; */
        if (message.examinerResult)
            ExaminerResult.internalBinaryWrite(message.examinerResult, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value organizationId = 9; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value evaluator_account_id = 10; */
        if (message.evaluatorAccountId)
            Int64Value.internalBinaryWrite(message.evaluatorAccountId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp evaluate_time = 11; */
        if (message.evaluateTime)
            Timestamp.internalBinaryWrite(message.evaluateTime, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ExaminationReportResult
 */
export const ExaminationReportResult = new ExaminationReportResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExamineeResult$Type extends MessageType<ExamineeResult> {
    constructor() {
        super("base.examination.ExamineeResult", [
            { no: 1, name: "examineeId", kind: "message", T: () => Int64Value },
            { no: 2, name: "name", kind: "message", T: () => StringValue },
            { no: 3, name: "gender", kind: "enum", T: () => ["base.examination.Gender", Gender] },
            { no: 4, name: "accountId", kind: "message", T: () => Int64Value },
            { no: 17, name: "creatorAccountId", kind: "message", T: () => Int64Value },
            { no: 5, name: "birthTimeStamp", kind: "message", T: () => Int64Value },
            { no: 6, name: "age", kind: "message", T: () => Int32Value },
            { no: 7, name: "phone", kind: "message", T: () => StringValue },
            { no: 8, name: "heightScalar", kind: "message", T: () => StringValue },
            { no: 9, name: "heightUnit", kind: "message", T: () => StringValue },
            { no: 10, name: "weightScalar", kind: "message", T: () => StringValue },
            { no: 11, name: "weightUnit", kind: "message", T: () => StringValue },
            { no: 12, name: "creationTimestamp", kind: "message", T: () => Int64Value },
            { no: 13, name: "userId", kind: "message", T: () => Int64Value },
            { no: 14, name: "userType", kind: "message", T: () => StringValue },
            { no: 15, name: "description", kind: "message", T: () => StringValue },
            { no: 16, name: "inPerson", kind: "message", T: () => BoolValue },
            { no: 18, name: "email", kind: "message", T: () => StringValue },
            { no: 19, name: "idNumber", kind: "message", T: () => StringValue },
            { no: 20, name: "nameInitial", kind: "message", T: () => StringValue },
            { no: 21, name: "examinee_id_code", kind: "message", T: () => StringValue },
            { no: 22, name: "patient_id", kind: "message", T: () => StringValue },
            { no: 31, name: "symptoms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExamineeResult>): ExamineeResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.gender = 0;
        message.symptoms = [];
        if (value !== undefined)
            reflectionMergePartial<ExamineeResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExamineeResult): ExamineeResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value examineeId */ 1:
                    message.examineeId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examineeId);
                    break;
                case /* google.protobuf.StringValue name */ 2:
                    message.name = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                case /* base.examination.Gender gender */ 3:
                    message.gender = reader.int32();
                    break;
                case /* google.protobuf.Int64Value accountId */ 4:
                    message.accountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                case /* google.protobuf.Int64Value creatorAccountId */ 17:
                    message.creatorAccountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.creatorAccountId);
                    break;
                case /* google.protobuf.Int64Value birthTimeStamp */ 5:
                    message.birthTimeStamp = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.birthTimeStamp);
                    break;
                case /* google.protobuf.Int32Value age */ 6:
                    message.age = Int32Value.internalBinaryRead(reader, reader.uint32(), options, message.age);
                    break;
                case /* google.protobuf.StringValue phone */ 7:
                    message.phone = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.phone);
                    break;
                case /* google.protobuf.StringValue heightScalar */ 8:
                    message.heightScalar = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.heightScalar);
                    break;
                case /* google.protobuf.StringValue heightUnit */ 9:
                    message.heightUnit = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.heightUnit);
                    break;
                case /* google.protobuf.StringValue weightScalar */ 10:
                    message.weightScalar = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.weightScalar);
                    break;
                case /* google.protobuf.StringValue weightUnit */ 11:
                    message.weightUnit = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.weightUnit);
                    break;
                case /* google.protobuf.Int64Value creationTimestamp */ 12:
                    message.creationTimestamp = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.creationTimestamp);
                    break;
                case /* google.protobuf.Int64Value userId */ 13:
                    message.userId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.userId);
                    break;
                case /* google.protobuf.StringValue userType */ 14:
                    message.userType = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.userType);
                    break;
                case /* google.protobuf.StringValue description */ 15:
                    message.description = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.description);
                    break;
                case /* google.protobuf.BoolValue inPerson */ 16:
                    message.inPerson = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.inPerson);
                    break;
                case /* google.protobuf.StringValue email */ 18:
                    message.email = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.email);
                    break;
                case /* google.protobuf.StringValue idNumber */ 19:
                    message.idNumber = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.idNumber);
                    break;
                case /* google.protobuf.StringValue nameInitial */ 20:
                    message.nameInitial = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.nameInitial);
                    break;
                case /* google.protobuf.StringValue examinee_id_code */ 21:
                    message.examineeIdCode = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.examineeIdCode);
                    break;
                case /* google.protobuf.StringValue patient_id */ 22:
                    message.patientId = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.patientId);
                    break;
                case /* repeated string symptoms */ 31:
                    message.symptoms.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExamineeResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value examineeId = 1; */
        if (message.examineeId)
            Int64Value.internalBinaryWrite(message.examineeId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue name = 2; */
        if (message.name)
            StringValue.internalBinaryWrite(message.name, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* base.examination.Gender gender = 3; */
        if (message.gender !== 0)
            writer.tag(3, WireType.Varint).int32(message.gender);
        /* google.protobuf.Int64Value accountId = 4; */
        if (message.accountId)
            Int64Value.internalBinaryWrite(message.accountId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value birthTimeStamp = 5; */
        if (message.birthTimeStamp)
            Int64Value.internalBinaryWrite(message.birthTimeStamp, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int32Value age = 6; */
        if (message.age)
            Int32Value.internalBinaryWrite(message.age, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue phone = 7; */
        if (message.phone)
            StringValue.internalBinaryWrite(message.phone, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue heightScalar = 8; */
        if (message.heightScalar)
            StringValue.internalBinaryWrite(message.heightScalar, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue heightUnit = 9; */
        if (message.heightUnit)
            StringValue.internalBinaryWrite(message.heightUnit, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue weightScalar = 10; */
        if (message.weightScalar)
            StringValue.internalBinaryWrite(message.weightScalar, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue weightUnit = 11; */
        if (message.weightUnit)
            StringValue.internalBinaryWrite(message.weightUnit, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value creationTimestamp = 12; */
        if (message.creationTimestamp)
            Int64Value.internalBinaryWrite(message.creationTimestamp, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value userId = 13; */
        if (message.userId)
            Int64Value.internalBinaryWrite(message.userId, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue userType = 14; */
        if (message.userType)
            StringValue.internalBinaryWrite(message.userType, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue description = 15; */
        if (message.description)
            StringValue.internalBinaryWrite(message.description, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.BoolValue inPerson = 16; */
        if (message.inPerson)
            BoolValue.internalBinaryWrite(message.inPerson, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value creatorAccountId = 17; */
        if (message.creatorAccountId)
            Int64Value.internalBinaryWrite(message.creatorAccountId, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue email = 18; */
        if (message.email)
            StringValue.internalBinaryWrite(message.email, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue idNumber = 19; */
        if (message.idNumber)
            StringValue.internalBinaryWrite(message.idNumber, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue nameInitial = 20; */
        if (message.nameInitial)
            StringValue.internalBinaryWrite(message.nameInitial, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue examinee_id_code = 21; */
        if (message.examineeIdCode)
            StringValue.internalBinaryWrite(message.examineeIdCode, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue patient_id = 22; */
        if (message.patientId)
            StringValue.internalBinaryWrite(message.patientId, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* repeated string symptoms = 31; */
        for (let i = 0; i < message.symptoms.length; i++)
            writer.tag(31, WireType.LengthDelimited).string(message.symptoms[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ExamineeResult
 */
export const ExamineeResult = new ExamineeResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExaminationReportInfo$Type extends MessageType<ExaminationReportInfo> {
    constructor() {
        super("base.examination.ExaminationReportInfo", [
            { no: 1, name: "id", kind: "message", T: () => Int64Value },
            { no: 2, name: "examineeId", kind: "message", T: () => Int64Value },
            { no: 3, name: "examineeReportDetailType", kind: "enum", T: () => ["base.examination.ExaminationReportType", ExaminationReportType] },
            { no: 4, name: "examineeReportDetailId", kind: "message", T: () => StringValue },
            { no: 5, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 6, name: "doctorAdvice", kind: "message", T: () => StringValue },
            { no: 7, name: "examinerId", kind: "message", T: () => Int64Value },
            { no: 8, name: "examinerAccountId", kind: "message", T: () => Int64Value },
            { no: 9, name: "examineeAccountId", kind: "message", T: () => Int64Value },
            { no: 10, name: "creationTimestamp", kind: "message", T: () => Int64Value },
            { no: 11, name: "evaluator_account_id", kind: "message", T: () => Int64Value },
            { no: 12, name: "evaluate_time", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<ExaminationReportInfo>): ExaminationReportInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeReportDetailType = 0;
        if (value !== undefined)
            reflectionMergePartial<ExaminationReportInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExaminationReportInfo): ExaminationReportInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value id */ 1:
                    message.id = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Int64Value examineeId */ 2:
                    message.examineeId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examineeId);
                    break;
                case /* base.examination.ExaminationReportType examineeReportDetailType */ 3:
                    message.examineeReportDetailType = reader.int32();
                    break;
                case /* google.protobuf.StringValue examineeReportDetailId */ 4:
                    message.examineeReportDetailId = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.examineeReportDetailId);
                    break;
                case /* google.protobuf.Int64Value organizationId */ 5:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.StringValue doctorAdvice */ 6:
                    message.doctorAdvice = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.doctorAdvice);
                    break;
                case /* google.protobuf.Int64Value examinerId */ 7:
                    message.examinerId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examinerId);
                    break;
                case /* google.protobuf.Int64Value examinerAccountId */ 8:
                    message.examinerAccountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examinerAccountId);
                    break;
                case /* google.protobuf.Int64Value examineeAccountId */ 9:
                    message.examineeAccountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examineeAccountId);
                    break;
                case /* google.protobuf.Int64Value creationTimestamp */ 10:
                    message.creationTimestamp = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.creationTimestamp);
                    break;
                case /* google.protobuf.Int64Value evaluator_account_id */ 11:
                    message.evaluatorAccountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.evaluatorAccountId);
                    break;
                case /* google.protobuf.Timestamp evaluate_time */ 12:
                    message.evaluateTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.evaluateTime);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExaminationReportInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value id = 1; */
        if (message.id)
            Int64Value.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value examineeId = 2; */
        if (message.examineeId)
            Int64Value.internalBinaryWrite(message.examineeId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* base.examination.ExaminationReportType examineeReportDetailType = 3; */
        if (message.examineeReportDetailType !== 0)
            writer.tag(3, WireType.Varint).int32(message.examineeReportDetailType);
        /* google.protobuf.StringValue examineeReportDetailId = 4; */
        if (message.examineeReportDetailId)
            StringValue.internalBinaryWrite(message.examineeReportDetailId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value organizationId = 5; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue doctorAdvice = 6; */
        if (message.doctorAdvice)
            StringValue.internalBinaryWrite(message.doctorAdvice, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value examinerId = 7; */
        if (message.examinerId)
            Int64Value.internalBinaryWrite(message.examinerId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value examinerAccountId = 8; */
        if (message.examinerAccountId)
            Int64Value.internalBinaryWrite(message.examinerAccountId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value examineeAccountId = 9; */
        if (message.examineeAccountId)
            Int64Value.internalBinaryWrite(message.examineeAccountId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value creationTimestamp = 10; */
        if (message.creationTimestamp)
            Int64Value.internalBinaryWrite(message.creationTimestamp, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value evaluator_account_id = 11; */
        if (message.evaluatorAccountId)
            Int64Value.internalBinaryWrite(message.evaluatorAccountId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp evaluate_time = 12; */
        if (message.evaluateTime)
            Timestamp.internalBinaryWrite(message.evaluateTime, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ExaminationReportInfo
 */
export const ExaminationReportInfo = new ExaminationReportInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExaminerInfo$Type extends MessageType<ExaminerInfo> {
    constructor() {
        super("base.examination.ExaminerInfo", [
            { no: 1, name: "name", kind: "message", T: () => StringValue },
            { no: 2, name: "phone", kind: "message", T: () => StringValue },
            { no: 3, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 5, name: "id", kind: "message", T: () => Int64Value },
            { no: 4, name: "creatorAccountId", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<ExaminerInfo>): ExaminerInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ExaminerInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExaminerInfo): ExaminerInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.StringValue name */ 1:
                    message.name = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                case /* google.protobuf.StringValue phone */ 2:
                    message.phone = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.phone);
                    break;
                case /* google.protobuf.Int64Value organizationId */ 3:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.Int64Value id */ 5:
                    message.id = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Int64Value creatorAccountId */ 4:
                    message.creatorAccountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.creatorAccountId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExaminerInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.StringValue name = 1; */
        if (message.name)
            StringValue.internalBinaryWrite(message.name, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue phone = 2; */
        if (message.phone)
            StringValue.internalBinaryWrite(message.phone, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value organizationId = 3; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value creatorAccountId = 4; */
        if (message.creatorAccountId)
            Int64Value.internalBinaryWrite(message.creatorAccountId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value id = 5; */
        if (message.id)
            Int64Value.internalBinaryWrite(message.id, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ExaminerInfo
 */
export const ExaminerInfo = new ExaminerInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExaminerResult$Type extends MessageType<ExaminerResult> {
    constructor() {
        super("base.examination.ExaminerResult", [
            { no: 5, name: "id", kind: "message", T: () => Int64Value },
            { no: 1, name: "name", kind: "message", T: () => StringValue },
            { no: 2, name: "phone", kind: "message", T: () => StringValue },
            { no: 3, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 4, name: "creatorAccountId", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<ExaminerResult>): ExaminerResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ExaminerResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExaminerResult): ExaminerResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value id */ 5:
                    message.id = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.StringValue name */ 1:
                    message.name = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                case /* google.protobuf.StringValue phone */ 2:
                    message.phone = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.phone);
                    break;
                case /* google.protobuf.Int64Value organizationId */ 3:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.Int64Value creatorAccountId */ 4:
                    message.creatorAccountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.creatorAccountId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExaminerResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.StringValue name = 1; */
        if (message.name)
            StringValue.internalBinaryWrite(message.name, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue phone = 2; */
        if (message.phone)
            StringValue.internalBinaryWrite(message.phone, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value organizationId = 3; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value creatorAccountId = 4; */
        if (message.creatorAccountId)
            Int64Value.internalBinaryWrite(message.creatorAccountId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value id = 5; */
        if (message.id)
            Int64Value.internalBinaryWrite(message.id, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ExaminerResult
 */
export const ExaminerResult = new ExaminerResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExaminationReportRequest$Type extends MessageType<CreateExaminationReportRequest> {
    constructor() {
        super("base.examination.CreateExaminationReportRequest", [
            { no: 1, name: "examinationReportInfo", kind: "message", T: () => ExaminationReportInfo }
        ]);
    }
    create(value?: PartialMessage<CreateExaminationReportRequest>): CreateExaminationReportRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateExaminationReportRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateExaminationReportRequest): CreateExaminationReportRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.examination.ExaminationReportInfo examinationReportInfo */ 1:
                    message.examinationReportInfo = ExaminationReportInfo.internalBinaryRead(reader, reader.uint32(), options, message.examinationReportInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateExaminationReportRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.examination.ExaminationReportInfo examinationReportInfo = 1; */
        if (message.examinationReportInfo)
            ExaminationReportInfo.internalBinaryWrite(message.examinationReportInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.CreateExaminationReportRequest
 */
export const CreateExaminationReportRequest = new CreateExaminationReportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExaminationReportResponse$Type extends MessageType<CreateExaminationReportResponse> {
    constructor() {
        super("base.examination.CreateExaminationReportResponse", [
            { no: 1, name: "examinationReportId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateExaminationReportResponse>): CreateExaminationReportResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportId = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateExaminationReportResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateExaminationReportResponse): CreateExaminationReportResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examinationReportId */ 1:
                    message.examinationReportId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateExaminationReportResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examinationReportId = 1; */
        if (message.examinationReportId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examinationReportId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.CreateExaminationReportResponse
 */
export const CreateExaminationReportResponse = new CreateExaminationReportResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExaminationReportRequest$Type extends MessageType<UpdateExaminationReportRequest> {
    constructor() {
        super("base.examination.UpdateExaminationReportRequest", [
            { no: 1, name: "examinationReportInfo", kind: "message", T: () => ExaminationReportInfo }
        ]);
    }
    create(value?: PartialMessage<UpdateExaminationReportRequest>): UpdateExaminationReportRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateExaminationReportRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateExaminationReportRequest): UpdateExaminationReportRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.examination.ExaminationReportInfo examinationReportInfo */ 1:
                    message.examinationReportInfo = ExaminationReportInfo.internalBinaryRead(reader, reader.uint32(), options, message.examinationReportInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateExaminationReportRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.examination.ExaminationReportInfo examinationReportInfo = 1; */
        if (message.examinationReportInfo)
            ExaminationReportInfo.internalBinaryWrite(message.examinationReportInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.UpdateExaminationReportRequest
 */
export const UpdateExaminationReportRequest = new UpdateExaminationReportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExaminationReportResponse$Type extends MessageType<UpdateExaminationReportResponse> {
    constructor() {
        super("base.examination.UpdateExaminationReportResponse", [
            { no: 1, name: "isUpdated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateExaminationReportResponse>): UpdateExaminationReportResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isUpdated = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateExaminationReportResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateExaminationReportResponse): UpdateExaminationReportResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isUpdated */ 1:
                    message.isUpdated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateExaminationReportResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isUpdated = 1; */
        if (message.isUpdated !== false)
            writer.tag(1, WireType.Varint).bool(message.isUpdated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.UpdateExaminationReportResponse
 */
export const UpdateExaminationReportResponse = new UpdateExaminationReportResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExaminationReportByIdRequest$Type extends MessageType<GetExaminationReportByIdRequest> {
    constructor() {
        super("base.examination.GetExaminationReportByIdRequest", [
            { no: 1, name: "examinationReportId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetExaminationReportByIdRequest>): GetExaminationReportByIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportId = "0";
        if (value !== undefined)
            reflectionMergePartial<GetExaminationReportByIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExaminationReportByIdRequest): GetExaminationReportByIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examinationReportId */ 1:
                    message.examinationReportId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExaminationReportByIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examinationReportId = 1; */
        if (message.examinationReportId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examinationReportId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExaminationReportByIdRequest
 */
export const GetExaminationReportByIdRequest = new GetExaminationReportByIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExaminationReportByIdResponse$Type extends MessageType<GetExaminationReportByIdResponse> {
    constructor() {
        super("base.examination.GetExaminationReportByIdResponse", [
            { no: 1, name: "examinationReportResult", kind: "message", T: () => ExaminationReportResult }
        ]);
    }
    create(value?: PartialMessage<GetExaminationReportByIdResponse>): GetExaminationReportByIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetExaminationReportByIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExaminationReportByIdResponse): GetExaminationReportByIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.examination.ExaminationReportResult examinationReportResult */ 1:
                    message.examinationReportResult = ExaminationReportResult.internalBinaryRead(reader, reader.uint32(), options, message.examinationReportResult);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExaminationReportByIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.examination.ExaminationReportResult examinationReportResult = 1; */
        if (message.examinationReportResult)
            ExaminationReportResult.internalBinaryWrite(message.examinationReportResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExaminationReportByIdResponse
 */
export const GetExaminationReportByIdResponse = new GetExaminationReportByIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteExaminationReportRelationshipRequest$Type extends MessageType<DeleteExaminationReportRelationshipRequest> {
    constructor() {
        super("base.examination.DeleteExaminationReportRelationshipRequest", [
            { no: 1, name: "examinationReportId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteExaminationReportRelationshipRequest>): DeleteExaminationReportRelationshipRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportId = "0";
        if (value !== undefined)
            reflectionMergePartial<DeleteExaminationReportRelationshipRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteExaminationReportRelationshipRequest): DeleteExaminationReportRelationshipRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examinationReportId */ 1:
                    message.examinationReportId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteExaminationReportRelationshipRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examinationReportId = 1; */
        if (message.examinationReportId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examinationReportId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.DeleteExaminationReportRelationshipRequest
 */
export const DeleteExaminationReportRelationshipRequest = new DeleteExaminationReportRelationshipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteExaminationReportRelationshipResponse$Type extends MessageType<DeleteExaminationReportRelationshipResponse> {
    constructor() {
        super("base.examination.DeleteExaminationReportRelationshipResponse", [
            { no: 1, name: "isDeleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteExaminationReportRelationshipResponse>): DeleteExaminationReportRelationshipResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isDeleted = false;
        if (value !== undefined)
            reflectionMergePartial<DeleteExaminationReportRelationshipResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteExaminationReportRelationshipResponse): DeleteExaminationReportRelationshipResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isDeleted */ 1:
                    message.isDeleted = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteExaminationReportRelationshipResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isDeleted = 1; */
        if (message.isDeleted !== false)
            writer.tag(1, WireType.Varint).bool(message.isDeleted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.DeleteExaminationReportRelationshipResponse
 */
export const DeleteExaminationReportRelationshipResponse = new DeleteExaminationReportRelationshipResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAllExaminationReportRelationshipRequest$Type extends MessageType<DeleteAllExaminationReportRelationshipRequest> {
    constructor() {
        super("base.examination.DeleteAllExaminationReportRelationshipRequest", [
            { no: 1, name: "examinationReportId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteAllExaminationReportRelationshipRequest>): DeleteAllExaminationReportRelationshipRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportId = "0";
        if (value !== undefined)
            reflectionMergePartial<DeleteAllExaminationReportRelationshipRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAllExaminationReportRelationshipRequest): DeleteAllExaminationReportRelationshipRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examinationReportId */ 1:
                    message.examinationReportId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAllExaminationReportRelationshipRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examinationReportId = 1; */
        if (message.examinationReportId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examinationReportId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.DeleteAllExaminationReportRelationshipRequest
 */
export const DeleteAllExaminationReportRelationshipRequest = new DeleteAllExaminationReportRelationshipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAllExaminationReportRelationshipResponse$Type extends MessageType<DeleteAllExaminationReportRelationshipResponse> {
    constructor() {
        super("base.examination.DeleteAllExaminationReportRelationshipResponse", [
            { no: 1, name: "isDeleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteAllExaminationReportRelationshipResponse>): DeleteAllExaminationReportRelationshipResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isDeleted = false;
        if (value !== undefined)
            reflectionMergePartial<DeleteAllExaminationReportRelationshipResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAllExaminationReportRelationshipResponse): DeleteAllExaminationReportRelationshipResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isDeleted */ 1:
                    message.isDeleted = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAllExaminationReportRelationshipResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isDeleted = 1; */
        if (message.isDeleted !== false)
            writer.tag(1, WireType.Varint).bool(message.isDeleted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.DeleteAllExaminationReportRelationshipResponse
 */
export const DeleteAllExaminationReportRelationshipResponse = new DeleteAllExaminationReportRelationshipResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteExaminationReportByDetailIdRequest$Type extends MessageType<DeleteExaminationReportByDetailIdRequest> {
    constructor() {
        super("base.examination.DeleteExaminationReportByDetailIdRequest", [
            { no: 1, name: "detail_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteExaminationReportByDetailIdRequest>): DeleteExaminationReportByDetailIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.detailId = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteExaminationReportByDetailIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteExaminationReportByDetailIdRequest): DeleteExaminationReportByDetailIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string detail_id */ 1:
                    message.detailId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteExaminationReportByDetailIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string detail_id = 1; */
        if (message.detailId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.detailId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.DeleteExaminationReportByDetailIdRequest
 */
export const DeleteExaminationReportByDetailIdRequest = new DeleteExaminationReportByDetailIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteExaminationReportByDetailIdResponse$Type extends MessageType<DeleteExaminationReportByDetailIdResponse> {
    constructor() {
        super("base.examination.DeleteExaminationReportByDetailIdResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteExaminationReportByDetailIdResponse>): DeleteExaminationReportByDetailIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.success = false;
        if (value !== undefined)
            reflectionMergePartial<DeleteExaminationReportByDetailIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteExaminationReportByDetailIdResponse): DeleteExaminationReportByDetailIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteExaminationReportByDetailIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.DeleteExaminationReportByDetailIdResponse
 */
export const DeleteExaminationReportByDetailIdResponse = new DeleteExaminationReportByDetailIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExamineeListByExaminerAccountIdRequest$Type extends MessageType<GetExamineeListByExaminerAccountIdRequest> {
    constructor() {
        super("base.examination.GetExamineeListByExaminerAccountIdRequest", [
            { no: 1, name: "examinerAccountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "clientList", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetExamineeListByExaminerAccountIdRequest>): GetExamineeListByExaminerAccountIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinerAccountId = "0";
        message.clientList = [];
        if (value !== undefined)
            reflectionMergePartial<GetExamineeListByExaminerAccountIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExamineeListByExaminerAccountIdRequest): GetExamineeListByExaminerAccountIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examinerAccountId */ 1:
                    message.examinerAccountId = reader.int64().toString();
                    break;
                case /* repeated string clientList */ 2:
                    message.clientList.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExamineeListByExaminerAccountIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examinerAccountId = 1; */
        if (message.examinerAccountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examinerAccountId);
        /* repeated string clientList = 2; */
        for (let i = 0; i < message.clientList.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.clientList[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExamineeListByExaminerAccountIdRequest
 */
export const GetExamineeListByExaminerAccountIdRequest = new GetExamineeListByExaminerAccountIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExamineeListByExaminerAccountIdResponse$Type extends MessageType<GetExamineeListByExaminerAccountIdResponse> {
    constructor() {
        super("base.examination.GetExamineeListByExaminerAccountIdResponse", [
            { no: 1, name: "examineeResult", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExamineeResult }
        ]);
    }
    create(value?: PartialMessage<GetExamineeListByExaminerAccountIdResponse>): GetExamineeListByExaminerAccountIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeResult = [];
        if (value !== undefined)
            reflectionMergePartial<GetExamineeListByExaminerAccountIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetExamineeListByExaminerAccountIdResponse): GetExamineeListByExaminerAccountIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ExamineeResult examineeResult */ 1:
                    message.examineeResult.push(ExamineeResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetExamineeListByExaminerAccountIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ExamineeResult examineeResult = 1; */
        for (let i = 0; i < message.examineeResult.length; i++)
            ExamineeResult.internalBinaryWrite(message.examineeResult[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.GetExamineeListByExaminerAccountIdResponse
 */
export const GetExamineeListByExaminerAccountIdResponse = new GetExamineeListByExaminerAccountIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddExaminationReportRequest$Type extends MessageType<AddExaminationReportRequest> {
    constructor() {
        super("base.examination.AddExaminationReportRequest", [
            { no: 1, name: "examinationReportId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<AddExaminationReportRequest>): AddExaminationReportRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportId = "0";
        if (value !== undefined)
            reflectionMergePartial<AddExaminationReportRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddExaminationReportRequest): AddExaminationReportRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examinationReportId */ 1:
                    message.examinationReportId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddExaminationReportRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examinationReportId = 1; */
        if (message.examinationReportId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examinationReportId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.AddExaminationReportRequest
 */
export const AddExaminationReportRequest = new AddExaminationReportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddExaminationReportResponse$Type extends MessageType<AddExaminationReportResponse> {
    constructor() {
        super("base.examination.AddExaminationReportResponse", [
            { no: 1, name: "isSucceeded", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AddExaminationReportResponse>): AddExaminationReportResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isSucceeded = false;
        if (value !== undefined)
            reflectionMergePartial<AddExaminationReportResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddExaminationReportResponse): AddExaminationReportResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isSucceeded */ 1:
                    message.isSucceeded = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddExaminationReportResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isSucceeded = 1; */
        if (message.isSucceeded !== false)
            writer.tag(1, WireType.Varint).bool(message.isSucceeded);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.AddExaminationReportResponse
 */
export const AddExaminationReportResponse = new AddExaminationReportResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ShareExaminationReportRequest$Type extends MessageType<ShareExaminationReportRequest> {
    constructor() {
        super("base.examination.ShareExaminationReportRequest", [
            { no: 1, name: "examination_report_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "examiner_account_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<ShareExaminationReportRequest>): ShareExaminationReportRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinationReportId = "0";
        message.examinerAccountId = "0";
        if (value !== undefined)
            reflectionMergePartial<ShareExaminationReportRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ShareExaminationReportRequest): ShareExaminationReportRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examination_report_id */ 1:
                    message.examinationReportId = reader.int64().toString();
                    break;
                case /* int64 examiner_account_id */ 2:
                    message.examinerAccountId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ShareExaminationReportRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examination_report_id = 1; */
        if (message.examinationReportId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examinationReportId);
        /* int64 examiner_account_id = 2; */
        if (message.examinerAccountId !== "0")
            writer.tag(2, WireType.Varint).int64(message.examinerAccountId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ShareExaminationReportRequest
 */
export const ShareExaminationReportRequest = new ShareExaminationReportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountExaminationReportByExaminersRequest$Type extends MessageType<CountExaminationReportByExaminersRequest> {
    constructor() {
        super("base.examination.CountExaminationReportByExaminersRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "examiner_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["base.examination.ExaminationReportType", ExaminationReportType] }
        ]);
    }
    create(value?: PartialMessage<CountExaminationReportByExaminersRequest>): CountExaminationReportByExaminersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        message.examinerIds = [];
        message.types = [];
        if (value !== undefined)
            reflectionMergePartial<CountExaminationReportByExaminersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountExaminationReportByExaminersRequest): CountExaminationReportByExaminersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organization_id */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* repeated int64 examiner_ids */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.examinerIds.push(reader.int64().toString());
                    else
                        message.examinerIds.push(reader.int64().toString());
                    break;
                case /* repeated base.examination.ExaminationReportType types */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.types.push(reader.int32());
                    else
                        message.types.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountExaminationReportByExaminersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organization_id = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* repeated int64 examiner_ids = 2; */
        if (message.examinerIds.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.examinerIds.length; i++)
                writer.int64(message.examinerIds[i]);
            writer.join();
        }
        /* repeated base.examination.ExaminationReportType types = 3; */
        if (message.types.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.types.length; i++)
                writer.int32(message.types[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.CountExaminationReportByExaminersRequest
 */
export const CountExaminationReportByExaminersRequest = new CountExaminationReportByExaminersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountExaminationReportByExaminersResponse$Type extends MessageType<CountExaminationReportByExaminersResponse> {
    constructor() {
        super("base.examination.CountExaminationReportByExaminersResponse", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CountExaminationReportByExaminersResponse_Result }
        ]);
    }
    create(value?: PartialMessage<CountExaminationReportByExaminersResponse>): CountExaminationReportByExaminersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        if (value !== undefined)
            reflectionMergePartial<CountExaminationReportByExaminersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountExaminationReportByExaminersResponse): CountExaminationReportByExaminersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.CountExaminationReportByExaminersResponse.Result results */ 1:
                    message.results.push(CountExaminationReportByExaminersResponse_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountExaminationReportByExaminersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.CountExaminationReportByExaminersResponse.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            CountExaminationReportByExaminersResponse_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.CountExaminationReportByExaminersResponse
 */
export const CountExaminationReportByExaminersResponse = new CountExaminationReportByExaminersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountExaminationReportByExaminersResponse_Result$Type extends MessageType<CountExaminationReportByExaminersResponse_Result> {
    constructor() {
        super("base.examination.CountExaminationReportByExaminersResponse.Result", [
            { no: 1, name: "examiner_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<CountExaminationReportByExaminersResponse_Result>): CountExaminationReportByExaminersResponse_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examinerId = "0";
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<CountExaminationReportByExaminersResponse_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountExaminationReportByExaminersResponse_Result): CountExaminationReportByExaminersResponse_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examiner_id */ 1:
                    message.examinerId = reader.int64().toString();
                    break;
                case /* int32 count */ 2:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountExaminationReportByExaminersResponse_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examiner_id = 1; */
        if (message.examinerId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examinerId);
        /* int32 count = 2; */
        if (message.count !== 0)
            writer.tag(2, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.CountExaminationReportByExaminersResponse.Result
 */
export const CountExaminationReportByExaminersResponse_Result = new CountExaminationReportByExaminersResponse_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountExaminationReportByExamineesRequest$Type extends MessageType<CountExaminationReportByExamineesRequest> {
    constructor() {
        super("base.examination.CountExaminationReportByExamineesRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "examinee_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["base.examination.ExaminationReportType", ExaminationReportType] }
        ]);
    }
    create(value?: PartialMessage<CountExaminationReportByExamineesRequest>): CountExaminationReportByExamineesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        message.examineeIds = [];
        message.types = [];
        if (value !== undefined)
            reflectionMergePartial<CountExaminationReportByExamineesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountExaminationReportByExamineesRequest): CountExaminationReportByExamineesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organization_id */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* repeated int64 examinee_ids */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.examineeIds.push(reader.int64().toString());
                    else
                        message.examineeIds.push(reader.int64().toString());
                    break;
                case /* repeated base.examination.ExaminationReportType types */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.types.push(reader.int32());
                    else
                        message.types.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountExaminationReportByExamineesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organization_id = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* repeated int64 examinee_ids = 2; */
        if (message.examineeIds.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.examineeIds.length; i++)
                writer.int64(message.examineeIds[i]);
            writer.join();
        }
        /* repeated base.examination.ExaminationReportType types = 3; */
        if (message.types.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.types.length; i++)
                writer.int32(message.types[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.CountExaminationReportByExamineesRequest
 */
export const CountExaminationReportByExamineesRequest = new CountExaminationReportByExamineesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountExaminationReportByExamineesResponse$Type extends MessageType<CountExaminationReportByExamineesResponse> {
    constructor() {
        super("base.examination.CountExaminationReportByExamineesResponse", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CountExaminationReportByExamineesResponse_Result }
        ]);
    }
    create(value?: PartialMessage<CountExaminationReportByExamineesResponse>): CountExaminationReportByExamineesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        if (value !== undefined)
            reflectionMergePartial<CountExaminationReportByExamineesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountExaminationReportByExamineesResponse): CountExaminationReportByExamineesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.CountExaminationReportByExamineesResponse.Result results */ 1:
                    message.results.push(CountExaminationReportByExamineesResponse_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountExaminationReportByExamineesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.CountExaminationReportByExamineesResponse.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            CountExaminationReportByExamineesResponse_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.CountExaminationReportByExamineesResponse
 */
export const CountExaminationReportByExamineesResponse = new CountExaminationReportByExamineesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountExaminationReportByExamineesResponse_Result$Type extends MessageType<CountExaminationReportByExamineesResponse_Result> {
    constructor() {
        super("base.examination.CountExaminationReportByExamineesResponse.Result", [
            { no: 1, name: "examinee_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<CountExaminationReportByExamineesResponse_Result>): CountExaminationReportByExamineesResponse_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.examineeId = "0";
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<CountExaminationReportByExamineesResponse_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountExaminationReportByExamineesResponse_Result): CountExaminationReportByExamineesResponse_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 examinee_id */ 1:
                    message.examineeId = reader.int64().toString();
                    break;
                case /* int32 count */ 2:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountExaminationReportByExamineesResponse_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 examinee_id = 1; */
        if (message.examineeId !== "0")
            writer.tag(1, WireType.Varint).int64(message.examineeId);
        /* int32 count = 2; */
        if (message.count !== 0)
            writer.tag(2, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.CountExaminationReportByExamineesResponse.Result
 */
export const CountExaminationReportByExamineesResponse_Result = new CountExaminationReportByExamineesResponse_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExaminationReportsRequest$Type extends MessageType<ListExaminationReportsRequest> {
    constructor() {
        super("base.examination.ListExaminationReportsRequest", [
            { no: 1, name: "page_num", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "organization_id", kind: "message", T: () => Int64Value },
            { no: 5, name: "examinee_id", kind: "message", T: () => Int64Value },
            { no: 6, name: "report_type", kind: "enum", opt: true, T: () => ["base.examination.ExaminationReportType", ExaminationReportType] },
            { no: 7, name: "examiner_account_id", kind: "message", T: () => Int64Value },
            { no: 8, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 9, name: "end_time", kind: "message", T: () => Timestamp },
            { no: 10, name: "self_examine", kind: "message", T: () => BoolValue }
        ]);
    }
    create(value?: PartialMessage<ListExaminationReportsRequest>): ListExaminationReportsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<ListExaminationReportsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExaminationReportsRequest): ListExaminationReportsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_num */ 1:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* google.protobuf.Int64Value organization_id */ 4:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.Int64Value examinee_id */ 5:
                    message.examineeId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examineeId);
                    break;
                case /* optional base.examination.ExaminationReportType report_type */ 6:
                    message.reportType = reader.int32();
                    break;
                case /* google.protobuf.Int64Value examiner_account_id */ 7:
                    message.examinerAccountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.examinerAccountId);
                    break;
                case /* google.protobuf.Timestamp start_time */ 8:
                    message.startTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startTime);
                    break;
                case /* google.protobuf.Timestamp end_time */ 9:
                    message.endTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.endTime);
                    break;
                case /* google.protobuf.BoolValue self_examine */ 10:
                    message.selfExamine = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.selfExamine);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExaminationReportsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_num = 1; */
        if (message.pageNum !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageNum);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* google.protobuf.Int64Value organization_id = 4; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value examinee_id = 5; */
        if (message.examineeId)
            Int64Value.internalBinaryWrite(message.examineeId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* optional base.examination.ExaminationReportType report_type = 6; */
        if (message.reportType !== undefined)
            writer.tag(6, WireType.Varint).int32(message.reportType);
        /* google.protobuf.Int64Value examiner_account_id = 7; */
        if (message.examinerAccountId)
            Int64Value.internalBinaryWrite(message.examinerAccountId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp start_time = 8; */
        if (message.startTime)
            Timestamp.internalBinaryWrite(message.startTime, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp end_time = 9; */
        if (message.endTime)
            Timestamp.internalBinaryWrite(message.endTime, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.BoolValue self_examine = 10; */
        if (message.selfExamine)
            BoolValue.internalBinaryWrite(message.selfExamine, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ListExaminationReportsRequest
 */
export const ListExaminationReportsRequest = new ListExaminationReportsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExaminationReportsResponse$Type extends MessageType<ListExaminationReportsResponse> {
    constructor() {
        super("base.examination.ListExaminationReportsResponse", [
            { no: 1, name: "reports", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExaminationReportResult },
            { no: 2, name: "total_elements", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "total_pages", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "is_first", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "is_last", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "page_elements", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "page_num", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ListExaminationReportsResponse>): ListExaminationReportsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.reports = [];
        message.totalElements = "0";
        message.totalPages = 0;
        message.isFirst = false;
        message.isLast = false;
        message.pageElements = 0;
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<ListExaminationReportsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExaminationReportsResponse): ListExaminationReportsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ExaminationReportResult reports */ 1:
                    message.reports.push(ExaminationReportResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 total_elements */ 2:
                    message.totalElements = reader.int64().toString();
                    break;
                case /* int32 total_pages */ 3:
                    message.totalPages = reader.int32();
                    break;
                case /* bool is_first */ 4:
                    message.isFirst = reader.bool();
                    break;
                case /* bool is_last */ 5:
                    message.isLast = reader.bool();
                    break;
                case /* int32 page_elements */ 6:
                    message.pageElements = reader.int32();
                    break;
                case /* int32 page_num */ 7:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 page_size */ 8:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExaminationReportsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ExaminationReportResult reports = 1; */
        for (let i = 0; i < message.reports.length; i++)
            ExaminationReportResult.internalBinaryWrite(message.reports[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 total_elements = 2; */
        if (message.totalElements !== "0")
            writer.tag(2, WireType.Varint).int64(message.totalElements);
        /* int32 total_pages = 3; */
        if (message.totalPages !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalPages);
        /* bool is_first = 4; */
        if (message.isFirst !== false)
            writer.tag(4, WireType.Varint).bool(message.isFirst);
        /* bool is_last = 5; */
        if (message.isLast !== false)
            writer.tag(5, WireType.Varint).bool(message.isLast);
        /* int32 page_elements = 6; */
        if (message.pageElements !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageElements);
        /* int32 page_num = 7; */
        if (message.pageNum !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageNum);
        /* int32 page_size = 8; */
        if (message.pageSize !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ListExaminationReportsResponse
 */
export const ListExaminationReportsResponse = new ListExaminationReportsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExaminationReportHeadersRequest$Type extends MessageType<ListExaminationReportHeadersRequest> {
    constructor() {
        super("base.examination.ListExaminationReportHeadersRequest", [
            { no: 1, name: "page_num", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "examine_type", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<ListExaminationReportHeadersRequest>): ListExaminationReportHeadersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<ListExaminationReportHeadersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExaminationReportHeadersRequest): ListExaminationReportHeadersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_num */ 1:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* google.protobuf.StringValue examine_type */ 5:
                    message.examineType = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.examineType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExaminationReportHeadersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_num = 1; */
        if (message.pageNum !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageNum);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* google.protobuf.StringValue examine_type = 5; */
        if (message.examineType)
            StringValue.internalBinaryWrite(message.examineType, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ListExaminationReportHeadersRequest
 */
export const ListExaminationReportHeadersRequest = new ListExaminationReportHeadersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExaminationReportHeadersResponse$Type extends MessageType<ListExaminationReportHeadersResponse> {
    constructor() {
        super("base.examination.ListExaminationReportHeadersResponse", [
            { no: 1, name: "report_headers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ListExaminationReportHeadersResponse_ReportHeader },
            { no: 2, name: "total_elements", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "total_pages", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "is_first", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "is_last", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "page_elements", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "page_num", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ListExaminationReportHeadersResponse>): ListExaminationReportHeadersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.reportHeaders = [];
        message.totalElements = "0";
        message.totalPages = 0;
        message.isFirst = false;
        message.isLast = false;
        message.pageElements = 0;
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<ListExaminationReportHeadersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExaminationReportHeadersResponse): ListExaminationReportHeadersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.examination.ListExaminationReportHeadersResponse.ReportHeader report_headers */ 1:
                    message.reportHeaders.push(ListExaminationReportHeadersResponse_ReportHeader.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 total_elements */ 2:
                    message.totalElements = reader.int64().toString();
                    break;
                case /* int32 total_pages */ 3:
                    message.totalPages = reader.int32();
                    break;
                case /* bool is_first */ 4:
                    message.isFirst = reader.bool();
                    break;
                case /* bool is_last */ 5:
                    message.isLast = reader.bool();
                    break;
                case /* int32 page_elements */ 6:
                    message.pageElements = reader.int32();
                    break;
                case /* int32 page_num */ 7:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 page_size */ 8:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExaminationReportHeadersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.examination.ListExaminationReportHeadersResponse.ReportHeader report_headers = 1; */
        for (let i = 0; i < message.reportHeaders.length; i++)
            ListExaminationReportHeadersResponse_ReportHeader.internalBinaryWrite(message.reportHeaders[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 total_elements = 2; */
        if (message.totalElements !== "0")
            writer.tag(2, WireType.Varint).int64(message.totalElements);
        /* int32 total_pages = 3; */
        if (message.totalPages !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalPages);
        /* bool is_first = 4; */
        if (message.isFirst !== false)
            writer.tag(4, WireType.Varint).bool(message.isFirst);
        /* bool is_last = 5; */
        if (message.isLast !== false)
            writer.tag(5, WireType.Varint).bool(message.isLast);
        /* int32 page_elements = 6; */
        if (message.pageElements !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageElements);
        /* int32 page_num = 7; */
        if (message.pageNum !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageNum);
        /* int32 page_size = 8; */
        if (message.pageSize !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ListExaminationReportHeadersResponse
 */
export const ListExaminationReportHeadersResponse = new ListExaminationReportHeadersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExaminationReportHeadersResponse_ReportHeader$Type extends MessageType<ListExaminationReportHeadersResponse_ReportHeader> {
    constructor() {
        super("base.examination.ListExaminationReportHeadersResponse.ReportHeader", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "create_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "examine_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "examinee", kind: "message", T: () => ListExaminationReportHeadersResponse_Examinee }
        ]);
    }
    create(value?: PartialMessage<ListExaminationReportHeadersResponse_ReportHeader>): ListExaminationReportHeadersResponse_ReportHeader {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uuid = "";
        message.examineType = "";
        if (value !== undefined)
            reflectionMergePartial<ListExaminationReportHeadersResponse_ReportHeader>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExaminationReportHeadersResponse_ReportHeader): ListExaminationReportHeadersResponse_ReportHeader {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string uuid */ 1:
                    message.uuid = reader.string();
                    break;
                case /* google.protobuf.Timestamp create_time */ 2:
                    message.createTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createTime);
                    break;
                case /* string examine_type */ 3:
                    message.examineType = reader.string();
                    break;
                case /* base.examination.ListExaminationReportHeadersResponse.Examinee examinee */ 4:
                    message.examinee = ListExaminationReportHeadersResponse_Examinee.internalBinaryRead(reader, reader.uint32(), options, message.examinee);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExaminationReportHeadersResponse_ReportHeader, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string uuid = 1; */
        if (message.uuid !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.uuid);
        /* google.protobuf.Timestamp create_time = 2; */
        if (message.createTime)
            Timestamp.internalBinaryWrite(message.createTime, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string examine_type = 3; */
        if (message.examineType !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.examineType);
        /* base.examination.ListExaminationReportHeadersResponse.Examinee examinee = 4; */
        if (message.examinee)
            ListExaminationReportHeadersResponse_Examinee.internalBinaryWrite(message.examinee, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ListExaminationReportHeadersResponse.ReportHeader
 */
export const ListExaminationReportHeadersResponse_ReportHeader = new ListExaminationReportHeadersResponse_ReportHeader$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExaminationReportHeadersResponse_Examinee$Type extends MessageType<ListExaminationReportHeadersResponse_Examinee> {
    constructor() {
        super("base.examination.ListExaminationReportHeadersResponse.Examinee", [
            { no: 1, name: "name", kind: "message", T: () => StringValue },
            { no: 2, name: "gender", kind: "message", T: () => StringValue },
            { no: 3, name: "age", kind: "message", T: () => Int32Value },
            { no: 4, name: "height", kind: "message", T: () => Int32Value },
            { no: 5, name: "weight", kind: "message", T: () => Int32Value },
            { no: 6, name: "description", kind: "message", T: () => StringValue },
            { no: 10, name: "phone_number", kind: "message", T: () => StringValue },
            { no: 11, name: "id_number", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<ListExaminationReportHeadersResponse_Examinee>): ListExaminationReportHeadersResponse_Examinee {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListExaminationReportHeadersResponse_Examinee>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExaminationReportHeadersResponse_Examinee): ListExaminationReportHeadersResponse_Examinee {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.StringValue name */ 1:
                    message.name = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                case /* google.protobuf.StringValue gender */ 2:
                    message.gender = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.gender);
                    break;
                case /* google.protobuf.Int32Value age */ 3:
                    message.age = Int32Value.internalBinaryRead(reader, reader.uint32(), options, message.age);
                    break;
                case /* google.protobuf.Int32Value height */ 4:
                    message.height = Int32Value.internalBinaryRead(reader, reader.uint32(), options, message.height);
                    break;
                case /* google.protobuf.Int32Value weight */ 5:
                    message.weight = Int32Value.internalBinaryRead(reader, reader.uint32(), options, message.weight);
                    break;
                case /* google.protobuf.StringValue description */ 6:
                    message.description = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.description);
                    break;
                case /* google.protobuf.StringValue phone_number */ 10:
                    message.phoneNumber = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.phoneNumber);
                    break;
                case /* google.protobuf.StringValue id_number */ 11:
                    message.idNumber = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.idNumber);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExaminationReportHeadersResponse_Examinee, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.StringValue name = 1; */
        if (message.name)
            StringValue.internalBinaryWrite(message.name, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue gender = 2; */
        if (message.gender)
            StringValue.internalBinaryWrite(message.gender, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int32Value age = 3; */
        if (message.age)
            Int32Value.internalBinaryWrite(message.age, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int32Value height = 4; */
        if (message.height)
            Int32Value.internalBinaryWrite(message.height, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int32Value weight = 5; */
        if (message.weight)
            Int32Value.internalBinaryWrite(message.weight, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue description = 6; */
        if (message.description)
            StringValue.internalBinaryWrite(message.description, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue phone_number = 10; */
        if (message.phoneNumber)
            StringValue.internalBinaryWrite(message.phoneNumber, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue id_number = 11; */
        if (message.idNumber)
            StringValue.internalBinaryWrite(message.idNumber, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.examination.ListExaminationReportHeadersResponse.Examinee
 */
export const ListExaminationReportHeadersResponse_Examinee = new ListExaminationReportHeadersResponse_Examinee$Type();
/**
 * @generated ServiceType for protobuf service base.examination.ExaminationService
 */
export const ExaminationService = new ServiceType("base.examination.ExaminationService", [
    { name: "AddExamineeByAccountId", options: { "google.api.http": { post: "/base.examination.ExaminationService/AddExamineeByAccountId", body: "*" } }, I: AddExamineeByAccountIdRequest, O: AddExamineeByAccountIdResponse },
    { name: "AddExaminee", options: { "google.api.http": { post: "/base.examination.ExaminationService/AddExaminee", body: "*" } }, I: AddExamineeRequest, O: AddExamineeResponse },
    { name: "AddExamineeMyself", options: { "google.api.http": { post: "/base.examination.ExaminationService/AddExamineeMyself", body: "*" } }, I: AddExamineeMyselfRequest, O: AddExamineeMyselfResponse },
    { name: "CreateExaminee", options: { "google.api.http": { post: "/base.examination.ExaminationService/CreateExaminee", body: "*" } }, I: CreateExamineeRequest, O: CreateExamineeResponse },
    { name: "BatchCreateExaminees", options: { "google.api.http": { post: "/base.examination.ExaminationService/BatchCreateExaminees", body: "*" } }, I: BatchCreateExamineesRequest, O: BatchCreateExamineesResponse },
    { name: "GetPresignedPutObjectUrl", options: { "google.api.http": { get: "/base.examination.ExaminationService/GetPresignedPutObjectUrl", body: "*" } }, I: GetPresignedPutObjectUrlRequest, O: GetPresignedPutObjectUrlResponse },
    { name: "BatchCreateExamineesWithExcel", options: { "google.api.http": { post: "/base.examination.ExaminationService/BatchCreateExamineesWithExcel", body: "*" } }, I: BatchCreateExamineesWithExcelRequest, O: BatchCreateExamineesWithExcelResponse },
    { name: "GetBatchCreateExamineesExcelTemplate", options: { "google.api.http": { get: "/base.examination.ExaminationService/GetBatchCreateExamineesExcelTemplate", body: "*" } }, I: Empty, O: GetBatchCreateExamineesExcelTemplateResponse },
    { name: "BindExamineeToExaminer", options: { "google.api.http": { post: "/base.examination.ExaminationService/BindExamineeToExaminer", body: "*" } }, I: BindExamineeToExaminerRequest, O: Empty },
    { name: "UnbindExamineeFromExaminer", options: { "google.api.http": { post: "/base.examination.ExaminationService/UnbindExamineeFromExaminer", body: "*" } }, I: UnbindExamineeFromExaminerRequest, O: Empty },
    { name: "ExportExamineesList", options: { "google.api.http": { post: "/base.examination.ExaminationService/ExportExamineesList", body: "*" } }, I: ExportExamineesListRequest, O: ExportExamineesListResponse },
    { name: "GetExamineeIdEncryptAlphabet", options: {}, I: Empty, O: GetExamineeIdEncryptAlphabetResponse },
    { name: "DecodeExamineeIdCode", options: { "google.api.http": { get: "/base.examination.ExaminationService/DecodeExamineeIdCode" } }, I: DecodeExamineeIdCodeRequest, O: DecodeExamineeIdCodeResponse },
    { name: "GetMyExamineeList", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetMyExamineeList", body: "*" } }, I: GetMyExamineeListRequest, O: GetMyExamineeListResponse },
    { name: "GetExamineeListByOrganizationId", options: { "google.api.http": { get: "/base.examination.ExaminationService/GetExamineeListByOrganizationId", body: "*" } }, I: GetExamineeListByOrganizationIdRequest, O: GetExamineeListByOrganizationIdResponse },
    { name: "AddExamineeToExaminationRelationship", options: { "google.api.http": { post: "/base.examination.ExaminationService/AddExamineeToExaminationRelationship", body: "*" } }, I: AddExamineeToExaminationRelationshipRequest, O: AddExamineeToExaminationRelationshipResponse },
    { name: "ShareExamineeByAccessToken", options: { "google.api.http": { post: "/base.examination.ExaminationService/ShareExamineeByAccessToken", body: "*" } }, I: ShareExamineeRequest, O: ShareExamineeResponse },
    { name: "DeleteExaminationRelationship", options: { "google.api.http": { post: "/base.examination.ExaminationService/DeleteExaminationRelationship", body: "*" } }, I: DeleteExaminationRelationshipRequest, O: DeleteExaminationRelationshipResponse },
    { name: "DeleteExaminationRelationshipByAccountId", options: { "google.api.http": { post: "/base.examination.ExaminationService/DeleteExaminationRelationshipByAccountId", body: "*" } }, I: DeleteExaminationRelationshipByAccountIdRequest, O: DeleteExaminationRelationshipByAccountIdResponse },
    { name: "BatchDeleteExaminationRelationshipByOrganization", options: { "google.api.http": { post: "/base.examination.ExaminationService/BatchDeleteExaminationRelationshipByOrganization", body: "*" } }, I: BatchDeleteExaminationRelationshipByOrganizationRequest, O: BatchDeleteExaminationRelationshipByOrganizationResponse },
    { name: "BatchDeleteExaminationRelationshipByExaminerAccountId", options: { "google.api.http": { post: "/base.examination.ExaminationService/BatchDeleteExaminationRelationshipByExaminerAccountId", body: "*" } }, I: BatchDeleteExaminationRelationshipByExaminerAccountIdRequest, O: BatchDeleteExaminationRelationshipByExaminerAccountIdResponse },
    { name: "SetAccountIdForExaminee", options: { "google.api.http": { post: "/base.examination.ExaminationService/SetAccountIdForExaminee", body: "*" } }, I: SetAccountIdForExamineeRequest, O: SetAccountIdForExamineeResponse },
    { name: "SetExamineeAccountId", options: { "google.api.http": { post: "/base.examination.ExaminationService/SetExamineeAccountId", body: "*" } }, I: SetExamineeAccountIdRequest, O: Empty },
    { name: "UpdateExaminee", options: { "google.api.http": { post: "/base.examination.ExaminationService/UpdateExaminee", body: "*" } }, I: UpdateExamineeRequest, O: UpdateExamineeResponse },
    { name: "GetExamineeById", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetExamineeById", body: "*" } }, I: GetExamineeByIdRequest, O: GetExamineeByIdResponse },
    { name: "GetExamineeByAccountId", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetExamineeByAccountId", body: "*" } }, I: GetExamineeByAccountIdRequest, O: GetExamineeByAccountIdResponse },
    { name: "GetMyExaminee", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetMyExaminee", body: "*" } }, I: GetMyExamineeRequest, O: GetMyExamineeResponse },
    { name: "GetExamineeListByExaminerAccountId", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetExamineeListByExaminerAccountId", body: "*" } }, I: GetExamineeListByExaminerAccountIdRequest, O: GetExamineeListByExaminerAccountIdResponse },
    { name: "GetExamineesExaminationReportList", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetExamineesExaminationReportList", body: "*" } }, I: GetExamineesExaminationReportListRequest, O: GetExamineesExaminationReportListResponse },
    { name: "CreateExaminer", options: { "google.api.http": { post: "/base.examination.ExaminationService/CreateExaminer", body: "*" } }, I: CreateExaminerRequest, O: CreateExaminerResponse },
    { name: "CreateExaminerByAccountId", options: { "google.api.http": { post: "/base.examination.ExaminationService/CreateExaminerByAccountId", body: "*" } }, I: CreateExaminerByAccountIdRequest, O: CreateExaminerByAccountIdResponse },
    { name: "GetExaminerByAccountId", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetExaminerByAccountId", body: "*" } }, I: GetExaminerByAccountIdRequest, O: GetExaminerByAccountIdResponse },
    { name: "GetMyAllExaminers", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetMyAllExaminers", body: "*" } }, I: GetMyAllExaminersRequest, O: GetMyAllExaminersResponse },
    { name: "GetExaminationRelationshipByAccessToken", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetExaminationRelationshipByAccessToken", body: "*" } }, I: GetExaminationRelationshipByAccessTokenRequest, O: GetExaminationRelationshipByAccessTokenResponse },
    { name: "ListExaminers", options: { "google.api.http": { post: "/base.examination.ExaminationService/ListExaminers", body: "*" } }, I: ListExaminersRequest, O: ListExaminersResponse },
    { name: "UpdateExaminationRelationshipById", options: { "google.api.http": { post: "/base.examination.ExaminationService/UpdateExaminationRelationshipById", body: "*" } }, I: UpdateExaminationRelationshipByIdRequest, O: UpdateExaminationRelationshipByIdResponse },
    { name: "GetExamineeListByIds", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetExamineeListByIds", body: "*" } }, I: GetExamineeListByIdsRequest, O: GetExamineeListByIdsResponse },
    { name: "ListExamineeListByExamineeAccountIds", options: { "google.api.http": { post: "/base.examination.ExaminationService/ListExamineeListByExamineeAccountIds", body: "*" } }, I: ListExamineeListByExamineeAccountIdsRequest, O: ListExamineeListByExamineeAccountIdsResponse },
    { name: "ListExaminee", options: { "google.api.http": { post: "/base.examination.ExaminationService/ListExaminee", body: "*" } }, I: ListExamineeRequest, O: ListExamineeResponse },
    { name: "CountExamineeByExaminers", options: { "google.api.http": { post: "/base.examination.ExaminationService/CountExamineeByExaminers", body: "*" } }, I: CountExamineeByExaminersRequest, O: CountExamineeByExaminersResponse },
    { name: "PageListExaminee", options: { "google.api.http": { post: "/base.examination.ExaminationService/PageListExaminee", body: "*" } }, I: PageListExamineeRequest, O: PageListExamineeResponse },
    { name: "ListSymptoms", options: { "google.api.http": { post: "/base.examination.ExaminationService/ListSymptoms", body: "*" } }, I: ListSymptomsRequest, O: ListSymptomsResponse },
    { name: "DeleteSymptoms", options: { "google.api.http": { post: "/base.examination.ExaminationService/DeleteSymptoms", body: "*" } }, I: DeleteSymptomsRequest, O: Empty },
    { name: "CreateExaminationReport", options: { "google.api.http": { post: "/base.examination.ExaminationService/CreateExaminationReport", body: "*" } }, I: CreateExaminationReportRequest, O: CreateExaminationReportResponse },
    { name: "UpdateExaminationReport", options: { "google.api.http": { post: "/base.examination.ExaminationService/UpdateExaminationReport", body: "*" } }, I: UpdateExaminationReportRequest, O: UpdateExaminationReportResponse },
    { name: "GetMyExaminationReportList", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetMyExaminationReportList", body: "*" } }, I: GetMyExaminationReportListRequest, O: GetMyExaminationReportListResponse },
    { name: "GetExaminationReportById", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetExaminationReportById", body: "*" } }, I: GetExaminationReportByIdRequest, O: GetExaminationReportByIdResponse },
    { name: "AddExaminationReport", options: { "google.api.http": { post: "/base.examination.ExaminationService/AddExaminationReport", body: "*" } }, I: AddExaminationReportRequest, O: AddExaminationReportResponse },
    { name: "ShareExaminationReport", options: { "google.api.http": { post: "/base.examination.ExaminationService/ShareExaminationReport", body: "*" } }, I: ShareExaminationReportRequest, O: Empty },
    { name: "DeleteExaminationReportRelationship", options: { "google.api.http": { post: "/base.examination.ExaminationService/DeleteExaminationReportRelationship", body: "*" } }, I: DeleteExaminationReportRelationshipRequest, O: DeleteExaminationReportRelationshipResponse },
    { name: "DeleteAllExaminationReportRelationship", options: { "google.api.http": { post: "/base.examination.ExaminationService/DeleteAllExaminationReportRelationship", body: "*" } }, I: DeleteAllExaminationReportRelationshipRequest, O: DeleteAllExaminationReportRelationshipResponse },
    { name: "DeleteExaminationReportByDetailId", options: { "google.api.http": { post: "/base.examination.ExaminationService/DeleteExaminationReportByDetailId", body: "*" } }, I: DeleteExaminationReportByDetailIdRequest, O: DeleteExaminationReportByDetailIdResponse },
    { name: "GetExamineesExaminationReportListByReportType", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetExamineesExaminationReportListByReportType", body: "*" } }, I: GetExamineesExaminationReportListByReportTypeRequest, O: GetExamineesExaminationReportListByReportTypeResponse },
    { name: "GetExaminationReportPageByAccountId", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetExaminationReportPageByAccountId", body: "*" } }, I: GetExaminationReportPageByAccountIdRequest, O: GetExaminationReportPageByAccountIdResponse },
    { name: "GetExaminationReportPageByAccountIdAndType", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetExaminationReportPageByAccountIdAndType", body: "*" } }, I: GetExaminationReportPageByAccountIdAndTypeRequest, O: GetExaminationReportPageByAccountIdAndTypeResponse },
    { name: "GetExaminationReportPageByExamineeId", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetExaminationReportPageByExamineeId", body: "*" } }, I: GetExaminationReportPageByExamineeIdRequest, O: GetExaminationReportPageByExamineeIdResponse },
    { name: "GetExaminationReportPageByExamineeIdAndType", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetExaminationReportPageByExamineeIdAndType", body: "*" } }, I: GetExaminationReportPageByExamineeIdAndTypeRequest, O: GetExaminationReportPageByExamineeIdAndTypeResponse },
    { name: "GetExaminationReportPageByAccessTokenAndType", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetExaminationReportPageByAccessTokenAndType", body: "*" } }, I: GetExaminationReportPageByAccessTokenAndTypeRequest, O: GetExaminationReportPageByAccessTokenAndTypeResponse },
    { name: "UpdateExaminationReportByExamineeReportDetailId", options: { "google.api.http": { post: "/base.examination.ExaminationService/UpdateExaminationReportByExamineeReportDetailId", body: "*" } }, I: UpdateExaminationReportByExamineeReportDetailIdRequest, O: UpdateExaminationReportByExamineeReportDetailIdResponse },
    { name: "GetExaminationReportByExamineeReportDetailId", options: { "google.api.http": { post: "/base.examination.ExaminationService/GetExaminationReportByExamineeReportDetailId", body: "*" } }, I: GetExaminationReportByExamineeReportDetailIdRequest, O: GetExaminationReportByExamineeReportDetailIdResponse },
    { name: "BatchGetExaminationReportsByDetailId", options: { "google.api.http": { post: "/base.examination.ExaminationService/BatchGetExaminationReportsByDetailId", body: "*" } }, I: BatchGetExaminationReportsByDetailIdRequest, O: BatchGetExaminationReportsByDetailIdResponse },
    { name: "ListExaminationReportByOrganizationIdAndType", options: { "google.api.http": { post: "/base.examination.ExaminationService/ListExaminationReportByOrganizationIdAndType", body: "*" } }, I: ListExaminationReportByOrganizationIdAndTypeRequest, O: ListExaminationReportByOrganizationIdAndTypeResponse },
    { name: "CountExaminationReportByExaminers", options: { "google.api.http": { post: "/base.examination.ExaminationService/CountExaminationReportByExaminers", body: "*" } }, I: CountExaminationReportByExaminersRequest, O: CountExaminationReportByExaminersResponse },
    { name: "CountExaminationReportByExaminees", options: { "google.api.http": { post: "/base.examination.ExaminationService/CountExaminationReportByExaminees", body: "*" } }, I: CountExaminationReportByExamineesRequest, O: CountExaminationReportByExamineesResponse },
    { name: "ListExaminationReports", options: { "google.api.http": { post: "/base.examination.ExaminationService/ListExaminationReports", body: "*" } }, I: ListExaminationReportsRequest, O: ListExaminationReportsResponse },
    { name: "ListExaminationReportHeaders", options: { "google.api.http": { post: "/base.examination.ExaminationService/ListExaminationReportHeaders", body: "*" } }, I: ListExaminationReportHeadersRequest, O: ListExaminationReportHeadersResponse }
]);
